(window["webpackJsonp"] = window["webpackJsonp"] || []).push([["main"],{

/***/ "./$$_lazy_route_resource lazy recursive":
/*!******************************************************!*\
  !*** ./$$_lazy_route_resource lazy namespace object ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"../app/screen/asignacion-segmentos/asignacion-segmentos.module": [
		"./src/app/screen/asignacion-segmentos/asignacion-segmentos.module.ts",
		"app-screen-asignacion-segmentos-asignacion-segmentos-module"
	],
	"../app/screen/corte-diario/corte-diario.module": [
		"./src/app/screen/corte-diario/corte-diario.module.ts",
		"app-screen-corte-diario-corte-diario-module"
	],
	"../app/screen/gestiones/gestiones.module": [
		"./src/app/screen/gestiones/gestiones.module.ts",
		"default~app-screen-gestiones-gestiones-module~app-screen-revision-ingreso-revision-ingreso-module",
		"app-screen-gestiones-gestiones-module"
	],
	"../app/screen/inventarios/inventarios.module": [
		"./src/app/screen/inventarios/inventarios.module.ts",
		"app-screen-inventarios-inventarios-module"
	],
	"../app/screen/migo-sap/migo-sap.module": [
		"./src/app/screen/migo-sap/migo-sap.module.ts",
		"default~app-screen-migo-sap-migo-sap-module~app-screen-miro-sap-miro-sap-module~app-screen-traslados~ae72f09e",
		"app-screen-migo-sap-migo-sap-module"
	],
	"../app/screen/miro-sap/miro-sap.module": [
		"./src/app/screen/miro-sap/miro-sap.module.ts",
		"default~app-screen-migo-sap-migo-sap-module~app-screen-miro-sap-miro-sap-module~app-screen-traslados~ae72f09e",
		"app-screen-miro-sap-miro-sap-module"
	],
	"../app/screen/picking/picking.module": [
		"./src/app/screen/picking/picking.module.ts",
		"app-screen-picking-picking-module"
	],
	"../app/screen/registro-migo/registro-migo.module": [
		"./src/app/screen/registro-migo/registro-migo.module.ts",
		"app-screen-registro-migo-registro-migo-module"
	],
	"../app/screen/reporte-tracking-facturas-nacionales/reporte-tracking-facturas-nacionales.module": [
		"./src/app/screen/reporte-tracking-facturas-nacionales/reporte-tracking-facturas-nacionales.module.ts",
		"app-screen-reporte-tracking-facturas-nacionales-reporte-tracking-facturas-nacionales-module"
	],
	"../app/screen/requisas/requisas.module": [
		"./src/app/screen/requisas/requisas.module.ts"
	],
	"../app/screen/revision-ajuste/revision-ajuste.module": [
		"./src/app/screen/revision-ajuste/revision-ajuste.module.ts",
		"app-screen-revision-ajuste-revision-ajuste-module"
	],
	"../app/screen/revision-ingreso/revision-ingreso.module": [
		"./src/app/screen/revision-ingreso/revision-ingreso.module.ts",
		"default~app-screen-gestiones-gestiones-module~app-screen-revision-ingreso-revision-ingreso-module",
		"app-screen-revision-ingreso-revision-ingreso-module"
	],
	"../app/screen/solicitudmateria-prima/solicitudmateria-prima.module": [
		"./src/app/screen/solicitudmateria-prima/solicitudmateria-prima.module.ts",
		"app-screen-solicitudmateria-prima-solicitudmateria-prima-module"
	],
	"../app/screen/traslados-sap/traslados-sap.module": [
		"./src/app/screen/traslados-sap/traslados-sap.module.ts",
		"default~app-screen-migo-sap-migo-sap-module~app-screen-miro-sap-miro-sap-module~app-screen-traslados~ae72f09e",
		"app-screen-traslados-sap-traslados-sap-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;

/***/ }),

/***/ "./dist-library/fileshare/fesm2015/fileshare.js":
/*!******************************************************!*\
  !*** ./dist-library/fileshare/fesm2015/fileshare.js ***!
  \******************************************************/
/*! exports provided: DataRequest, DocumentoBlob, DocumentoBto, DocumentoRequestVm, DocumentoResponseVm, EstadoReponseFileShare, FileshareComponent, FileshareModule, FileshareMultipleComponent, FileshareService, FolderBto, FolderFileBto, FolderFileUpdateIdentificadorVm, FolderFileVmGroup, InitApi, InitWeb, Params, ResponseFileShare, ResponseFileShareHojasRutas, ResponseFileShareVm, RespuestaDataRequest, TramiteInfo, UploadMultiple, ViewFileshareCompareComponent, ViewFileshareComponent, ViewFileshareContentComponent, ɵa, ɵb */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DataRequest", function() { return DataRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DocumentoBlob", function() { return DocumentoBlob; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DocumentoBto", function() { return DocumentoBto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DocumentoRequestVm", function() { return DocumentoRequestVm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DocumentoResponseVm", function() { return DocumentoResponseVm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EstadoReponseFileShare", function() { return EstadoReponseFileShare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FileshareComponent", function() { return FileshareComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FileshareModule", function() { return FileshareModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FileshareMultipleComponent", function() { return FileshareMultipleComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FileshareService", function() { return FileshareService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FolderBto", function() { return FolderBto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FolderFileBto", function() { return FolderFileBto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FolderFileUpdateIdentificadorVm", function() { return FolderFileUpdateIdentificadorVm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FolderFileVmGroup", function() { return FolderFileVmGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InitApi", function() { return InitApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InitWeb", function() { return InitWeb; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Params", function() { return Params; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ResponseFileShare", function() { return ResponseFileShare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ResponseFileShareHojasRutas", function() { return ResponseFileShareHojasRutas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ResponseFileShareVm", function() { return ResponseFileShareVm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RespuestaDataRequest", function() { return RespuestaDataRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TramiteInfo", function() { return TramiteInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UploadMultiple", function() { return UploadMultiple; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ViewFileshareCompareComponent", function() { return ViewFileshareCompareComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ViewFileshareComponent", function() { return ViewFileshareComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ViewFileshareContentComponent", function() { return ViewFileshareContentComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵa", function() { return FILESHARE_WEB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵb", function() { return FILESHARE_API; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var vesta__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vesta */ "./dist-library/vesta/fesm2015/vesta.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var modal_iframe__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! modal-iframe */ "./dist-library/modal-iframe/fesm2015/modal-iframe.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var modal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! modal */ "./dist-library/modal/fesm2015/modal.js");
/* harmony import */ var _ng_select_ng_select__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @ng-select/ng-select */ "./node_modules/@ng-select/ng-select/fesm2015/ng-select-ng-select.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");












/**
 * @fileoverview added by tsickle
 * Generated from: lib/fileshare.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
const EnumDireccionesFileShare = {
    FileShareWebApi: 0,
    FileShareWebApiHttps: 1,
    FileShareWeb: 2,
    FileShareWebHttps: 3,
};
EnumDireccionesFileShare[EnumDireccionesFileShare.FileShareWebApi] = 'FileShareWebApi';
EnumDireccionesFileShare[EnumDireccionesFileShare.FileShareWebApiHttps] = 'FileShareWebApiHttps';
EnumDireccionesFileShare[EnumDireccionesFileShare.FileShareWeb] = 'FileShareWeb';
EnumDireccionesFileShare[EnumDireccionesFileShare.FileShareWebHttps] = 'FileShareWebHttps';
class DireccionFileShare {
}
if (false) {}
/** @type {?} */
const DireccionesFileShare = [
    { Nombre: EnumDireccionesFileShare.FileShareWeb, Direccion: 'http://fileshare.grupovesta.com' },
    { Nombre: EnumDireccionesFileShare.FileShareWebApi, Direccion: 'http://filesharewebapi.grupovesta.com' },
    { Nombre: EnumDireccionesFileShare.FileShareWebHttps, Direccion: 'https://fileshare.vesta-accelerate.com' },
    { Nombre: EnumDireccionesFileShare.FileShareWebApiHttps, Direccion: 'https://fileshareapi.vesta-accelerate.com' } // 'https://filesharewebapi-stage.azurewebsites.net' //'https://localhost:44350'
];
/** @type {?} */
let FILESHARE_WEB = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["InjectionToken"]('FileShareWeb');
/** @type {?} */
let FILESHARE_API = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["InjectionToken"]('FileShareApi');

/**
 * @fileoverview added by tsickle
 * Generated from: lib/fileshare.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
__webpack_require__(/*! vesta/esm5/lib/service/array-extends */ "./dist-library/vesta/esm5/lib/service/array-extends.js");
class FileshareService {
    /**
     * @param {?} dialogService
     * @param {?} callHttp
     * @param {?} fileShareWebApi
     */
    constructor(dialogService, callHttp, fileShareWebApi) {
        this.dialogService = dialogService;
        this.callHttp = callHttp;
        this.fileShareWebApi = fileShareWebApi;
        this.Respuestas = [];
    }
    /**
     * @param {?} idSistema
     * @param {?} idDialog
     * @param {?} idLabel
     * @param {?=} identificador
     * @param {?=} enabled
     * @return {?}
     */
    DownloadDocumento(idSistema, idDialog, idLabel, identificador = null, enabled = null) {
        /** @type {?} */
        var obj = { IdSistema: idSistema, Identificador: identificador, Enabled: enabled };
        /** @type {?} */
        var objJson = JSON.stringify(obj);
        /** @type {?} */
        var objBase64 = btoa(objJson);
        return objBase64;
    }
    /**
     * @param {?} idSistemas
     * @param {?} idDialog
     * @param {?} idLabel
     * @param {?=} identificador
     * @param {?=} enabled
     * @return {?}
     */
    DownloadDocumentoListIdSistema(idSistemas, idDialog, idLabel, identificador = null, enabled = null) {
        /** @type {?} */
        var obj = { IdSistemas: idSistemas, Identificador: identificador, Enabled: enabled };
        /** @type {?} */
        var objJson = JSON.stringify(obj);
        /** @type {?} */
        var objBase64 = btoa((objJson));
        return objBase64;
    }
    /**
     * @param {?} userId
     * @param {?} userName
     * @param {?} tramites
     * @param {?} codSistema
     * @param {?} idDocumento
     * @param {?} documento
     * @param {?} codPais
     * @param {?} codOficina
     * @return {?}
     */
    UploadTramitesDocumento(userId, userName, tramites, codSistema, idDocumento, documento, codPais, codOficina) {
        this.Verificar(codSistema, userId, userName);
        this.VerificarFolderFilesTramites(tramites);
        /** @type {?} */
        let folderFiles = vesta__WEBPACK_IMPORTED_MODULE_2__["Mapper"].ConvertListObject(tramites, new FolderFilesRequestVm());
        /** @type {?} */
        var folder = new FolderRequestVm();
        if (codPais !== "" && codOficina !== "") {
            folder = FolderRequestVm.GetFolderRequestVm(codSistema, userId, userName, folderFiles);
        }
        else if (codPais !== "") {
            folder = FolderRequestVm.GetFolderRequestVm(codSistema, userId, userName, folderFiles, "504");
        }
        else if (codOficina !== "") {
            folder = FolderRequestVm.GetFolderRequestVm(codSistema, userId, userName, folderFiles, "", "PRINC");
        }
        else {
            folder = FolderRequestVm.GetFolderRequestVm(codSistema, userId, userName, folderFiles);
        }
        /** @type {?} */
        let filetype = DocumentoRequestVm.GetDocumentoRequestVm(idDocumento, documento);
        /** @type {?} */
        let documentos = [filetype];
        /** @type {?} */
        var datosEnvio = DataRequest.GetDataRequest(folder, documentos);
        return datosEnvio;
    }
    /**
     * @param {?} userId
     * @param {?} userName
     * @param {?} documentoDtos
     * @param {?} idSistema
     * @param {?} codSistema
     * @param {?=} identificador
     * @param {?=} nombreEmpresa
     * @param {?=} codPaisOperacion
     * @param {?=} datos
     * @param {?=} observacion
     * @param {?=} codPais
     * @param {?=} codOficina
     * @param {?=} idDialog
     * @param {?=} idLabel
     * @return {?}
     */
    UploadDocumentos(userId, userName, documentoDtos, idSistema, codSistema, identificador = "", nombreEmpresa = "", codPaisOperacion = "", datos = "", observacion = "", codPais = "", codOficina = "", idDialog = "", idLabel = "") {
        this.Respuestas = [];
        //this.dialogService.Snniper();
        this.Verificar(codSistema, userId, userName);
        this.VerificarFolderFiles(idSistema, identificador, nombreEmpresa, codPaisOperacion, datos, observacion);
        /** @type {?} */
        var folderFile = FolderFilesRequestVm.GetFolderFilesRequestVm(idSistema, identificador, nombreEmpresa, datos, codPaisOperacion, observacion);
        /** @type {?} */
        var listFolderFile = [folderFile];
        /** @type {?} */
        var folder = new FolderRequestVm();
        if (codPais !== "" && codOficina !== "") {
            folder = FolderRequestVm.GetFolderRequestVm(codSistema, userId, userName, listFolderFile);
        }
        else if (codPais !== "") {
            folder = FolderRequestVm.GetFolderRequestVm(codSistema, userId, userName, listFolderFile, "504");
        }
        else if (codOficina !== "") {
            folder = FolderRequestVm.GetFolderRequestVm(codSistema, userId, userName, listFolderFile, "", "PRINC");
        }
        else {
            folder = FolderRequestVm.GetFolderRequestVm(codSistema, userId, userName, listFolderFile);
        }
        /** @type {?} */
        var datosEnvio = DataRequest.GetDataRequest(folder, documentoDtos);
        console.log(JSON.stringify(datosEnvio));
        return datosEnvio;
    }
    /**
     * @param {?} userId
     * @param {?} userName
     * @param {?} idDocumento
     * @param {?} documento
     * @param {?} idSistema
     * @param {?} codSistema
     * @param {?=} identificador
     * @param {?=} nombreEmpresa
     * @param {?=} codPaisOperacion
     * @param {?=} datos
     * @param {?=} observacion
     * @param {?=} codPais
     * @param {?=} codOficina
     * @param {?=} idDialog
     * @param {?=} idLabel
     * @return {?}
     */
    UploadDocumento(userId, userName, idDocumento, documento, idSistema, codSistema, identificador = "", nombreEmpresa = "", codPaisOperacion = "", datos = "", observacion = "", codPais = "", codOficina = "", idDialog = "", idLabel = "") {
        this.Respuestas = [];
        //this.dialogService.Snniper();
        this.Verificar(codSistema, userId, userName);
        this.VerificarFolderFiles(idSistema, identificador, nombreEmpresa, codPaisOperacion, datos, observacion);
        /** @type {?} */
        var folderFile = FolderFilesRequestVm.GetFolderFilesRequestVm(idSistema, identificador, nombreEmpresa, datos, codPaisOperacion, observacion);
        /** @type {?} */
        var listFolderFile = [folderFile];
        /** @type {?} */
        var folder = new FolderRequestVm();
        if (codPais !== "" && codOficina !== "") {
            folder = FolderRequestVm.GetFolderRequestVm(codSistema, userId, userName, listFolderFile);
        }
        else if (codPais !== "") {
            folder = FolderRequestVm.GetFolderRequestVm(codSistema, userId, userName, listFolderFile, "504");
        }
        else if (codOficina !== "") {
            folder = FolderRequestVm.GetFolderRequestVm(codSistema, userId, userName, listFolderFile, "", "PRINC");
        }
        else {
            folder = FolderRequestVm.GetFolderRequestVm(codSistema, userId, userName, listFolderFile);
        }
        /** @type {?} */
        var documentos = DocumentoRequestVm.GetDocumentoRequestVm(idDocumento, documento);
        /** @type {?} */
        var listDocumentos = [documentos];
        /** @type {?} */
        var datosEnvio = DataRequest.GetDataRequest(folder, listDocumentos);
        console.log(JSON.stringify(datosEnvio));
        return datosEnvio;
    }
    /**
     * @param {?} folderFile
     * @return {?}
     */
    UpdateIdSistemaFolderFile(folderFile) {
        return this.callHttp.httpPost(`${this.fileShareWebApi}/Api/SyncFolderFilesApi/PostUpdateFolderFile`, folderFile, { withCredentials: false });
    }
    /**
     * @param {?} idSistema
     * @return {?}
     */
    GetRespuestaUploadDocumento(idSistema) {
        if (this.Respuestas.Enumerable().any((/**
         * @param {?} a
         * @return {?}
         */
        a => a.IdSistema === idSistema && a.Save))) {
            /** @type {?} */
            let resp = this.Respuestas.Enumerable().lastOrDefault((/**
             * @param {?} f
             * @return {?}
             */
            f => f.IdSistema === idSistema && f.Save));
            if (resp !== null) {
                /** @type {?} */
                let call = this.callHttp
                    .httpGet(`${this.fileShareWebApi}/Api/SyncFolderFilesApi/GetResponseFileShare?id=${resp.IdRespuesta}`, null, { withCredentials: false });
                call.subscribe((/**
                 * @param {?} response
                 * @return {?}
                 */
                response => {
                    if (response != undefined) {
                        /** @type {?} */
                        let respTemp = response.Enumerable().firstOrDefault();
                        if (respTemp !== null) {
                            if (response.Enumerable().select((/**
                             * @param {?} s
                             * @return {?}
                             */
                            s => s.Estado)).firstOrDefault() === 1) {
                                resp.Save = true;
                            }
                        }
                    }
                    else {
                        console.log("Upload respuesta vacia 1");
                    }
                }), (/**
                 * @param {?} error
                 * @return {?}
                 */
                error => {
                    //this.dialogService.SnniperClose();
                }));
                return call;
            }
            else {
                return this.callHttp.httpGet(`${this.fileShareWebApi}/Api/SyncFolderFilesApi/GetResponseFileShare?id=null`, null, { withCredentials: false });
            }
        }
        else {
            /** @type {?} */
            let resp = this.Respuestas.Enumerable().lastOrDefault((/**
             * @param {?} f
             * @return {?}
             */
            f => f.IdSistema === idSistema));
            if (resp !== null) {
                /** @type {?} */
                let call = this.callHttp
                    .httpGet(`${this.fileShareWebApi}/Api/SyncFolderFilesApi/GetResponseFileShare?id=${resp.IdRespuesta}`, null, { withCredentials: false });
                call.subscribe((/**
                 * @param {?} response
                 * @return {?}
                 */
                response => {
                    if (response != undefined) {
                        /** @type {?} */
                        let respTemp = response.Enumerable().firstOrDefault();
                        if (respTemp !== null) {
                            if (response.Enumerable().select((/**
                             * @param {?} s
                             * @return {?}
                             */
                            s => s.Estado)).firstOrDefault() === 1) {
                                resp.Save = true;
                            }
                        }
                    }
                    else {
                        console.log("Upload respuesta vacia 2");
                    }
                }), (/**
                 * @param {?} error
                 * @return {?}
                 */
                error => {
                    // void
                }));
                return call;
            }
            else {
                return this.callHttp.httpGet(`${this.fileShareWebApi}/Api/SyncFolderFilesApi/GetResponseFileShare?id=null`, null, { withCredentials: false });
            }
        }
    }
    /**
     * @param {?} id
     * @return {?}
     */
    GetUrlFolderFile(id) {
        return this.callHttp.httpGetParams(`${this.fileShareWebApi}/Api/SyncFolderFilesApi/GetUrlFolderFile`, { id: id }, { withCredentials: false });
    }
    /**
     * @param {?} id
     * @return {?}
     */
    GetUrlFolderFileDownload(id) {
        return this.callHttp.httpGetParams(`${this.fileShareWebApi}/Api/SyncFolderFilesApi/GetUrlFolderFileDownload`, { id: id }, { withCredentials: false });
    }
    /**
     * @param {?} idSistema
     * @param {?} identificador
     * @return {?}
     */
    GetUrlFolderFileDownloadIdentificador(idSistema, identificador) {
        return this.callHttp.httpGetParams(`${this.fileShareWebApi}/Api/SyncFolderFilesApi/GetUrlFolderFileDownloadIdentificador`, { idSistema: idSistema, identificador: identificador }, { withCredentials: false });
    }
    /**
     * @param {?} ids
     * @return {?}
     */
    DeleteFile(ids) {
        return this.callHttp.httpPostText(`${this.fileShareWebApi}/Api/SyncFolderFilesApi/PostDeleteFolderFile`, ids, { withCredentials: false });
    }
    /**
     * @param {?} ids
     * @return {?}
     */
    UpdateIdentificadorFolderFiles(ids) {
        return this.callHttp.httpPostText(`${this.fileShareWebApi}/Api/SyncFolderFilesApi/UpdateIdentificadorFolderFiles`, ids, { withCredentials: false });
    }
    /**
     * @return {?}
     */
    Upload() {
        this.dialogService.NotificacionAlert("Error CodSistema");
    }
    /**
     * @return {?}
     */
    GetNameFileSystem() {
        return this.callHttp.httpGetText(`${this.fileShareWebApi}/Api/SyncFolderFilesApi/GetNameFileSystem`, null, { withCredentials: false }).toPromise();
    }
    /**
     * @param {?} codPais
     * @param {?} pais
     * @param {?} codOficina
     * @param {?} oficina
     * @param {?} sistema
     * @param {?} userId
     * @param {?} userName
     * @param {?} folderUriBase
     * @return {?}
     */
    GetFolder(codPais, pais, codOficina, oficina, sistema, userId, userName, folderUriBase) {
        return this.callHttp.httpGet(`${this.fileShareWebApi}/Api/SyncFolderFilesApi/GetFolderUriByConditions`, `codPais=${codPais}&pais=${pais}&codOficina=${codOficina}&oficina=${oficina}&sistema=${sistema}&userId=${userId}&userName=${userName}&folderUriBase=${folderUriBase}`, { withCredentials: false }).toPromise();
    }
    /**
     * @param {?} codSistema
     * @param {?} codPais
     * @param {?} oficina
     * @param {?} codOficina
     * @param {?} userName
     * @param {?} userId
     * @param {?} fileExtension
     * @return {?}
     */
    GetFolderUrlSinged(codSistema, codPais, oficina, codOficina, userName, userId, fileExtension) {
        return this.callHttp.httpGet(`${this.fileShareWebApi}/Api/SyncFolderFilesApi/GetFolderUrlSinged`, `codSistema=${codSistema}&codPais=${codPais}&oficina=${oficina}&codOficina=${codOficina}&userName=${userName}&userId=${userId}&fileExtension=${fileExtension}`, { withCredentials: false }).toPromise();
    }
    /**
     * @param {?} userId
     * @param {?} userName
     * @param {?} idDocumento
     * @param {?} documento
     * @param {?} idSistema
     * @param {?} codSistema
     * @param {?} fileName
     * @param {?} fileExtension
     * @param {?} documentoBlob
     * @param {?} numeroReferencia
     * @param {?=} identificador
     * @param {?=} nombreEmpresa
     * @param {?=} codPaisOperacion
     * @param {?=} datos
     * @param {?=} observacion
     * @param {?=} codPais
     * @param {?=} codOficina
     * @return {?}
     */
    UploadDocumentoBlob(userId, userName, idDocumento, documento, idSistema, codSistema, fileName, fileExtension, documentoBlob, numeroReferencia, identificador = "", nombreEmpresa = "", codPaisOperacion = "", datos = "", observacion = "", codPais = "", codOficina = "") {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function* () {
            /** @type {?} */
            let promise = new Promise((/**
             * @param {?} resolve
             * @param {?} reject
             * @return {?}
             */
            (resolve, reject) => Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function* () {
                /** @type {?} */
                let datoUpload = this.UploadDocumento(userId, userName, idDocumento, documento, idSistema, codSistema, identificador, nombreEmpresa, codPaisOperacion, datos, observacion, codPais, codOficina);
                if (Strings.IsNullOrEmpty(fileExtension) || Strings.IsNullOrEmpty(numeroReferencia) || Strings.IsNullOrEmpty(fileName))
                    throw "fileExtension, numeroReferencia, fileName son campos obligatorios";
                if (documentoBlob == null)
                    throw "Documento Blob vacio";
                /** @type {?} */
                let folder = datoUpload.FolderRequestVm;
                /** @type {?} */
                let upload = yield this.GetFolderUrlSinged(folder.CodSistema, folder.CodPais, folder.Oficina, folder.CodOficina, folder.UserName, folder.UserId, fileExtension);
                let [folderFile] = folder.FolderFilesRequestVm;
                /** @type {?} */
                let documentoBto = { IdDocumento: idDocumento, NombreDocumento: documento, NumeroReferencia: numeroReferencia };
                /** @type {?} */
                let folderFileUpload = FolderFileBto.GetFolderFileBto(folderFile.IdSistema, folderFile.Identificador, folderFile.NombreEmpresa, folderFile.CodPaisOperacion, folderFile.Observacion, fileName, fileExtension, upload.NameFileSystem, documentoBlob.size, [documentoBto]);
                /** @type {?} */
                let folderUpload = FolderBto.GetFolderBto(folder.CodPais, folder.CodOficina, folder.Oficina, parseInt(folder.CodSistema), folder.UserName, parseInt(folder.UserId), [folderFileUpload]);
                this.callHttp.httpPutFileShare(upload.Url, documentoBlob, documentoBlob.type).subscribe((/**
                 * @param {?} response
                 * @return {?}
                 */
                response => {
                    console.log("Documento Digitalizado");
                    console.log(response);
                    this.callHttp.httpPost(`${this.fileShareWebApi}/api/SyncFolderFilesApi/PostSaveDocument`, folderUpload, { withCredentials: false })
                        .subscribe((/**
                     * @param {?} response
                     * @return {?}
                     */
                    response => {
                        this.dialogService.NotificacionSucess("Documento Digitalizado con exito...");
                        resolve(response);
                    }), (/**
                     * @param {?} error
                     * @return {?}
                     */
                    error => {
                        this.dialogService.NotificacionAlert(error);
                        reject([]);
                    }));
                }), (/**
                 * @param {?} error
                 * @return {?}
                 */
                error => {
                    this.dialogService.NotificacionAlert(error);
                    reject([]);
                }));
            })));
            return promise;
        });
    }
    /**
     * @param {?} userId
     * @param {?} userName
     * @param {?} idSistema
     * @param {?} codSistema
     * @param {?} documentosBlob
     * @param {?=} identificador
     * @param {?=} nombreEmpresa
     * @param {?=} codPaisOperacion
     * @param {?=} datos
     * @param {?=} observacion
     * @param {?=} codPais
     * @param {?=} codOficina
     * @return {?}
     */
    UploadDocumentoListBlob(userId, userName, idSistema, codSistema, documentosBlob, identificador = "", nombreEmpresa = "", codPaisOperacion = "", datos = "", observacion = "", codPais = "", codOficina = "") {
        //let promise = new Promise<Array<ReponseUploadFileBlob>>(async (resolve, reject) => {
        /** @type {?} */
        let subject = new rxjs__WEBPACK_IMPORTED_MODULE_3__["Subject"]();
        if (!Array.isArray(documentosBlob))
            throw "Documentos vacio";
        if (documentosBlob.some((/**
         * @param {?} s
         * @return {?}
         */
        s => Strings.IsNullOrEmpty(s.FileExtension) || Strings.IsNullOrEmpty(s.NumeroReferencia) || Strings.IsNullOrEmpty(s.FileName))))
            throw "fileExtension, numeroReferencia, fileName son campos obligatorios";
        if (documentosBlob.some((/**
         * @param {?} s
         * @return {?}
         */
        s => s.File == null)))
            throw "Documento Blob vacio";
        /** @type {?} */
        let uploadResponseDocumentos = [];
        documentosBlob.forEach((/**
         * @param {?} f
         * @param {?} i
         * @return {?}
         */
        (f, i) => Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function* () {
            /** @type {?} */
            let datoUpload = this.UploadDocumento(userId, userName, f.IdDocumento, f.Documento, idSistema, codSistema, identificador, nombreEmpresa, codPaisOperacion, datos, observacion, codPais, codOficina);
            /** @type {?} */
            let folder = datoUpload.FolderRequestVm;
            /** @type {?} */
            let upload = yield this.GetFolderUrlSinged(folder.CodSistema, folder.CodPais, folder.Oficina, folder.CodOficina, folder.UserName, folder.UserId, f.FileExtension);
            let [folderFile] = folder.FolderFilesRequestVm;
            /** @type {?} */
            let documentoBto = { IdDocumento: f.IdDocumento, NombreDocumento: f.Documento, NumeroReferencia: f.NumeroReferencia };
            /** @type {?} */
            let folderFileUpload = FolderFileBto.GetFolderFileBto(folderFile.IdSistema, folderFile.Identificador, folderFile.NombreEmpresa, folderFile.CodPaisOperacion, folderFile.Observacion, f.FileName, f.FileExtension, upload.NameFileSystem, f.File.size, [documentoBto]);
            /** @type {?} */
            let folderUpload = FolderBto.GetFolderBto(folder.CodPais, folder.CodOficina, folder.Oficina, parseInt(folder.CodSistema), folder.UserName, parseInt(folder.UserId), [folderFileUpload]);
            try {
                //let responseUpload = await this.callHttp.httpPutFileShareProgress(upload.Url, f.File, f.File.type).toPromise()
                this.callHttp.httpPutFileShareProgress(upload.Url, f.File, f.File.type).subscribe((/**
                 * @param {?} event
                 * @return {?}
                 */
                event => {
                    switch (event.type) {
                        case _angular_common_http__WEBPACK_IMPORTED_MODULE_4__["HttpEventType"].Sent:
                            console.log('Request has been made!');
                            break;
                        case _angular_common_http__WEBPACK_IMPORTED_MODULE_4__["HttpEventType"].ResponseHeader:
                            console.log('Response header has been received!');
                            break;
                        case _angular_common_http__WEBPACK_IMPORTED_MODULE_4__["HttpEventType"].UploadProgress:
                            /** @type {?} */
                            let progress = Math.round(event.loaded / event.total * 100);
                            console.log(`Uploaded! ${progress}%`);
                            subject.next({ Event: true, Data: { Index: i, Progress: progress } });
                            break;
                        case _angular_common_http__WEBPACK_IMPORTED_MODULE_4__["HttpEventType"].Response:
                            console.log('User successfully created!', event.body);
                            setTimeout((/**
                             * @return {?}
                             */
                            () => {
                                //this.progress = 0;
                            }), 1500);
                    }
                }), (/**
                 * @param {?} error
                 * @return {?}
                 */
                error => {
                    this.dialogService.NotificacionAlert(error);
                }), (/**
                 * @return {?}
                 */
                () => Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function* () {
                    console.log("Documento Digitalizado");
                    //console.log(responseUpload);
                    /** @type {?} */
                    let response = yield this.callHttp.httpPost(`${this.fileShareWebApi}/api/SyncFolderFilesApi/PostSaveDocument`, folderUpload, { withCredentials: false }).toPromise();
                    let [uploadDocumento] = response;
                    if (uploadDocumento != null) {
                        uploadDocumento.NumeroReferencia = f.NumeroReferencia;
                        uploadResponseDocumentos.push(uploadDocumento);
                        this.dialogService.NotificacionSucess(`Documento ${f.NumeroReferencia}, Digitalizado con exito...`);
                    }
                    if (uploadResponseDocumentos.length == documentosBlob.length) {
                        subject.next({ Event: false, Data: uploadResponseDocumentos });
                        subject.complete();
                    }
                })));
            }
            catch (error) {
                this.dialogService.NotificacionAlert(error);
            }
        })));
        //resolve(uploadResponseDocumentos)
        //})
        return subject;
        //return promise;
    }
    /**
     * @param {?} base64Data
     * @param {?} contentType
     * @return {?}
     */
    Base64toBlob(base64Data, contentType) {
        document.getElementById("status").innerHTML += "Processing file</br>";
        contentType = contentType || '';
        /** @type {?} */
        var sliceSize = 1024;
        /** @type {?} */
        var byteCharacters = atob(base64Data);
        /** @type {?} */
        var bytesLength = byteCharacters.length;
        /** @type {?} */
        var slicesCount = Math.ceil(bytesLength / sliceSize);
        /** @type {?} */
        var byteArrays = new Array(slicesCount);
        for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
            /** @type {?} */
            var begin = sliceIndex * sliceSize;
            /** @type {?} */
            var end = Math.min(begin + sliceSize, bytesLength);
            /** @type {?} */
            var bytes = new Array(end - begin);
            for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
                bytes[i] = byteCharacters[offset].charCodeAt(0);
            }
            byteArrays[sliceIndex] = new Uint8Array(bytes);
        }
        return new Blob(byteArrays, { type: contentType });
    }
    /**
     * @private
     * @param {?} codSistema
     * @param {?} userId
     * @param {?} userName
     * @return {?}
     */
    Verificar(codSistema, userId, userName) {
        if (Strings.IsNullOrEmpty(codSistema) || Strings.IsNullOrEmpty(userId) || Strings.IsNullOrEmpty(userName)) {
            throw "CodSistema, UserId, userName son campos obligatorios";
        }
    }
    /**
     * @private
     * @param {?} idSistema
     * @param {?=} identificador
     * @param {?=} nombreEmpresa
     * @param {?=} codPaisOperacion
     * @param {?=} datos
     * @param {?=} observacion
     * @return {?}
     */
    VerificarFolderFiles(idSistema, identificador = "", nombreEmpresa = "", codPaisOperacion = "", datos = "", observacion = "") {
        if (!Strings.IsNullOrEmpty(idSistema)) {
            if (Strings.IsNullOrEmpty(identificador) && Strings.IsNullOrEmpty(nombreEmpresa) &&
                Strings.IsNullOrEmpty(codPaisOperacion) && Strings.IsNullOrEmpty(datos) &&
                Strings.IsNullOrEmpty(observacion)) {
                throw "Tramites no cumplen con requisitos minimos. IdSistema es campo obligatorio. Identificador, " +
                    "NombreEmpresa, Datos, CodPaisOperacion, Observacion, se debe tener al menos uno de ellos";
            }
        }
        else {
            throw "IdSistema es campo obligatorio";
        }
    }
    /**
     * @private
     * @param {?} tramites
     * @return {?}
     */
    VerificarFolderFilesTramites(tramites) {
        /** @type {?} */
        let folderFilesTemp = [];
        /** @type {?} */
        let folderFiles = tramites.Enumerable();
        folderFiles.forEach((/**
         * @param {?} f
         * @return {?}
         */
        f => {
            if (!Strings.IsNullOrEmpty(f.IdSistema)) {
                if (Strings.IsNullOrEmpty(f.Identificador) && Strings.IsNullOrEmpty(f.Datos) &&
                    Strings.IsNullOrEmpty(f.NombreEmpresa) && Strings.IsNullOrEmpty(f.Observacion) &&
                    Strings.IsNullOrEmpty(f.CodPaisOperacion)) {
                    folderFilesTemp.push(f);
                }
            }
            else {
                folderFilesTemp.push(f);
            }
        }));
        if (folderFilesTemp.Enumerable().any()) {
            throw "Tramites no cumplen con requisitos minimos. " +
                "IdSistema es campo obligatorio. Identificador, NombreEmpresa, Datos, " +
                "CodPaisOperacion, Observacion se debe tener al menos uno de ellos";
        }
    }
}
FileshareService.decorators = [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"], args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
FileshareService.ctorParameters = () => [
    { type: vesta__WEBPACK_IMPORTED_MODULE_2__["DialogService"] },
    { type: vesta__WEBPACK_IMPORTED_MODULE_2__["CallHttp"] },
    { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [FILESHARE_API,] }] }
];
/** @nocollapse */ FileshareService.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵɵdefineInjectable"])({ factory: function FileshareService_Factory() { return new FileshareService(Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵɵinject"])(vesta__WEBPACK_IMPORTED_MODULE_2__["DialogService"]), Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵɵinject"])(vesta__WEBPACK_IMPORTED_MODULE_2__["CallHttp"]), Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ɵɵinject"])(FILESHARE_API)); }, token: FileshareService, providedIn: "root" });
if (false) {}
class DocumentoRequestVm {
    constructor() {
        this.IdDocumento = 0;
        this.Documento = "";
    }
    /**
     * @param {?} idDocumento
     * @param {?} documento
     * @return {?}
     */
    static GetDocumentoRequestVm(idDocumento, documento) {
        /** @type {?} */
        var obj = new DocumentoRequestVm();
        obj.IdDocumento = idDocumento;
        obj.Documento = documento;
        return obj;
    }
}
if (false) {}
class FolderFilesRequestVm {
    constructor() {
        this.Id = 0;
        this.IdFolder = 0;
        this.IdSistema = null;
        this.Identificador = null;
        this.NombreEmpresa = null;
        this.Datos = null;
        this.CodPaisOperacion = null;
        this.Observacion = null;
    }
    /**
     * @param {?} idSistema
     * @param {?=} identidificador
     * @param {?=} nombreEmpresa
     * @param {?=} datos
     * @param {?=} codPaisOperacion
     * @param {?=} observacion
     * @return {?}
     */
    static GetFolderFilesRequestVm(idSistema, identidificador = "", nombreEmpresa = "", datos = "", codPaisOperacion = "", observacion = "") {
        /** @type {?} */
        var obj = new FolderFilesRequestVm();
        obj.IdSistema = idSistema;
        obj.Identificador = identidificador;
        obj.NombreEmpresa = nombreEmpresa;
        obj.Datos = datos;
        obj.CodPaisOperacion = codPaisOperacion;
        obj.Observacion = observacion;
        return obj;
    }
}
if (false) {}
/**
 * @record
 */
function FolderVm() { }
if (false) {}
class FolderRequestVm {
    constructor() {
        this.Id = 0;
        this.CodPais = "504";
        this.CodOficina = "PRINC";
        this.Oficina = "Principal";
        this.CodSistema = "";
        this.UserId = "";
        this.UserName = "";
        this.FolderFilesRequestVm = [];
    }
    /**
     * @param {?} codSistema
     * @param {?} userId
     * @param {?} userName
     * @param {?} folderFile
     * @param {?=} codPais
     * @param {?=} codOficina
     * @return {?}
     */
    static GetFolderRequestVm(codSistema, userId, userName, folderFile, codPais = "", codOficina = "") {
        /** @type {?} */
        var obj = new FolderRequestVm();
        obj.CodSistema = codSistema;
        obj.UserId = userId;
        obj.UserName = userName;
        obj.FolderFilesRequestVm = folderFile;
        if (codOficina !== "") {
            obj.CodOficina = codOficina;
        }
        if (codPais !== "") {
            obj.CodPais = codPais;
        }
        return obj;
    }
}
if (false) {}
class DataRequest {
    constructor() {
        this.FolderRequestVm = new FolderRequestVm();
        this.DocumentoRequestVm = [];
    }
    /**
     * @param {?} folderRequestVm
     * @param {?} documentoRequestVm
     * @return {?}
     */
    static GetDataRequest(folderRequestVm, documentoRequestVm) {
        /** @type {?} */
        var obj = new DataRequest();
        obj.FolderRequestVm = folderRequestVm;
        obj.DocumentoRequestVm = documentoRequestVm;
        return obj;
    }
}
if (false) {}
class RespuestaDataRequest {
    constructor() {
        this.IdFolderRequest = 0;
        this.IdDocumento = [];
    }
    /**
     * @param {?} idFolderRequest
     * @param {?} IdDocumento
     * @return {?}
     */
    static GetRespuestaDataRequest(idFolderRequest, IdDocumento) {
        /** @type {?} */
        var obj = new RespuestaDataRequest();
        obj.IdDocumento = IdDocumento;
        obj.IdFolderRequest = idFolderRequest;
        return obj;
    }
}
if (false) {}
class FolderFileUpdateIdentificadorVm {
    /**
     * @param {?} id
     * @param {?} identificador
     * @return {?}
     */
    static GetFolderFileUpdateIdentificadorVm(id, identificador) {
        /** @type {?} */
        let obj = {
            Id: id,
            Identificador: identificador
        };
        return obj;
    }
}
if (false) {}
class ResponseFileShareVm {
    constructor() {
        this.IdSistema = "";
        this.Estado = EstadoReponseFileShare.Start;
        this.DocumentoResponseVms = [];
    }
}
if (false) {}
/**
 * @record
 */
function FolderFileDownloadVm() { }
if (false) {}
/** @enum {number} */
const EstadoReponseFileShare = {
    Start: -1,
    NoLoaded: 0,
    Upload: 1,
};
EstadoReponseFileShare[EstadoReponseFileShare.Start] = 'Start';
EstadoReponseFileShare[EstadoReponseFileShare.NoLoaded] = 'NoLoaded';
EstadoReponseFileShare[EstadoReponseFileShare.Upload] = 'Upload';
class ResponseFileShare {
    constructor() {
        this.IdSistema = "";
        this.IdRespuesta = 0;
        this.Save = false;
    }
    /**
     * @param {?} idSistema
     * @param {?} idRespuesta
     * @return {?}
     */
    static GetResponseFileShare(idSistema, idRespuesta) {
        /** @type {?} */
        var obj = new ResponseFileShare();
        obj.IdRespuesta = idRespuesta;
        obj.IdSistema = idSistema;
        return obj;
    }
}
if (false) {}
class ResponseFileShareHojasRutas {
    constructor() {
        this.IdSistemas = [];
        this.IdRespuesta = 0;
        this.Save = false;
    }
    /**
     * @param {?} idSistema
     * @param {?} idRespuesta
     * @return {?}
     */
    static GetResponseFileShare(idSistema, idRespuesta) {
        /** @type {?} */
        var obj = new ResponseFileShareHojasRutas();
        obj.IdRespuesta = idRespuesta;
        obj.IdSistemas = idSistema;
        return obj;
    }
}
if (false) {}
class DocumentoResponseVm {
    constructor() {
        this.IdDocumento = 0;
        this.Documento = "";
        this.NoReferencia = "";
    }
}
if (false) {}
class Strings extends String {
    /**
     * @param {?} value
     * @return {?}
     */
    static IsNullOrEmpty(value) {
        /** @type {?} */
        var isNullOrEmpty = true;
        if (value) {
            if (typeof (value) === "string") {
                if (value.length > 0) {
                    isNullOrEmpty = false;
                }
            }
        }
        return isNullOrEmpty;
    }
}
class TramiteInfo {
    /**
     * @param {?} idSistema
     * @param {?} identificador
     * @param {?} nombreEmpresa
     * @param {?} datos
     * @param {?} codPaisOperacion
     * @param {?} observacion
     * @return {?}
     */
    static GetTramiteInfo(idSistema, identificador, nombreEmpresa, datos, codPaisOperacion, observacion) {
        /** @type {?} */
        let obj = new TramiteInfo();
        obj.IdSistema = idSistema;
        obj.Identificador = identificador;
        obj.NombreEmpresa = nombreEmpresa;
        obj.Datos = datos;
        obj.CodPaisOperacion = codPaisOperacion;
        obj.Observacion = observacion;
        return obj;
    }
}
if (false) {}
class FolderFileVmGroup {
    /**
     * @param {?} idSistema
     * @param {?} ids
     * @return {?}
     */
    static GetFolderFileVmGroup(idSistema, ids) {
        /** @type {?} */
        let obj = new FolderFileVmGroup();
        obj.Ids = ids;
        obj.IdSistema = idSistema;
        return obj;
    }
}
if (false) {}
/**
 * @record
 */
function ResponseFolderUpload() { }
if (false) {}
class DocumentoBto {
}
if (false) {}
class FolderFileBto {
    /**
     * @param {?} idSistema
     * @param {?} identificador
     * @param {?} nombreEmpresa
     * @param {?} codPaisOperacion
     * @param {?} observacion
     * @param {?} fileName
     * @param {?} fileExtencion
     * @param {?} fileNameSystem
     * @param {?} fileSize
     * @param {?} documentoBto
     * @return {?}
     */
    static GetFolderFileBto(idSistema, identificador, nombreEmpresa, codPaisOperacion, observacion, fileName, fileExtencion, fileNameSystem, fileSize, documentoBto) {
        /** @type {?} */
        let obj = {
            IdSistema: idSistema,
            Identificador: identificador,
            NombreEmpresa: nombreEmpresa,
            CodPaisOperacion: codPaisOperacion,
            Observacion: observacion,
            FileName: fileName,
            FileNameSystem: fileNameSystem,
            FileExtencion: fileExtencion,
            FileSize: fileSize,
            DocumentoBto: documentoBto
        };
        return obj;
    }
}
if (false) {}
class FolderBto {
    /**
     * @param {?} codPais
     * @param {?} codOficina
     * @param {?} oficina
     * @param {?} codSistema
     * @param {?} userName
     * @param {?} userId
     * @param {?} folderFileBto
     * @return {?}
     */
    static GetFolderBto(codPais, codOficina, oficina, codSistema, userName, userId, folderFileBto) {
        /** @type {?} */
        let obj = {
            CodPais: codPais,
            CodOficina: codOficina,
            Oficina: oficina,
            CodSistema: codSistema,
            UserName: userName,
            UserId: userId,
            FolderFileBto: folderFileBto
        };
        return obj;
    }
}
if (false) {}
/**
 * @record
 */
function ReponseUploadFileBlob() { }
if (false) {}
class UploadMultiple {
    constructor() {
        this.Documentos = [];
    }
    /**
     * @param {?} userId
     * @param {?} userName
     * @param {?} idSistema
     * @param {?} codigoSistema
     * @param {?} documentos
     * @param {?=} identificador
     * @param {?=} nombreEmpresa
     * @param {?=} codPaisOperacion
     * @param {?=} datos
     * @param {?=} observacion
     * @param {?=} codPais
     * @param {?=} codOficina
     * @return {?}
     */
    static getUploadMultiple(userId, userName, idSistema, codigoSistema, documentos, identificador, nombreEmpresa, codPaisOperacion, datos, observacion, codPais, codOficina) {
        /** @type {?} */
        let obj = new UploadMultiple();
        obj.UserId = userId;
        obj.UserName = userName;
        obj.IdSistema = idSistema;
        obj.CodigoSistema = codigoSistema;
        obj.Documentos = documentos;
        obj.Identificador = identificador;
        obj.NombreEmpresa = nombreEmpresa;
        obj.CodPaisOperacion = codPaisOperacion;
        obj.Datos = datos;
        obj.Observacion = observacion;
        obj.CodPais = codPais;
        obj.CodOficina = codOficina;
        return obj;
    }
}
if (false) {}
class DocumentoBlob {
    /**
     * @param {?} file
     * @param {?} numeroReferencia
     * @param {?} fileName
     * @param {?} fileExtension
     * @param {?} idDocumento
     * @param {?} documento
     * @return {?}
     */
    static getDocumentosBlob(file, numeroReferencia, fileName, fileExtension, idDocumento, documento) {
        /** @type {?} */
        let obj = new DocumentoBlob();
        obj.File = file;
        obj.NumeroReferencia = numeroReferencia;
        obj.FileName = fileName;
        obj.FileExtension = fileExtension;
        obj.IdDocumento = idDocumento;
        obj.Documento = documento;
        return obj;
    }
}
if (false) {}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/fileshare.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var chance = __webpack_require__(/*! chance */ "./node_modules/chance/chance.js").Chance();
class FileshareComponent {
    /**
     * @param {?} fileShareService
     * @param {?} dialogService
     * @param {?} callHttp
     * @param {?} fileShareWeb
     * @param {?} fileShareApi
     */
    constructor(fileShareService, dialogService, callHttp, fileShareWeb, fileShareApi) {
        this.fileShareService = fileShareService;
        this.dialogService = dialogService;
        this.callHttp = callHttp;
        this.fileShareWeb = fileShareWeb;
        this.fileShareApi = fileShareApi;
    }
    /**
     * @return {?}
     */
    get tittle() {
        return this._tittle;
    }
    /**
     * @return {?}
     */
    get width() {
        return this._width;
    }
    /**
     * @return {?}
     */
    get height() {
        return this._height;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.IdDialog = chance.guid();
        this.IdLabel = chance.guid();
        this._tittle = "Upload Files";
        this._width = "850";
    }
    /**
     * @return {?}
     */
    Close() {
        if (this.IdInstrucion !== undefined) {
            this.SubjectModal.next(this.IdInstrucion);
        }
        else if (this.IdInstrucciones !== undefined) {
            this.SubjectModalList.next(this.IdInstrucciones);
        }
    }
    /**
     * @param {?} idSistema
     * @param {?=} identificador
     * @param {?=} enabled
     * @return {?}
     */
    DownloadDocumento(idSistema, identificador = null, enabled = true) {
        this.SubjectModal = new rxjs__WEBPACK_IMPORTED_MODULE_3__["Subject"]();
        //this.IdInstrucion = idSistema;
        /** @type {?} */
        var objBase64 = this.fileShareService.DownloadDocumento(idSistema, this.IdDialog, this.IdLabel, identificador, enabled);
        this._tittle = "Download Files";
        this._width = "500";
        /** @type {?} */
        var url = `${this.fileShareWeb}/Default.aspx?pagina=FileShareDloadClienteSide&datos=${objBase64}`;
        this._height = "505px";
        this.modelIframeComponent.showModal(url);
        return this.SubjectModal;
    }
    /**
     * @param {?} idSistema
     * @param {?=} identificador
     * @param {?=} enabled
     * @return {?}
     */
    DownloadListDocumento(idSistema, identificador = null, enabled = true) {
        this.SubjectModal = new rxjs__WEBPACK_IMPORTED_MODULE_3__["Subject"]();
        // this.IdInstrucion = idSistema;
        /** @type {?} */
        var objBase64 = this.fileShareService.DownloadDocumentoListIdSistema(idSistema, this.IdDialog, this.IdLabel, identificador, enabled);
        this._tittle = "Download Files";
        this._width = "500";
        /** @type {?} */
        var url = `${this.fileShareWeb}/Default.aspx?pagina=FileShareDloadClienteSide&datos=${objBase64}`;
        this._height = "505px";
        this.modelIframeComponent.showModal(url);
        return this.SubjectModal;
    }
    /**
     * @param {?} userId
     * @param {?} userName
     * @param {?} documentosDtos
     * @param {?} idSistema
     * @param {?} codSistema
     * @param {?=} identificador
     * @param {?=} nombreEmpresa
     * @param {?=} codPaisOperacion
     * @param {?=} datos
     * @param {?=} observacion
     * @param {?=} codPais
     * @param {?=} codOficina
     * @return {?}
     */
    UploadDocumentos(userId, userName, documentosDtos, idSistema, codSistema, identificador = "", nombreEmpresa = "", codPaisOperacion = "", datos = "", observacion = "", codPais = "", codOficina = "") {
        this.IdInstrucion = idSistema;
        this.SubjectModal = new rxjs__WEBPACK_IMPORTED_MODULE_3__["Subject"]();
        /** @type {?} */
        let datosEnvio = this.fileShareService.UploadDocumentos(userId, userName, documentosDtos, idSistema, codSistema, identificador, nombreEmpresa, codPaisOperacion, datos, observacion, codPais, codOficina);
        this._tittle = "Upload Files";
        this._width = "850";
        this._height = "480px";
        this.callHttp
            .httpPost(`${this.fileShareApi}/Api/SyncFolderFilesApi/PostDataRequest`, datosEnvio, { withCredentials: false }) // { withCredentials: false }
            .subscribe((/**
         * @param {?} response
         * @return {?}
         */
        response => {
            if (response !== null) {
                this.fileShareService.Respuestas.push(ResponseFileShare.GetResponseFileShare(idSistema, response.IdFolderRequest));
                this.fileShareService.Respuestas.push();
                /** @type {?} */
                var jsonResult = JSON.stringify(response);
                /** @type {?} */
                var jsonBase64 = btoa(jsonResult);
                /** @type {?} */
                var url = `${this.fileShareWeb}/Default.aspx?pagina=FileShareUploadClientSide&datos=${jsonBase64}`;
                this.modelIframeComponent.showModal(url);
            }
            else {
                this.dialogService.NotificacionAlert("Fileshare: No se pudo obtener respuesta.");
            }
        }), (/**
         * @param {?} error
         * @return {?}
         */
        error => {
            this.dialogService.NotificacionAlert("Fileshare: Error en la comunicación.");
        }));
        return this.SubjectModal;
    }
    /**
     * @param {?} userId
     * @param {?} userName
     * @param {?} idDocumento
     * @param {?} documento
     * @param {?} idSistema
     * @param {?} codSistema
     * @param {?=} identificador
     * @param {?=} nombreEmpresa
     * @param {?=} codPaisOperacion
     * @param {?=} datos
     * @param {?=} observacion
     * @param {?=} codPais
     * @param {?=} codOficina
     * @return {?}
     */
    UploadDocumento(userId, userName, idDocumento, documento, idSistema, codSistema, identificador = "", nombreEmpresa = "", codPaisOperacion = "", datos = "", observacion = "", codPais = "", codOficina = "") {
        this.IdInstrucion = idSistema;
        this.SubjectModal = new rxjs__WEBPACK_IMPORTED_MODULE_3__["Subject"]();
        /** @type {?} */
        var datosEnvio = this.fileShareService.UploadDocumento(userId, userName, idDocumento, documento, idSistema, codSistema, identificador, nombreEmpresa, codPaisOperacion, datos, observacion, codPais, codOficina, this.IdDialog, this.IdLabel);
        this._tittle = "Upload Files";
        this._width = "850px";
        this._height = "480px";
        this.callHttp.httpPost(`${this.fileShareApi}/Api/SyncFolderFilesApi/PostDataRequest`, datosEnvio, { withCredentials: false }) // { withCredentials: false }
            .subscribe((/**
         * @param {?} response
         * @return {?}
         */
        response => {
            if (response !== null) {
                this.fileShareService.Respuestas
                    .push(ResponseFileShare.GetResponseFileShare(idSistema, response.IdFolderRequest));
                this.fileShareService.Respuestas.push();
                /** @type {?} */
                var jsonResult = JSON.stringify(response);
                /** @type {?} */
                var jsonBase64 = btoa(jsonResult);
                /** @type {?} */
                var url = `${this.fileShareWeb}/Default.aspx?pagina=FileShareUploadClientSide&datos=${jsonBase64}`;
                this.modelIframeComponent.showModal(url);
            }
            else {
                this.dialogService.NotificacionAlert("Fileshare: No se pudo obtener respuesta.");
            }
        }), (/**
         * @param {?} error
         * @return {?}
         */
        error => {
            this.dialogService.NotificacionAlert("Fileshare: Error en la comunicación.");
        }));
        return this.SubjectModal;
    }
    /**
     * @param {?} hojaRuta
     * @return {?}
     */
    GetRespuestaUploadDocumento(hojaRuta) {
        return this.fileShareService.GetRespuestaUploadDocumento(hojaRuta);
    }
    /**
     * @param {?} ids
     * @return {?}
     */
    DeleteFile(ids) {
        return this.fileShareService.DeleteFile(ids);
    }
    /**
     * @param {?} ids
     * @return {?}
     */
    UpdateIdentificadorFolderFiles(ids) {
        return this.fileShareService.UpdateIdentificadorFolderFiles(ids);
    }
    /**
     * @param {?} id
     * @return {?}
     */
    GetUrlFolderFile(id) {
        return this.fileShareService.GetUrlFolderFile(id);
    }
    /**
     * @param {?} id
     * @return {?}
     */
    GetUrlFolderFileDownload(id) {
        this.fileShareService.GetUrlFolderFileDownload(id).subscribe((/**
         * @param {?} response
         * @return {?}
         */
        response => {
            this.callHttp.httpGetFile(response.Url, response.FileName, { withCredentials: false }).subscribe((/**
             * @return {?}
             */
            () => { }), (/**
             * @param {?} error
             * @return {?}
             */
            error => {
                this.dialogService.NotificacionAlert(`FileShare error: ${error}`);
            }));
        }), (/**
         * @param {?} error
         * @return {?}
         */
        error => {
            this.dialogService.NotificacionAlert(`FileShare error: ${error}`);
        }));
    }
    /**
     * @param {?} idSistema
     * @param {?} identificador
     * @return {?}
     */
    GetUrlFolderFileDownloadIdentificador(idSistema, identificador) {
        this.fileShareService.GetUrlFolderFileDownloadIdentificador(idSistema, identificador).subscribe((/**
         * @param {?} response
         * @return {?}
         */
        response => {
            this.callHttp.httpGetFile(response.Url, response.FileName, { withCredentials: false }).subscribe((/**
             * @return {?}
             */
            () => { }), (/**
             * @param {?} error
             * @return {?}
             */
            error => {
                this.dialogService.NotificacionAlert(`FileShare error: ${error}`);
            }));
        }), (/**
         * @param {?} error
         * @return {?}
         */
        error => {
            this.dialogService.NotificacionAlert(`FileShare error: ${error}`);
        }));
    }
}
FileshareComponent.decorators = [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"], args: [{
                //
                selector: 'fileshare',
                template: `<modal-iframe-template [tittle]="tittle" [width-modal]="'850px'" [height-modal]="height" (close)="Close()"></modal-iframe-template>`
            }] }
];
/** @nocollapse */
FileshareComponent.ctorParameters = () => [
    { type: FileshareService },
    { type: vesta__WEBPACK_IMPORTED_MODULE_2__["DialogService"] },
    { type: vesta__WEBPACK_IMPORTED_MODULE_2__["CallHttp"] },
    { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [FILESHARE_WEB,] }] },
    { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [FILESHARE_API,] }] }
];
FileshareComponent.propDecorators = {
    modelIframeComponent: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"], args: [modal_iframe__WEBPACK_IMPORTED_MODULE_5__["ModalIframeComponent"], { static: false },] }]
};
if (false) {}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/view-fileshare/view-fileshare.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ViewFileshareComponent {
    /**
     * @param {?} fileShareService
     * @param {?} sanitizer
     */
    constructor(fileShareService, sanitizer) {
        this.fileShareService = fileShareService;
        this.sanitizer = sanitizer;
        this._Url = this.sanitizer.bypassSecurityTrustUrl(null);
    }
    /**
     * @return {?}
     */
    get Url() {
        return this._Url;
    }
    /**
     * @return {?}
     */
    get MimeType() {
        return this._mimeType;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.Documentos == null)
            this.Documentos = [];
        this._Url = this.sanitizer.bypassSecurityTrustResourceUrl("about:blank");
    }
    /**
     * @param {?} item
     * @return {?}
     */
    ViewDocumentos(item) {
        if (item == null) {
            this._Url = this.sanitizer.bypassSecurityTrustResourceUrl("about:blank");
            return void 0;
        }
        if (item.Id == 0)
            return void 0;
        this.fileShareService.GetUrlFolderFileDownload(item.Id).subscribe((/**
         * @param {?} response
         * @return {?}
         */
        response => {
            this._mimeType = response.MimeType;
            let [tipo] = response.MimeType.split('/');
            /** @type {?} */
            let encode = encodeURIComponent(response.Url);
            //let url = (tipo == 'image') ? response.Url : `https://docs.google.com/gview?url=${encode}&embedded=true`;
            /** @type {?} */
            let url = response.Url;
            this._Url = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        }));
    }
    /**
     * @return {?}
     */
    ShowModal() {
        /** @type {?} */
        let promise = new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            this.modal.showModal().subscribe((/**
             * @param {?} rseponse
             * @return {?}
             */
            rseponse => {
                this._Url = this.sanitizer.bypassSecurityTrustResourceUrl("about:blank");
                resolve(true);
            }));
        }));
        return promise;
    }
}
ViewFileshareComponent.decorators = [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"], args: [{
                selector: 'view-fileshare',
                template: "<modal-template #modalTemplate [width-modal]=\"'90%'\" [height-modal]=\"'70vh'\" [isContentDinamico]=\"false\">\r\n  <div class=\"grid\">\r\n    <div class=\"row cells4\">\r\n      <div class=\"cell colspan2\">\r\n        <ng-select class=\"custom\" [items]=\"Documentos\" bindLabel=\"Descripcion\" (change)=\"ViewDocumentos($event)\"\r\n                   placeholder=\"Seleccione...\"></ng-select>\r\n      </div>\r\n    </div>\r\n    <div class=\"row cell\">\r\n      <iframe [src]=\"Url\" height=\"63vh\" width=\"100%\" style=\"height: 63vh; width: 100%\"></iframe>\r\n    </div>\r\n  </div>\r\n</modal-template>`\r\n",
                styles: [""]
            }] }
];
/** @nocollapse */
ViewFileshareComponent.ctorParameters = () => [
    { type: FileshareService },
    { type: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_7__["DomSanitizer"] }
];
ViewFileshareComponent.propDecorators = {
    Documentos: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"], args: ['documentos',] }],
    modal: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"], args: ['modalTemplate', { static: false },] }]
};
if (false) {}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/view-fileshare-content/view-fileshare-content.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ViewFileshareContentComponent {
    /**
     * @param {?} fileShareService
     * @param {?} sanitizer
     */
    constructor(fileShareService, sanitizer) {
        this.fileShareService = fileShareService;
        this.sanitizer = sanitizer;
        this._Url = this.sanitizer.bypassSecurityTrustUrl(null);
    }
    /**
     * @return {?}
     */
    get Url() {
        return this._Url;
    }
    /**
     * @return {?}
     */
    get MimeType() {
        return this._mimeType;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.Documentos == null)
            this.Documentos = [];
        this._Url = this.sanitizer.bypassSecurityTrustResourceUrl("about:blank");
        if (this.isContentDinamico == null || this.isContentDinamico == undefined)
            this.isContentDinamico = true;
    }
    /**
     * @param {?} item
     * @return {?}
     */
    ViewDocumentos(item) {
        if (item == null) {
            this._Url = this.sanitizer.bypassSecurityTrustResourceUrl("about:blank");
            return void 0;
        }
        if (item.Id == 0)
            return void 0;
        this.fileShareService.GetUrlFolderFileDownload(item.Id).subscribe((/**
         * @param {?} response
         * @return {?}
         */
        response => {
            this._mimeType = response.MimeType;
            let [tipo] = response.MimeType.split('/');
            /** @type {?} */
            let encode = encodeURIComponent(response.Url);
            /** @type {?} */
            let url = response.Url;
            //let url = (tipo == 'image') ? response.Url : `https://docs.google.com/gview?url=${encode}&embedded=true`;
            this._Url = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        }));
    }
    /**
     * @return {?}
     */
    ShowModal() {
        this.modal.showModal().subscribe((/**
         * @param {?} rseponse
         * @return {?}
         */
        rseponse => {
            this._Url = this.sanitizer.bypassSecurityTrustResourceUrl("about:blank");
        }));
    }
    /**
     * @return {?}
     */
    CloseModal() {
        this.modal.closeModal();
    }
}
ViewFileshareContentComponent.decorators = [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"], args: [{
                selector: 'view-fileshare-content',
                template: "<modal-template #modalTemplate [width-modal]=\"'90%'\" [height-modal]=\"'70vh'\" [isContentDinamico]=\"false\">\r\n  <div class=\"grid\">\r\n    <div class=\"row cells4\">\r\n      <div class=\"cell colspan2\">\r\n        <ng-select class=\"custom\" [items]=\"Documentos\" bindLabel=\"Descripcion\" (change)=\"ViewDocumentos($event)\"\r\n                   placeholder=\"Seleccione...\"></ng-select>\r\n      </div>\r\n    </div>\r\n    <div class=\"row cells3\">\r\n      <div class=\"cell colspan2\">\r\n        <iframe [src]=\"Url\" height=\"63vh\" width=\"100%\" style=\"height: 63vh; width: 100%\"></iframe>\r\n      </div>\r\n      <div class=\"cell\" style=\"max-height:63vh;\">\r\n        <div [ngClass]=\"{'contentDialog': isContentDinamico }\" style=\"height:63vh;\">\r\n          <ng-content class=\"contentDinamico\"></ng-content>\r\n        </div>        \r\n      </div>\r\n    </div>\r\n  </div>\r\n</modal-template>\r\n",
                styles: [".contentDinamicoHeader .contentDinamico{border:0;width:100%;overflow-y:scroll;overflow-x:auto;overflow-wrap:normal}"]
            }] }
];
/** @nocollapse */
ViewFileshareContentComponent.ctorParameters = () => [
    { type: FileshareService },
    { type: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_7__["DomSanitizer"] }
];
ViewFileshareContentComponent.propDecorators = {
    isContentDinamico: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"], args: ['isContentDinamico',] }],
    Documentos: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"], args: ['documentos',] }],
    modal: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"], args: ['modalTemplate', { static: false },] }]
};
if (false) {}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/view-fileshare-compare/view-fileshare-compare.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ViewFileshareCompareComponent {
    /**
     * @param {?} fileShareService
     * @param {?} sanitizer
     */
    constructor(fileShareService, sanitizer) {
        this.fileShareService = fileShareService;
        this.sanitizer = sanitizer;
        this._Url = this.sanitizer.bypassSecurityTrustUrl(null);
        this._Url2 = this.sanitizer.bypassSecurityTrustUrl(null);
    }
    /**
     * @return {?}
     */
    get Url() {
        return this._Url;
    }
    /**
     * @return {?}
     */
    get Url2() {
        return this._Url2;
    }
    /**
     * @return {?}
     */
    get MimeType() {
        return this._mimeType;
    }
    /**
     * @return {?}
     */
    get MimeType2() {
        return this._mimeType2;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.Documentos == null)
            this.Documentos = [];
        this._Url = this.sanitizer.bypassSecurityTrustResourceUrl("about:blank");
        if (this.isContentDinamico == null || this.isContentDinamico == undefined)
            this.isContentDinamico = true;
    }
    /**
     * @param {?} item
     * @param {?} item2
     * @return {?}
     */
    ViewDocumentos(item, item2) {
        if (item == null) {
            this._Url = this.sanitizer.bypassSecurityTrustResourceUrl("about:blank");
            //return void 0;
        }
        if (item2 == null) {
            this._Url2 = this.sanitizer.bypassSecurityTrustResourceUrl("about:blank");
            //return void 0;
        }
        if (item.Id == 0)
            return void 0;
        this.fileShareService.GetUrlFolderFileDownload(item.Id).subscribe((/**
         * @param {?} response
         * @return {?}
         */
        response => {
            this._mimeType = response.MimeType == 'application/unknown' ? 'application/pdf' : response.MimeType;
            let [tipo] = response.MimeType.split('/');
            /** @type {?} */
            let encode = encodeURIComponent(response.Url);
            /** @type {?} */
            let url = (tipo == 'image' || this._mimeType == 'application/pdf') ? response.Url : `https://docs.google.com/gview?url=${encode}&embedded=true`;
            this._Url = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        }));
        if (item2 != null && item2.Id != 0) {
            this.fileShareService.GetUrlFolderFileDownload(item2.Id).subscribe((/**
             * @param {?} response
             * @return {?}
             */
            response => {
                //this._mimeType2 = response.MimeType;
                this._mimeType2 = response.MimeType == 'application/unknown' ? 'application/pdf' : response.MimeType;
                let [tipo] = this._mimeType.split('/');
                /** @type {?} */
                let encode = encodeURIComponent(response.Url);
                /** @type {?} */
                let url = (tipo == 'image' || this._mimeType2 == 'application/pdf') ? response.Url : `https://docs.google.com/gview?url=${encode}&embedded=true`;
                this._Url2 = this.sanitizer.bypassSecurityTrustResourceUrl(url);
            }));
        }
    }
    /**
     * @return {?}
     */
    ShowModal() {
        this.modal.showModal().subscribe((/**
         * @param {?} rseponse
         * @return {?}
         */
        rseponse => {
            this._Url = this.sanitizer.bypassSecurityTrustResourceUrl("about:blank");
            this._Url2 = this.sanitizer.bypassSecurityTrustResourceUrl("about:blank");
        }));
    }
    /**
     * @return {?}
     */
    CloseModal() {
        this.modal.closeModal();
    }
}
ViewFileshareCompareComponent.decorators = [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"], args: [{
                selector: 'view-fileshare-compare',
                template: "<modal-template #modalTemplate [width-modal]=\"'95%'\" [height-modal]=\"'70vh'\" [isContentDinamico]=\"false\">\r\n  <div class=\"grid\">\r\n    <div class=\"row cells5\">\r\n      <div class=\"cell colspan2\">\r\n        <iframe [src]=\"Url\" height=\"63vh\" width=\"100%\" style=\"height: 63vh; width: 100%\"></iframe>\r\n      </div>\r\n      <div class=\"cell\" style=\"max-height:63vh;\">\r\n        <div [ngClass]=\"{'contentDialog': isContentDinamico }\" style=\"height:63vh;\">\r\n          <ng-content class=\"contentDinamico\"></ng-content>\r\n        </div>\r\n      </div>\r\n      <div class=\"cell colspan2\">\r\n        <iframe [src]=\"Url2\" height=\"63vh\" width=\"100%\" style=\"height: 63vh; width: 100%\"></iframe>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</modal-template>\r\n",
                styles: [""]
            }] }
];
/** @nocollapse */
ViewFileshareCompareComponent.ctorParameters = () => [
    { type: FileshareService },
    { type: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_7__["DomSanitizer"] }
];
ViewFileshareCompareComponent.propDecorators = {
    isContentDinamico: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"], args: ['isContentDinamico',] }],
    Documentos: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"], args: ['documentos',] }],
    modal: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"], args: ['modalTemplate', { static: false },] }]
};
if (false) {}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/fileshare-multiple/fileshare-multiple.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FileshareMultipleComponent {
    /**
     * @param {?} fileShareService
     * @param {?} fb
     */
    constructor(fileShareService, fb) {
        this.fileShareService = fileShareService;
        this.fb = fb;
        this.out = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
        this.close = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
        this.click = false;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.InitFormulario();
    }
    /**
     * @return {?}
     */
    ngOnChanges() {
        //this.InitData();
    }
    /**
     * @return {?}
     */
    ngAfterContentInit() {
        //this.InitData();
    }
    /**
     * @return {?}
     */
    InitData() {
        this.data.Documentos.forEach((/**
         * @param {?} f
         * @return {?}
         */
        f => {
            this.addDocumentosFormulario(f.IdDocumento, f.Documento);
        }));
    }
    /**
     * @return {?}
     */
    InitFormulario() {
        this.myForm = this.fb.group({
            Documentos: this.fb.array([])
        });
    }
    /**
     * @return {?}
     */
    get documentosFormulario() {
        if (this.myForm == null)
            return null;
        return (/** @type {?} */ (this.myForm.get('Documentos')));
    }
    /**
     * @param {?} id
     * @param {?} nombreDocumento
     * @return {?}
     */
    addDocumentosFormulario(id, nombreDocumento) {
        /** @type {?} */
        let documento = this.fb.group({
            Id: [id],
            NombreDocumento: [nombreDocumento],
            NumeroReferencia: [null],
            File: [null]
        });
        if (this.documentosFormulario != null) {
            this.documentosFormulario.push(documento);
            documento.get('NumeroReferencia').valueChanges.subscribe((/**
             * @param {?} res
             * @return {?}
             */
            res => {
                if (res != null && res != '') {
                    if (documento.get('File').value == null) {
                        documento.get('File').enable({ onlySelf: true, emitEvent: false });
                        documento.get('File').setValidators([_angular_forms__WEBPACK_IMPORTED_MODULE_10__["Validators"].required]);
                    }
                }
                else {
                    documento.get('File').setValidators(null);
                    documento.get('File').disable({ onlySelf: true, emitEvent: false });
                }
                documento.get('File').updateValueAndValidity({ emitEvent: false });
            }));
            documento.get('File').disable({ onlySelf: true, emitEvent: false });
            //documento.get('File').valueChanges.subscribe(res => {
            //  if (res != null) {
            //    documento.get('NumeroReferencia').setValidators([Validators.required])
            //  } else {
            //    documento.get('NumeroReferencia').setValidators(null);
            //  }
            //  documento.get('NumeroReferencia').updateValueAndValidity({ emitEvent: false });
            //})
        }
        ;
    }
    /**
     * @param {?} index
     * @return {?}
     */
    getFile(index) {
        //console.log(this.documentosFormulario.at(index).get('File'));
        if (this.documentosFormulario.at(index).get('File').disabled)
            return;
        document.getElementById(`upload${index}`).click();
    }
    /**
     * @param {?} event
     * @param {?} index
     * @return {?}
     */
    uploadChangeFile(event, index) {
        if (event.target.files.length > 0) {
            const [file] = event.target.files;
            this.documentosFormulario.at(index).patchValue({ File: file });
        }
    }
    /**
     * @return {?}
     */
    ViewDocumentos() {
        this.InitData();
        this.myModal.showModal().subscribe((/**
         * @param {?} response
         * @return {?}
         */
        response => {
            this.InitFormulario();
            this.close.emit();
        }));
    }
    /**
     * @return {?}
     */
    SaveDocumentos() {
        this.click = true;
        if (!this.myForm.valid) {
            return void 0;
        }
        /** @type {?} */
        let documentos = this.myForm.getRawValue();
        /** @type {?} */
        let documentosBlob = documentos.Documentos.filter((/**
         * @param {?} f
         * @return {?}
         */
        f => f.File != null)).map((/**
         * @param {?} m
         * @return {?}
         */
        m => {
            /** @type {?} */
            let extension = ((/** @type {?} */ (m.File.name))).split('.').pop();
            return DocumentoBlob.getDocumentosBlob(m.File, m.NumeroReferencia, m.File.name, extension, m.Id, m.NombreDocumento);
        }));
        this.fileShareService.UploadDocumentoListBlob(this.data.UserId, this.data.UserName, this.data.IdSistema, this.data.CodigoSistema, documentosBlob, this.data.Identificador, this.data.NombreEmpresa, this.data.CodPaisOperacion, this.data.Datos, this.data.Observacion, this.data.CodPais, this.data.CodOficina).subscribe((/**
         * @param {?} event
         * @return {?}
         */
        event => {
            if (event.Event) {
                let [progress] = this.progress.filter((/**
                 * @param {?} _
                 * @param {?} i
                 * @return {?}
                 */
                (_, i) => i == event.Data.Index));
                /** @type {?} */
                let pbTemp = $(progress.nativeElement);
                /** @type {?} */
                let pb = pbTemp.data('progress');
                pb.set(event.Data.Progress);
            }
            else {
                this.out.emit(event.Data);
                //this.myForm.reset(this.fb.array([]), { onlySelf: true } );
                this.click = false;
                this.myModal.closeModal();
            }
        }));
    }
}
FileshareMultipleComponent.decorators = [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"], args: [{
                selector: 'fileshare-multiple',
                template: "<modal-template #modalTemplate [width-modal]=\"'60%'\" [height-modal]=\"'70vh'\" [isContentDinamico]=\"false\">\r\n  <div [formGroup]=\"myForm\">\r\n    <div class=\"grid\" formArrayName=\"Documentos\">\r\n      <div class=\"row cells7\" *ngFor=\"let control of documentosFormulario.controls; let i = index\" [formGroupName]=\"i\">\r\n        <div class=\"cell colspan3\">\r\n          <div class=\"input-control text full-size\">\r\n            <input type=\"text\" readonly formControlName=\"NombreDocumento\" />\r\n          </div>\r\n        </div>\r\n        <div class=\"cell colspan2\">\r\n\r\n          <div class=\"input-control text full-size\">\r\n            <input type=\"text\" formControlName=\"NumeroReferencia\" placeholder=\"Numero de referencia\" />\r\n          </div>\r\n          <span style=\"margin: 0; position: absolute; top: 50%; -ms-transform: translateY(-50%); transform: translateY(-50%);\" *ngIf=\"!control.controls.NumeroReferencia.valid && click\" class=\"invalid_feedback float-right\">*</span>\r\n        </div>\r\n        <div class=\"cell align-center\">\r\n          <div class=\"row cell\">\r\n            <button class=\"yourBtn buttonGridAuto\" (click)=\"getFile(i)\">\r\n              <img *ngIf=\"control.controls.File.disabled\"  style=\"opacity:0.5\" src=\"assets/icons/up-green.png\" />\r\n              <img *ngIf=\"!control.controls.File.valid && !control.controls.File.disabled\" src=\"assets/icons/up-yellow.png\" />\r\n              <img *ngIf=\"control.controls.File.valid && control.controls.File.value != null\" src=\"assets/icons/up-green.png\" />\r\n            </button>\r\n          </div>\r\n          <div class=\"row cell\" style=\"margin: 0; position: absolute; top: 50%; -ms-transform: translateY(-50%); transform: translateY(-50%);\">\r\n            <span *ngIf=\"!control.controls.File.valid && !control.controls.File.disabled && click\" class=\"invalid_feedback float-right\">*</span>\r\n          </div>\r\n          \r\n          \r\n\r\n          <div style='height: 0px;width: 0px; overflow:hidden;'>\r\n            <input id=\"upload{{i}}\" type=\"file\" value=\"upload\" (change)=\"uploadChangeFile($event, i)\" />\r\n          </div>\r\n        </div>\r\n        <div class=\"cell\">\r\n          <div #progressView [attr.data-role]=\"'progress'\" class=\"progress small\" \r\n              data-colors='{\"bg-red\": 33,\"bg-yellow\":66,\"bg-cyan\": 90,\"bg-green\": 100 }'></div>\r\n        </div>\r\n      </div>\r\n      <div class=\"row cell\">\r\n        <span *ngIf=\"!myForm.valid && click\" class=\"invalid_feedback float-right\">* Campos obligatarios</span>\r\n      </div>\r\n      <div class=\"row cells12\">\r\n        <div class=\"cell offset11\">\r\n          <button (click)=\"SaveDocumentos()\"><img src=\"assets/icons/save.png\" /></button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</modal-template>\r\n",
                styles: [".btnFile{position:relative;top:150px;font-family:calibri;width:150px;padding:10px;-webkit-border-radius:5px;-moz-border-radius:5px;border:1px dashed #bbb;text-align:center;background-color:#ddd;cursor:pointer}"]
            }] }
];
/** @nocollapse */
FileshareMultipleComponent.ctorParameters = () => [
    { type: FileshareService },
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_10__["FormBuilder"] }
];
FileshareMultipleComponent.propDecorators = {
    data: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"], args: ['data',] }],
    myModal: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"], args: ['modalTemplate', { static: false },] }],
    progress: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChildren"], args: ['progressView',] }],
    out: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"], args: ['response',] }],
    close: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"], args: ['close',] }]
};
if (false) {}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/fileshare.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
let Params = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["InjectionToken"]('Params');
/**
 * @param {?} settings
 * @return {?}
 */
function InitWeb(settings) {
    /** @type {?} */
    let direccion = EnumDireccionesFileShare.FileShareWeb;
    if (settings.Https)
        direccion = EnumDireccionesFileShare.FileShareWebHttps;
    let [direccionWeb] = DireccionesFileShare.filter((/**
     * @param {?} f
     * @return {?}
     */
    f => f.Nombre == direccion));
    return direccionWeb.Direccion;
}
/**
 * @param {?} settings
 * @return {?}
 */
function InitApi(settings) {
    /** @type {?} */
    let direccion = EnumDireccionesFileShare.FileShareWebApi;
    if (settings.Https)
        direccion = EnumDireccionesFileShare.FileShareWebApiHttps;
    let [direccionApi] = DireccionesFileShare.filter((/**
     * @param {?} f
     * @return {?}
     */
    f => f.Nombre == direccion));
    return direccionApi.Direccion;
}
class FileshareModule {
    /**
     * @param {?=} settings
     * @return {?}
     */
    static forRoot(settings = { Https: false }) {
        return {
            ngModule: FileshareModule,
            providers: [
                { provide: Params, useValue: settings },
                { provide: FILESHARE_WEB, useFactory: InitWeb, deps: [Params] },
                { provide: FILESHARE_API, useFactory: InitApi, deps: [Params] }
            ]
        };
    }
}
FileshareModule.decorators = [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"], args: [{
                declarations: [FileshareComponent, ViewFileshareComponent, ViewFileshareContentComponent, ViewFileshareCompareComponent, FileshareMultipleComponent],
                imports: [
                    _angular_common__WEBPACK_IMPORTED_MODULE_6__["CommonModule"], modal_iframe__WEBPACK_IMPORTED_MODULE_5__["ModalIframeModule"], _ng_select_ng_select__WEBPACK_IMPORTED_MODULE_9__["NgSelectModule"], modal__WEBPACK_IMPORTED_MODULE_8__["ModalModule"], _angular_forms__WEBPACK_IMPORTED_MODULE_10__["ReactiveFormsModule"]
                ],
                exports: [FileshareComponent, ViewFileshareComponent, ViewFileshareContentComponent, ViewFileshareCompareComponent, FileshareMultipleComponent],
                bootstrap: [FileshareComponent],
                providers: [FileshareService]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: fileshare.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */


//# sourceMappingURL=fileshare.js.map


/***/ }),

/***/ "./dist-library/modal-iframe/fesm2015/modal-iframe.js":
/*!************************************************************!*\
  !*** ./dist-library/modal-iframe/fesm2015/modal-iframe.js ***!
  \************************************************************/
/*! exports provided: ModalIframeComponent, ModalIframeModule, ModalIframeService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ModalIframeComponent", function() { return ModalIframeComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ModalIframeModule", function() { return ModalIframeModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ModalIframeService", function() { return ModalIframeService; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");




/**
 * @fileoverview added by tsickle
 * Generated from: lib/modal-iframe.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ModalIframeService {
    constructor() {
        this.CargarNuevo = (/**
         * @param {?} direccion
         * @param {?} titulo
         * @param {?=} height
         * @param {?=} id
         * @param {?=} idLabel
         * @return {?}
         */
        (direccion, titulo, height = "477", id = "dialog", idLabel = "headerTextFileShare") => {
            // $("#dialog").attr("data-width", width);
            $(".contentDialog").css("height", height + "px");
            $(`#${id} iframe`).attr("src", direccion);
            //this.router.navigateByUrl("digitalizacion");
            $(`#${idLabel}`).html(titulo);
        });
    }
    /**
     * @param {?=} id
     * @return {?}
     */
    CloseModal(id = "dialog") {
        /** @type {?} */
        var dialog = $(`#${id}`).data('dialog');
        $(`#${id} iframe`).attr("src", "about:blank");
        dialog.close();
    }
    /**
     * @param {?=} id
     * @return {?}
     */
    ShowModal(id = "dialog") {
        //toggleMetroDialog("#dialog");
        metroDialog.toggle(`#${id}`);
    }
}
ModalIframeService.decorators = [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"] }
];
/** @nocollapse */
ModalIframeService.ctorParameters = () => [];
if (false) {}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modal-iframe.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var chance = __webpack_require__(/*! chance */ "./node_modules/chance/chance.js").Chance();
class ModalIframeComponent {
    /**
     * @param {?} sanitizer
     */
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
        this.close = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
        this.closeModal = (/**
         * @return {?}
         */
        () => {
            /** @type {?} */
            var dialog = $(`#${this.id}`).data('dialog');
            this.url = this.sanitizer.bypassSecurityTrustResourceUrl("about:blank");
            this.close.emit();
            dialog.close();
            /** @type {?} */
            let controls = (/** @type {?} */ ($(".searchModal")));
            /** @type {?} */
            let elementos = null;
            for (let item of controls) {
                /** @type {?} */
                let visible = $(item).css("visibility");
                if (visible == "visible") {
                    elementos = visible;
                }
            }
            //let elementos = $(".searchModal").css("visibility");
            if (elementos != "visible") {
                $(`body`).css("overflow-y", "auto");
                //setTimeout(() => {
                //   // $(window).scrollTop(window["scrollLast"]);
                //}, 3)
            }
        });
        this.showModal = (/**
         * @param {?} direccion
         * @param {?=} contentDinamico
         * @return {?}
         */
        (direccion, contentDinamico = false) => {
            $(`#${this.idContent}`).css("height", this.height);
            this.url = this.sanitizer.bypassSecurityTrustResourceUrl(direccion);
            //if (window["scrollLast"] == 0 || window["scrollLast"] == undefined) {
            //    window["scrollLast"] = $("body").scrollTop();
            //}
            $("body").css("overflow-y", "hidden");
            metroDialog.toggle(`#${this.id}`);
        });
        this.getIdClass = (/**
         * @return {?}
         */
        () => {
            this.id = chance.guid();
            this.idIframe = chance.guid();
            this.idContent = chance.guid();
        });
    }
    /**
     * @return {?}
     */
    get isContentDinamico() {
        return this._isContentDinamico;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.getIdClass();
        this.opDark = "op-dark";
        this._isContentDinamico = false;
        this.url = this.sanitizer.bypassSecurityTrustResourceUrl("about:blank");
        if (this.height == undefined || this.height == null) {
            this.height = "500px";
        }
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        $(`#${this.id}`).attr("data-role", "dialog"); //draggable
        //$(`#${this.id}`).attr("data-place", "top-center");
    }
}
ModalIframeComponent.decorators = [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{
                selector: 'modal-iframe-template',
                template: `
<div style="border: 2px solid;z-index: 1999 !important;" data-role="dialog" [attr.id]="id" class="grid searchModal" [attr.data-overlay]="true" 
  [attr.data-background]="'#fefefe'" [attr.data-close-button]="false" [attr.data-width]="width" [attr.data-overlay]="true" 
  [attr.data-overlay-click-close]="false" [attr.data-overlay-color]="opDark">
      <div class="headerDialog flex-grid">
          <div class="row cells12">
              <div class="sub-header cell colspan10 modalHeaderVesta">
                  <label id="headerText">{{tittle}}</label>
              </div>
              <div class="cell colspan2 modalHeaderVesta">
                  <img (click)="closeModal()" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAA3NCSVQICAjb4U/gAAAACXBIWXMAAADdAAAA3QFwU6IHAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAQtQTFRF////JJLbIIC/IIDKH4XMHILMH4XOH4PPHoTOHoXOHoTOH4XPIITOH4XOH4TNH4TOH4TOH4TOJYfPOJHTOZLUSZrWS5zYZanaaa3edrLdfbjjjLzgjb7hjb7ilsXomMfpsM/mudbswdjpw97y0eDs2eTt2er32uXt2+Xt3Obt3ebt3ebu3efu393l3+jw4d/l4erw4urw48zV5cfQ5e/36O7z6O/z6e/06vD07PT67fL27/b88fX48vX58/b59I+d9Y2b9e3w9ff69fj69oqY9vn79/n7+Pr7+fv8+tzh+3aG+9fc+/3+/I6b/JKf/JSh/f7+/f7//tnd/t/j/v7+/v7///T1//7/////THgr+QAAABF0Uk5TAAcIGBktSYSXmMHI2uPy8/XVqDFbAAAB2klEQVQ4jYVT11YCQQxdEOlVOiIgfaUjRQXpiiwoRcH8/5eYZNgF9HjIw0Bys8nNnYwkaaYzWqx2l8tutRh10l8zmJ0ezZxmwy9Yb3J7Tsxt0h/jFzbPH7NdHPBLB4e8wetEOp24DnrZdVxq3zN+Fc3L8l2tdifL+egVZ+xr6Lm+Pym3utMtwHbabclJP3cRPEz0P5ypvoJmr9VMmKImno/4+3NPWziy7VOOarhpWjP1T3YBvjefAv3cfAN0k8TDjPqRPtEm4h+KstwB7JaK8oEZzSgpppOMNF95BbBR0N53u3f63QCsyjStUbLgGXzBwjOFMxhXZhh4CSJkkax43lDnXl/RrN+jyA1CVsmO5y25X5WJik8qXxS5RcguufBsMPlxaZ8xKY050EDIxQmPYryhmjAU/iMnUIsU+4K/mIUDKW5BJGPsLw8klxyIMUkaM8T6ifKiDWsa4jFJKN8a3bngJ5jOMbD2sVAsdRz95wHOXxqPS6jH4BkDcSG1uKwsSlu8rxdGAKNC/b6I0mf3lyWuO7AAmLYf3qj120N7CrAIqNctFiaygBNbRLSF2a9cIHuMZwNHK6cubXytwuv4ydJqa+8LxVKdTioW8v1a+/MP5/zTO/94/3/+Px4gl/0Dnu+pAAAAAElFTkSuQmCC" />
              </div>
          </div>
      </div>
      <div style="margin:5px;" [ngClass]="{'contentDialog': isContentDinamico }" >
          <div [attr.id]="idContent" class="contentDinamico" [ngStyle]="{'height': height}">
              <iframe [src]="url" [height]="height" width="100%" ></iframe>
          </div>        
      </div>    
  </div>
  `
            }] }
];
/** @nocollapse */
ModalIframeComponent.ctorParameters = () => [
    { type: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__["DomSanitizer"] }
];
ModalIframeComponent.propDecorators = {
    close: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"], args: ["close",] }],
    tittle: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ["tittle",] }],
    width: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ["width-modal",] }],
    height: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ["height-modal",] }]
};
if (false) {}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modal-iframe.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ModalIframeModule {
}
ModalIframeModule.decorators = [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"], args: [{
                declarations: [ModalIframeComponent],
                imports: [_angular_common__WEBPACK_IMPORTED_MODULE_2__["CommonModule"]],
                exports: [ModalIframeComponent]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: modal-iframe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */


//# sourceMappingURL=modal-iframe.js.map


/***/ }),

/***/ "./dist-library/modal/fesm2015/modal.js":
/*!**********************************************!*\
  !*** ./dist-library/modal/fesm2015/modal.js ***!
  \**********************************************/
/*! exports provided: ModalComponent, ModalModule, ModalService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ModalComponent", function() { return ModalComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ModalModule", function() { return ModalModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ModalService", function() { return ModalService; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");




/**
 * @fileoverview added by tsickle
 * Generated from: lib/modal.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ModalService {
    /**
     * @param {?} idModal
     * @param {?=} titulo
     * @return {?}
     */
    ShowModal(idModal, titulo = "") {
        metroDialog.toggle("#" + idModal);
        $(".headerDialog label").html(titulo);
    }
    /**
     * @param {?} idModal
     * @return {?}
     */
    CloseModal(idModal) {
        /** @type {?} */
        var dialog = $("#" + idModal).data('dialog');
        dialog.close();
    }
}
ModalService.decorators = [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"], args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */ ModalService.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵdefineInjectable"])({ factory: function ModalService_Factory() { return new ModalService(); }, token: ModalService, providedIn: "root" });

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modal.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var chance = __webpack_require__(/*! chance */ "./node_modules/chance/chance.js").Chance();
class ModalComponent {
    constructor() {
        this.closeModal = (/**
         * @param {?=} response
         * @return {?}
         */
        (response = true) => {
            /** @type {?} */
            var dialog = $(`#${this.id}`).data("dialog");
            dialog.close();
            /** @type {?} */
            let controls = (/** @type {?} */ ($(".searchModal")));
            /** @type {?} */
            let elementos = null;
            for (let item of controls) {
                /** @type {?} */
                let visible = $(item).css("visibility");
                if (visible == "visible") {
                    elementos = visible;
                }
            }
            //let elementos = $(".searchModal").css("visibility");
            if (elementos != "visible") {
                $(`body`).css("overflow-y", "auto");
            }
            this._Response.next(response);
        });
        this.CloseModalFunction = (/**
         * @param {?=} response
         * @return {?}
         */
        (response = true) => {
            this.closeModal(response);
        });
        this.showModal = (/**
         * @param {?=} place
         * @return {?}
         */
        (place = "default") => {
            //this._isContentDinamico = contentDinamico;
            $(`#${this.id}`).css("width", this.width);
            metroDialog.toggle(`#${this.id}`, place);
            $("body").css("overflow-y", "hidden");
            this._Response = new rxjs__WEBPACK_IMPORTED_MODULE_1__["Subject"]();
            return this._Response;
        });
        this.getIdClass = (/**
         * @return {?}
         */
        () => {
            this._id = chance.guid();
            this._idContent = chance.guid();
        });
    }
    //get isContentDinamico() {
    //  return this._isContentDinamico;
    //}
    /**
     * @return {?}
     */
    get id() {
        return this._id;
    }
    /**
     * @return {?}
     */
    get idContent() {
        return this._idContent;
    }
    /**
     * @return {?}
     */
    get opDark() {
        return this._opDark;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.getIdClass();
        this._opDark = "op-dark";
        //this._isContentDinamico = true;
        if (this.height == undefined || this.height == null) {
            this.height = "500px";
        }
        if (this.isContentDinamico == null || this.isContentDinamico == undefined)
            this.isContentDinamico = true;
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        if (this.draggable) {
            $(`#${this.id}`).attr("data-role", "dialog, draggable"); // draggable
        }
    }
}
ModalComponent.decorators = [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{
                selector: 'modal-template',
                template: `
<div style="border: 2px solid;z-index: 1999 !important;" data-role="dialog" [attr.id]="id" class="grid searchModal" [attr.data-overlay]="true" 
[attr.data-background]="'#fefefe'" [attr.data-close-button]="false" [attr.data-width]="width" [attr.data-overlay]="true" 
[attr.data-overlay-click-close]="false" [attr.data-overlay-color]="opDark">
    <div class="headerDialog flex-grid">
        <div class="row cells12">
            <div class="sub-header cell colspan10 modalHeaderVesta">
                <label>{{tittle}}</label>
            </div>
            <div class="cell colspan2 modalHeaderVesta">
                <img (click)="closeModal()" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAA3NCSVQICAjb4U/gAAAACXBIWXMAAADdAAAA3QFwU6IHAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAQtQTFRF////JJLbIIC/IIDKH4XMHILMH4XOH4PPHoTOHoXOHoTOH4XPIITOH4XOH4TNH4TOH4TOH4TOJYfPOJHTOZLUSZrWS5zYZanaaa3edrLdfbjjjLzgjb7hjb7ilsXomMfpsM/mudbswdjpw97y0eDs2eTt2er32uXt2+Xt3Obt3ebt3ebu3efu393l3+jw4d/l4erw4urw48zV5cfQ5e/36O7z6O/z6e/06vD07PT67fL27/b88fX48vX58/b59I+d9Y2b9e3w9ff69fj69oqY9vn79/n7+Pr7+fv8+tzh+3aG+9fc+/3+/I6b/JKf/JSh/f7+/f7//tnd/t/j/v7+/v7///T1//7/////THgr+QAAABF0Uk5TAAcIGBktSYSXmMHI2uPy8/XVqDFbAAAB2klEQVQ4jYVT11YCQQxdEOlVOiIgfaUjRQXpiiwoRcH8/5eYZNgF9HjIw0Bys8nNnYwkaaYzWqx2l8tutRh10l8zmJ0ezZxmwy9Yb3J7Tsxt0h/jFzbPH7NdHPBLB4e8wetEOp24DnrZdVxq3zN+Fc3L8l2tdifL+egVZ+xr6Lm+Pym3utMtwHbabclJP3cRPEz0P5ypvoJmr9VMmKImno/4+3NPWziy7VOOarhpWjP1T3YBvjefAv3cfAN0k8TDjPqRPtEm4h+KstwB7JaK8oEZzSgpppOMNF95BbBR0N53u3f63QCsyjStUbLgGXzBwjOFMxhXZhh4CSJkkax43lDnXl/RrN+jyA1CVsmO5y25X5WJik8qXxS5RcguufBsMPlxaZ8xKY050EDIxQmPYryhmjAU/iMnUIsU+4K/mIUDKW5BJGPsLw8klxyIMUkaM8T6ifKiDWsa4jFJKN8a3bngJ5jOMbD2sVAsdRz95wHOXxqPS6jH4BkDcSG1uKwsSlu8rxdGAKNC/b6I0mf3lyWuO7AAmLYf3qj120N7CrAIqNctFiaygBNbRLSF2a9cIHuMZwNHK6cubXytwuv4ydJqa+8LxVKdTioW8v1a+/MP5/zTO/94/3/+Px4gl/0Dnu+pAAAAAElFTkSuQmCC"/>
            </div>
        </div>
    </div>
    <div [ngClass]="{'contentDialog': isContentDinamico }" style="margin:5px;">
        <div [attr.id]="idContent" class="contentDinamico" style="min-height: 300px;" [ngStyle]="{'height': height}">
            <ng-content></ng-content>
        </div>        
    </div>    
</div>
  `
            }] }
];
/** @nocollapse */
ModalComponent.ctorParameters = () => [];
ModalComponent.propDecorators = {
    tittle: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ["tittle",] }],
    width: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ["width-modal",] }],
    height: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ["height-modal",] }],
    draggable: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ["draggable",] }],
    isContentDinamico: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"], args: ["isContentDinamico",] }]
};
if (false) {}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modal.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ModalModule {
}
ModalModule.decorators = [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"], args: [{
                declarations: [ModalComponent],
                imports: [
                    _angular_common__WEBPACK_IMPORTED_MODULE_2__["CommonModule"]
                ],
                exports: [ModalComponent],
                providers: [ModalService]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: modal.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */


//# sourceMappingURL=modal.js.map


/***/ }),

/***/ "./dist-library/vesta-authentication/fesm2015/vesta-authentication.js":
/*!****************************************************************************!*\
  !*** ./dist-library/vesta-authentication/fesm2015/vesta-authentication.js ***!
  \****************************************************************************/
/*! exports provided: AUTH_SERVICE, AuthenticationMenuMock, AuthorizationGuard, InitWeb, InitWebApi, MenuAuthenticationService, USER_AUTH, VestaAuthenticationModule, VestaAuthenticationUserModule, ɵa, ɵb, ɵc, ɵd, ɵe, ɵf, ɵg, ɵh, ɵi */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AUTH_SERVICE", function() { return AUTH_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuthenticationMenuMock", function() { return AuthenticationMenuMock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuthorizationGuard", function() { return AuthorizationGuard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InitWeb", function() { return InitWeb; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InitWebApi", function() { return InitWebApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MenuAuthenticationService", function() { return MenuAuthenticationService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "USER_AUTH", function() { return USER_AUTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VestaAuthenticationModule", function() { return VestaAuthenticationModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VestaAuthenticationUserModule", function() { return VestaAuthenticationUserModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵa", function() { return AuthService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵb", function() { return ClientSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵc", function() { return CLIENT_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵd", function() { return BASEURL_AUTENTICACION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵe", function() { return BASEURL_AUTENTICACION_WEB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵf", function() { return AuthCallbackComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵg", function() { return AuthSilentComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵh", function() { return UserAuth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵi", function() { return HttpAccessTokenInterceptorService; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var oidc_client__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! oidc-client */ "./node_modules/oidc-client/lib/oidc-client.min.js");
/* harmony import */ var oidc_client__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(oidc_client__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var vesta__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! vesta */ "./dist-library/vesta/fesm2015/vesta.js");









/**
 * @fileoverview added by tsickle
 * Generated from: lib/user-auth.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IUserAuth() { }
if (false) {}
/** @type {?} */
let USER_AUTH = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["InjectionToken"]('IUserAuth');

/**
 * @fileoverview added by tsickle
 * Generated from: lib/authentication-providers.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
let CLIENT_SETTINGS = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["InjectionToken"]('ClientSettings');
/** @type {?} */
let BASEURL_AUTENTICACION = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["InjectionToken"]('BASEURLAUTENTICACION');
/** @type {?} */
let BASEURL_AUTENTICACION_WEB = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["InjectionToken"]('BASEURLAUTENTICACIONWEB');

/**
 * @fileoverview added by tsickle
 * Generated from: lib/client-settings.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ClientSettings {
    /**
     * @param {?} settings
     * @param {?} urlWeb
     */
    constructor(settings, urlWeb) {
        this.settings = settings;
        this.urlWeb = urlWeb;
        this._authority = this.urlWeb; //'https://vestaidentityserver.azurewebsites.net/'; //"https://identitysrvv.azurewebsites.net/"; //"https://identitysrvdev.azurewebsites.net/";
        this._client_id = this.settings.ClienteId; //"mario_js_client";
        this._redirect_uri = window.location.origin + "/auth-callback";
        this._post_logout_redirect_uri = window.location.origin + "/";
        // if we choose to use popup window instead for logins
        this._popup_redirect_uri = window.location.origin + "/popup.html";
        this._popupWindowFeatures = "menubar=yes,location=yes,toolbar=yes,width=1200,height=800,left=100,top=100;resizable=yes";
        // these two will be done dynamically from the buttons clicked, but are
        // needed if you want to use the silent_renew
        this._response_type = "code";
        //response_mode= "query",
        this._scope = "openid profile IdentitySrvApi"; //work.profile//IdentityServerApi api1 api1.full_access api2.full_access // IdentitySrvApi
        // this will toggle if profile endpoint is used
        this._loadUserInfo = true;
        //userStore= new WebStorageStateStore({ store= window.localStorage }),
        // silent renew will get a new access_token via an iframe 
        // just prior to the old access_token expiring (60 seconds prior)
        this._silent_redirect_uri = window.location.origin + "/auth-silent";
        this._automaticSilentRenew = true;
        // will revoke (reference) access tokens at logout time
        this._revokeAccessTokenOnSignout = true;
        // this will allow all the OIDC protocol claims to be visible in the window. normally a client app 
        // wouldn't care about them or want them taking up space
        this._filterProtocolClaims = true;
        this._extraQueryParams = {}; //sistema_id: this.settings.SistemaId
    }
    //'https://vestaidentityserver.azurewebsites.net/'; //"https://identitysrvv.azurewebsites.net/"; //"https://identitysrvdev.azurewebsites.net/";
    /**
     * @return {?}
     */
    get authority() {
        return this._authority;
    }
    //"mario_js_client";
    /**
     * @return {?}
     */
    get client_id() {
        return this._client_id;
    }
    /**
     * @return {?}
     */
    get redirect_uri() {
        return this._redirect_uri;
    }
    /**
     * @return {?}
     */
    get post_logout_redirect_uri() {
        return this._post_logout_redirect_uri;
    }
    /**
     * @return {?}
     */
    get popup_redirect_uri() {
        return this._popup_redirect_uri;
    }
    /**
     * @return {?}
     */
    get popupWindowFeatures() {
        return this._popupWindowFeatures;
    }
    ;
    /**
     * @return {?}
     */
    get response_type() {
        return this._response_type;
    }
    //work.profile//IdentityServerApi api1 api1.full_access api2.full_access // IdentitySrvApi
    /**
     * @return {?}
     */
    get scope() {
        return this._scope;
    }
    /**
     * @return {?}
     */
    get loadUserInfo() {
        return this._loadUserInfo;
    }
    /**
     * @return {?}
     */
    get silent_redirect_uri() {
        return this._silent_redirect_uri;
    }
    /**
     * @return {?}
     */
    get automaticSilentRenew() {
        return this._automaticSilentRenew;
    }
    /**
     * @return {?}
     */
    get revokeAccessTokenOnSignout() {
        return this._revokeAccessTokenOnSignout;
    }
    /**
     * @return {?}
     */
    get filterProtocolClaims() {
        return this._filterProtocolClaims;
    }
    //sistema_id: this.settings.SistemaId
    /**
     * @return {?}
     */
    get extraQueryParams() {
        return this._extraQueryParams;
    }
}
ClientSettings.decorators = [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"], args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
ClientSettings.ctorParameters = () => [
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [CLIENT_SETTINGS,] }] },
    { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [BASEURL_AUTENTICACION_WEB,] }] }
];
/** @nocollapse */ ClientSettings.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵdefineInjectable"])({ factory: function ClientSettings_Factory() { return new ClientSettings(Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵinject"])(CLIENT_SETTINGS), Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵinject"])(BASEURL_AUTENTICACION_WEB)); }, token: ClientSettings, providedIn: "root" });
if (false) {}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/auth.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
oidc_client__WEBPACK_IMPORTED_MODULE_3__["Log"].logger = window.console;
oidc_client__WEBPACK_IMPORTED_MODULE_3__["Log"].level = oidc_client__WEBPACK_IMPORTED_MODULE_3__["Log"].DEBUG;
class AuthService {
    //  new Promise((resolve, reject) => {
    //  this.manager.getUser().then(response => {
    //    resolve(response);
    //  }, error => {
    //    reject(error);
    //  })    
    //})
    /**
     * @param {?} router
     * @param {?} clientSettings
     */
    constructor(router, clientSettings) {
        this.router = router;
        this.clientSettings = clientSettings;
        this.manager = new oidc_client__WEBPACK_IMPORTED_MODULE_3__["UserManager"](this.clientSettings);
        this.user = null;
        this.UserEvent = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
        this._first = true;
        this.AsyncUser();
    }
    /**
     * @private
     * @return {?}
     */
    AsyncUser() {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_2__["__awaiter"])(this, void 0, void 0, function* () {
            this.user = yield this.manager.getUser();
            //this.UserEvent.emit(this.user);
        });
    }
    /**
     * @return {?}
     */
    isLoggedIn() {
        if (this._first) {
            this._first = false;
            if (this.user)
                this.UserEvent.emit(this.user);
            //else this.UserEvent.emit(new User(null));
        }
        return this.user != null && !this.user.expired;
    }
    /**
     * @return {?}
     */
    getClaims() {
        return this.user.profile;
    }
    /**
     * @return {?}
     */
    getAuthorizationHeaderValue() {
        return `${this.user.token_type} ${this.user.access_token}`;
    }
    /**
     * @return {?}
     */
    startAuthentication() {
        return this.manager.signinRedirect();
    }
    /**
     * @return {?}
     */
    completeAuthentication() {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_2__["__awaiter"])(this, void 0, void 0, function* () {
            /** @type {?} */
            let user = yield this.manager.signinRedirectCallback();
            this.user = user;
            this._first = false;
            this.UserEvent.emit(this.user);
            //let dirStorage = localStorage.getItem("history");
            //let dir = (dirStorage == null) ? '/menu' : dirStorage;
            this.router.navigate(['/menu']);
        });
    }
    /**
     * @return {?}
     */
    signoutRedirect() {
        return this.manager.signoutRedirect();
    }
    /**
     * @return {?}
     */
    signinSilentCallback() {
        this.manager.signinSilentCallback();
    }
    /**
     * @return {?}
     */
    GetIUserAuth() {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_2__["__awaiter"])(this, void 0, void 0, function* () {
            if (this.user == null)
                this.user = yield this.manager.getUser();
            if (this.user != null) {
                /** @type {?} */
                let user = {
                    Role: this.user.profile.JobRole,
                    Email: this.user.profile.preferred_username,
                    Name: this.user.profile.name,
                    UserName: this.user.profile.preferred_username,
                    Id: this.user.profile.sub.toLowerCase(),
                    User: null,
                    UserEvent: null
                };
                return user;
            }
            else {
                return {
                    Role: null,
                    Email: null,
                    Name: null,
                    UserName: null,
                    Id: null,
                    User: null,
                    UserEvent: null
                };
            }
        });
    }
}
AuthService.decorators = [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"], args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
AuthService.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_1__["Router"] },
    { type: ClientSettings }
];
/** @nocollapse */ AuthService.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵdefineInjectable"])({ factory: function AuthService_Factory() { return new AuthService(Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵinject"])(_angular_router__WEBPACK_IMPORTED_MODULE_1__["Router"]), Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵinject"])(ClientSettings)); }, token: AuthService, providedIn: "root" });
if (false) {}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/authorization-guard.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AuthorizationGuard {
    /**
     * @param {?} router
     * @param {?} authService
     */
    constructor(router, authService) {
        this.router = router;
        this.authService = authService;
        router.events.subscribe((/**
         * @param {?} value
         * @return {?}
         */
        value => {
            if (value instanceof _angular_router__WEBPACK_IMPORTED_MODULE_1__["NavigationEnd"]) {
                localStorage.removeItem("history");
                /** @type {?} */
                let url = value.url.split('(')[0];
                localStorage.setItem("history", url);
            }
        }));
    }
    /**
     * @param {?} route
     * @param {?} state
     * @return {?}
     */
    canActivate(route, state) {
        return this.checkUser();
    }
    /**
     * @return {?}
     */
    canLoad() {
        return this.checkUser();
    }
    /**
     * @private
     * @return {?}
     */
    checkUser() {
        if (this.authService.isLoggedIn()) {
            return true;
        }
        this.authService.startAuthentication();
        return false;
    }
}
AuthorizationGuard.decorators = [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"], args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
AuthorizationGuard.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_1__["Router"] },
    { type: AuthService }
];
/** @nocollapse */ AuthorizationGuard.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵdefineInjectable"])({ factory: function AuthorizationGuard_Factory() { return new AuthorizationGuard(Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵinject"])(_angular_router__WEBPACK_IMPORTED_MODULE_1__["Router"]), Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵinject"])(AuthService)); }, token: AuthorizationGuard, providedIn: "root" });
if (false) {}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/user-auth.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class UserAuth {
    /**
     * @param {?} auth
     */
    constructor(auth) {
        this.auth = auth;
        this._UserEvent = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
        auth.UserEvent.subscribe((/**
         * @param {?} response
         * @return {?}
         */
        response => {
            this._Role = response.profile.JobRole;
            this._Email = response.profile.preferred_username;
            this._Name = response.profile.name;
            this._UserName = response.profile.preferred_username;
            this._Id = response.profile.sub; //"BC55E46F-0B31-45D1-B1E1-1450C63CD32F"//response.profile.sub
            this._UserEvent.emit(this);
        }));
        this.GetUserAsync();
    }
    /**
     * @private
     * @return {?}
     */
    GetUserAsync() {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_2__["__awaiter"])(this, void 0, void 0, function* () {
            /** @type {?} */
            let user = yield this.auth.GetIUserAuth();
            if (user != null) {
                this._Role = user.Role;
                this._Email = user.Email;
                this._Name = user.Name;
                this._UserName = user.UserName;
                this._Id = user.Id; //'BC55E46F-0B31-45D1-B1E1-1450C63CD32F'//user.Id
                //if (user != null) this._UserEvent.emit(this);
            }
        });
    }
    //private _User;
    /**
     * @return {?}
     */
    get User() {
        return this.UserASync();
    }
    /**
     * @return {?}
     */
    UserASync() {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_2__["__awaiter"])(this, void 0, void 0, function* () {
            return yield this.auth.GetIUserAuth();
        });
    }
    /**
     * @return {?}
     */
    get UserEvent() {
        return this._UserEvent;
    }
    /**
     * @return {?}
     */
    get Role() {
        return this._Role;
    }
    /**
     * @return {?}
     */
    get Email() {
        return this._Email;
    }
    /**
     * @return {?}
     */
    get Name() {
        return this._Name;
    }
    /**
     * @return {?}
     */
    get UserName() {
        return this._UserName;
    }
    /**
     * @return {?}
     */
    get Id() {
        if (this._Id == null)
            return null;
        return this._Id.toLocaleLowerCase();
    }
}
UserAuth.decorators = [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"], args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
UserAuth.ctorParameters = () => [
    { type: AuthService }
];
/** @nocollapse */ UserAuth.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵdefineInjectable"])({ factory: function UserAuth_Factory() { return new UserAuth(Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵinject"])(AuthService)); }, token: UserAuth, providedIn: "root" });
if (false) {}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/http-access-token-interceptor.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class HttpAccessTokenInterceptorService {
    /**
     * @param {?} authService
     * @param {?} settings
     */
    constructor(authService, settings) {
        this.authService = authService;
        this.settings = settings;
    }
    /**
     * @param {?} req
     * @param {?} next
     * @return {?}
     */
    intercept(req, next) {
        //this.RequestInterceptor();
        if (req.withCredentials) {
            /** @type {?} */
            let accessToken = this.authService.getAuthorizationHeaderValue();
            /** @type {?} */
            const handler = req.clone({
                setHeaders: { Authorization: accessToken, WWWAuths: `${this.settings.ClienteId}, ${window.location.origin}, ${window.location.pathname}` },
                withCredentials: false
            });
            return next.handle(handler).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_6__["tap"])((/**
             * @return {?}
             */
            () => { }), (/**
             * @param {?} error
             * @return {?}
             */
            (error) => {
                if (error instanceof _angular_common_http__WEBPACK_IMPORTED_MODULE_5__["HttpErrorResponse"]) {
                    if (error.status != 401)
                        return void 0;
                    this.authService.startAuthentication();
                    //this.router.navigate(['/menu']);
                }
            })));
        }
        return next.handle(req);
    }
}
HttpAccessTokenInterceptorService.decorators = [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"], args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
HttpAccessTokenInterceptorService.ctorParameters = () => [
    { type: AuthService },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [CLIENT_SETTINGS,] }] }
];
/** @nocollapse */ HttpAccessTokenInterceptorService.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵdefineInjectable"])({ factory: function HttpAccessTokenInterceptorService_Factory() { return new HttpAccessTokenInterceptorService(Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵinject"])(AuthService), Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵinject"])(CLIENT_SETTINGS)); }, token: HttpAccessTokenInterceptorService, providedIn: "root" });
if (false) {}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/auth-service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IAuthService() { }
if (false) {}
/** @type {?} */
let AUTH_SERVICE = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["InjectionToken"]('IAuthService');

/**
 * @fileoverview added by tsickle
 * Generated from: lib/auth-callback/auth-callback.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AuthCallbackComponent {
    /**
     * @param {?} authService
     */
    constructor(authService) {
        this.authService = authService;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_2__["__awaiter"])(this, void 0, void 0, function* () {
            this.Init();
        });
    }
    /**
     * @return {?}
     */
    Init() {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_2__["__awaiter"])(this, void 0, void 0, function* () {
            yield this.authService.completeAuthentication();
        });
    }
}
AuthCallbackComponent.decorators = [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{
                selector: 'auth-callback',
                template: "<h1>Processing callback...</h1>\r\n",
                styles: [""]
            }] }
];
/** @nocollapse */
AuthCallbackComponent.ctorParameters = () => [
    { type: AuthService }
];
if (false) {}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/auth-silent/auth-silent.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AuthSilentComponent {
    /**
     * @param {?} authService
     */
    constructor(authService) {
        this.authService = authService;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.authService.signinSilentCallback();
    }
}
AuthSilentComponent.decorators = [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{
                selector: 'auth-silent',
                template: "<p>auth-silent works!</p>\r\n",
                styles: [""]
            }] }
];
/** @nocollapse */
AuthSilentComponent.ctorParameters = () => [
    { type: AuthService }
];
if (false) {}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/menu-authentication.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MenuAuthenticationService {
    /**
     * @param {?} callHttp
     * @param {?} settings
     * @param {?} urlBase
     * @param {?} userAuth
     */
    constructor(callHttp, settings, urlBase, userAuth) {
        this.callHttp = callHttp;
        this.settings = settings;
        this.urlBase = urlBase;
        this.userAuth = userAuth;
        this._MenuAuthentication = new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            //Opers/Sistema/Home/GetMenu
            //Opers/Project/Home/GetMenu
            //, { ProjectId: this.settings.SistemaId, UserId: this.userAuth.Id }
            ///api/IdentityApi/GetMenuTestMS
            ///api/IdentityApi/GetMenu
            this.callHttp.httpGet(`${this.urlBase}/api/IdentityApi/GetMenu`)
                .subscribe((/**
             * @param {?} response
             * @return {?}
             */
            response => {
                resolve(response);
            }), (/**
             * @param {?} error
             * @return {?}
             */
            error => {
                reject(error);
            }));
        }));
    }
    /**
     * @return {?}
     */
    get MenuAuthentication() {
        return this._MenuAuthentication;
    }
}
MenuAuthenticationService.decorators = [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"], args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
MenuAuthenticationService.ctorParameters = () => [
    { type: vesta__WEBPACK_IMPORTED_MODULE_7__["CallHttp"] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [CLIENT_SETTINGS,] }] },
    { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [BASEURL_AUTENTICACION,] }] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [USER_AUTH,] }] }
];
/** @nocollapse */ MenuAuthenticationService.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵdefineInjectable"])({ factory: function MenuAuthenticationService_Factory() { return new MenuAuthenticationService(Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵinject"])(vesta__WEBPACK_IMPORTED_MODULE_7__["CallHttp"]), Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵinject"])(CLIENT_SETTINGS), Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵinject"])(BASEURL_AUTENTICACION), Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵinject"])(USER_AUTH)); }, token: MenuAuthenticationService, providedIn: "root" });
if (false) {}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/vesta-authentication.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//let Routes_Vesta = new InjectionToken<Routes>('RoutesVesta');
//let routesRoot: Routes = [];
/**
 * @param {?} settings
 * @return {?}
 */
function InitWebApi(settings) {
    /** @type {?} */
    let direccion = 'https://vestaidentityserverapi.azurewebsites.net';
    if (settings.Stage)
        direccion = 'https://vestaidentityserverapi-stage.azurewebsites.net';
    // let [direccionWeb] = DireccionesFileShare.filter(f => f.Nombre == direccion);
    return direccion;
}
/**
 * @param {?} settings
 * @return {?}
 */
function InitWeb(settings) {
    /** @type {?} */
    let direccion = 'https://vestaidentityserver.azurewebsites.net/';
    if (settings.Stage)
        direccion = 'https://vestaidentityserver-stage.azurewebsites.net/';
    // let [direccionWeb] = DireccionesFileShare.filter(f => f.Nombre == direccion);
    return direccion;
}
/** @type {?} */
var routes = [
    { path: 'auth-callback', component: AuthCallbackComponent },
    { path: 'auth-silent', component: AuthSilentComponent },
    { path: '**', component: vesta__WEBPACK_IMPORTED_MODULE_7__["PageNotFoundComponent"] }
];
class VestaAuthenticationModule {
    /**
     * @param {?} settings
     * @return {?}
     */
    static forRoot(settings) {
        //let provide = { provide: CLIENT_SETTINGS, useValue: settings };
        //let providers = [provide];
        return {
            ngModule: VestaAuthenticationModule,
            providers: [
                { provide: CLIENT_SETTINGS, useValue: settings },
                { provide: BASEURL_AUTENTICACION, useFactory: InitWebApi, deps: [CLIENT_SETTINGS] },
                { provide: BASEURL_AUTENTICACION_WEB, useFactory: InitWeb, deps: [CLIENT_SETTINGS] },
            ]
        };
    }
}
VestaAuthenticationModule.decorators = [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"], args: [{
                declarations: [
                    AuthCallbackComponent,
                    AuthSilentComponent
                ],
                imports: [
                    _angular_common__WEBPACK_IMPORTED_MODULE_4__["CommonModule"],
                    _angular_router__WEBPACK_IMPORTED_MODULE_1__["RouterModule"].forRoot(routes),
                    vesta__WEBPACK_IMPORTED_MODULE_7__["VestaModule"]
                ],
                exports: [
                    AuthCallbackComponent,
                    AuthSilentComponent
                    //RouterModule
                ],
                providers: [
                    AuthorizationGuard,
                    AuthService,
                    MenuAuthenticationService,
                    { provide: USER_AUTH, useClass: UserAuth },
                    { provide: AUTH_SERVICE, useClass: AuthService },
                    { provide: _angular_common_http__WEBPACK_IMPORTED_MODULE_5__["HTTP_INTERCEPTORS"], useClass: HttpAccessTokenInterceptorService, multi: true },
                    //{ provide: BASEURL_AUTENTICACION, useValue: 'https://vestaidentityserverapi.azurewebsites.net' },//'https://identitysrvv-api.azurewebsites.net'
                    ClientSettings
                ]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/vesta-authentication.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function Backlog() { }
if (false) {}
/**
 * @record
 */
function Feature() { }
if (false) {}
/**
 * @record
 */
function Epic() { }
if (false) {}
/**
 * @record
 */
function AuthenticationMenu() { }
if (false) {}
class AuthenticationMenuMock {
    /**
     * @return {?}
     */
    static GetAuthenticationMenuMock() {
        /** @type {?} */
        let obj = (/** @type {?} */ ({}));
        return obj;
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/vesta-authentication-user/vesta-authentication-user.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class VestaAuthenticationUserModule {
}
VestaAuthenticationUserModule.decorators = [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"], args: [{
                declarations: [],
                imports: [
                    _angular_common__WEBPACK_IMPORTED_MODULE_4__["CommonModule"]
                ],
                providers: [{ provide: USER_AUTH, useClass: UserAuth },
                    { provide: AUTH_SERVICE, useClass: AuthService }]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: vesta-authentication.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */


//# sourceMappingURL=vesta-authentication.js.map


/***/ }),

/***/ "./dist-library/vesta-firebase/fesm2015/vesta-firebase.js":
/*!****************************************************************!*\
  !*** ./dist-library/vesta-firebase/fesm2015/vesta-firebase.js ***!
  \****************************************************************/
/*! exports provided: BASEURL_FIREBASE, EnvironmentToken, FIREBASE_TOKENID, FirebaseConnectService, Init, InitWebApi, MessageFireBase, NotificacionFirebaseService, Settings_FireBase, Settings_FireBase_Temp, VestaFirebaseModule, WebPushFirebaseService, WebpushNotificationFireBase, ɵa */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BASEURL_FIREBASE", function() { return BASEURL_FIREBASE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EnvironmentToken", function() { return EnvironmentToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FIREBASE_TOKENID", function() { return FIREBASE_TOKENID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FirebaseConnectService", function() { return FirebaseConnectService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Init", function() { return Init; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InitWebApi", function() { return InitWebApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MessageFireBase", function() { return MessageFireBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NotificacionFirebaseService", function() { return NotificacionFirebaseService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Settings_FireBase", function() { return Settings_FireBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Settings_FireBase_Temp", function() { return Settings_FireBase_Temp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VestaFirebaseModule", function() { return VestaFirebaseModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WebPushFirebaseService", function() { return WebPushFirebaseService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WebpushNotificationFireBase", function() { return WebpushNotificationFireBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵa", function() { return FirebaseTokenIdService; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var vesta__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! vesta */ "./dist-library/vesta/fesm2015/vesta.js");
/* harmony import */ var firebase_app__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! firebase/app */ "./node_modules/firebase/app/dist/index.cjs.js");
/* harmony import */ var firebase_app__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(firebase_app__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var firebase_database__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! firebase/database */ "./node_modules/firebase/database/dist/index.esm.js");
/* harmony import */ var firebase_messaging__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! firebase/messaging */ "./node_modules/firebase/messaging/dist/index.esm.js");
/* harmony import */ var firebase_auth__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! firebase/auth */ "./node_modules/firebase/auth/dist/index.esm.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");











/**
 * @fileoverview added by tsickle
 * Generated from: lib/settings-firebase.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function SettingsFirebase() { }
if (false) {}
/**
 * @record
 */
function Environment() { }
if (false) {}
/** @type {?} */
let Settings_FireBase = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["InjectionToken"]('Settings_FireBase');
/** @type {?} */
let Settings_FireBase_Temp = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["InjectionToken"]('Settings_FireBase_Temp');
/** @type {?} */
let EnvironmentToken = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["InjectionToken"]('Environment');
/** @type {?} */
let BASEURL_FIREBASE = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["InjectionToken"]('BASEURLFIREBASE');

/**
 * @fileoverview added by tsickle
 * Generated from: lib/firebase-connect.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//import { environment } from 'src/environments/environment';
////require("firebase/app");
//require("@firebase/database");
//require("@firebase/messaging");
//require("@firebase/auth");
class FirebaseConnectService {
    /**
     * @param {?} settings
     */
    constructor(settings) {
        this.settings = settings;
        let [app] = firebase_app__WEBPACK_IMPORTED_MODULE_4__["apps"];
        if (app == null) {
            firebase_app__WEBPACK_IMPORTED_MODULE_4__;
            this.App = Object(firebase_app__WEBPACK_IMPORTED_MODULE_4__["initializeApp"])(settings);
            this.DataBase = this.GetDataBase();
            this.Messaging = this.GetMessaging();
            this.Auth = this.GetAuth();
        }
        else {
            this.App = app;
            this.DataBase = this.GetDataBase();
            this.Messaging = this.GetMessaging();
            this.Auth = this.GetAuth();
        }
    }
    /**
     * @return {?}
     */
    GetDataBase() {
        return Object(firebase_app__WEBPACK_IMPORTED_MODULE_4__["database"])(this.App); //firebase.database(this.settings.databaseURL);//firebase.database(this.App);
    }
    /**
     * @return {?}
     */
    GetMessaging() {
        return Object(firebase_app__WEBPACK_IMPORTED_MODULE_4__["messaging"])(this.App); //firebase.messaging(this.App);
    }
    /**
     * @return {?}
     */
    GetAuth() {
        return Object(firebase_app__WEBPACK_IMPORTED_MODULE_4__["auth"])(this.App); //firebase.auth(this.App);
    }
}
FirebaseConnectService.decorators = [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"], args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
FirebaseConnectService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [Settings_FireBase,] }] }
];
/** @nocollapse */ FirebaseConnectService.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵdefineInjectable"])({ factory: function FirebaseConnectService_Factory() { return new FirebaseConnectService(Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵinject"])(Settings_FireBase)); }, token: FirebaseConnectService, providedIn: "root" });
if (false) {}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/local-storage-key-firebase.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const Key_FireBase_DateTime = 'firebase.token_id.datetime';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/web-push-firebase.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var moment = __webpack_require__(/*! moment */ "./node_modules/moment/moment.js");
class WebPushFirebaseService {
    /**
     * @param {?} fireBaseConnect
     * @param {?} callHttp
     * @param {?} settings
     * @param {?} environment
     * @param {?} baseURL
     */
    constructor(fireBaseConnect, callHttp, settings, environment, baseURL) {
        this.fireBaseConnect = fireBaseConnect;
        this.callHttp = callHttp;
        this.settings = settings;
        this.environment = environment;
        this.baseURL = baseURL;
        this.OnMessaging = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
        this.TokenIdSubject = new rxjs__WEBPACK_IMPORTED_MODULE_8__["Subject"]();
        this.FocusSubject = new rxjs__WEBPACK_IMPORTED_MODULE_8__["Subject"]();
        this._Timer = null;
    }
    /**
     * @param {?} tokenId
     * @return {?}
     */
    set TokenId(tokenId) {
        this._TokenId = tokenId;
        this.TokenIdSubject.next(tokenId);
    }
    /**
     * @return {?}
     */
    get TokenId() {
        return this._TokenId;
    }
    /**
     * @param {?} user
     * @return {?}
     */
    RequestPermission(user) {
        this.user = user;
        /** @type {?} */
        let promise = new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            if (this.fireBaseConnect.Auth.currentUser != null) {
                if (this.fireBaseConnect.Auth.currentUser.uid.toLowerCase() != this.user.Id)
                    this.fireBaseConnect.Auth.signOut();
            }
            this.fireBaseConnect.Messaging.requestPermission().then((/**
             * @return {?}
             */
            () => Object(tslib__WEBPACK_IMPORTED_MODULE_2__["__awaiter"])(this, void 0, void 0, function* () {
                console.log('Notification permission granted.');
                if ('serviceWorker' in navigator && 'PushManager' in window) {
                    /** @type {?} */
                    let serviceWorker = this.environment.production ? 'assets/firebase-messaging-sw.js' : 'assets/firebase-messaging-sw-dev.js';
                    navigator.serviceWorker.register(serviceWorker)
                        .then((/**
                     * @param {?} swReg
                     * @return {?}
                     */
                    (swReg) => Object(tslib__WEBPACK_IMPORTED_MODULE_2__["__awaiter"])(this, void 0, void 0, function* () {
                        console.log('Service Worker is registered', swReg);
                        /** @type {?} */
                        var user = this.fireBaseConnect.Auth.currentUser;
                        if (user) {
                            resolve(true);
                            this.ValidTimeAuthentication().then((/**
                             * @param {?} id
                             * @return {?}
                             */
                            id => {
                                this.TokenId = id;
                                this.NotificacionUserRegistrado(swReg);
                            }));
                        }
                        else {
                            /** @type {?} */
                            let resp = yield this.AutenticarUsuarioAndRecibirNotificacion(swReg);
                            resolve(resp);
                        }
                    })))
                        .catch((/**
                     * @param {?} error
                     * @return {?}
                     */
                    error => {
                        console.error('Service Worker Error', error);
                        resolve(false);
                    }));
                }
                else {
                    // this.pushNotificationStatus.isSupported = false;
                }
            }))).catch((/**
             * @param {?} err
             * @return {?}
             */
            function (err) {
                console.log('Unable to get permission to notify.', err);
            }));
            this.fireBaseConnect.Messaging.onTokenRefresh((/**
             * @return {?}
             */
            () => {
                this.fireBaseConnect.Messaging.getToken().then((/**
                 * @param {?} token
                 * @return {?}
                 */
                (token) => {
                    this.TokenMessaging = token;
                    console.log(token);
                    console.log(this.userName.Token);
                    //if (this.userName.Token == null) this.SaveDataBase(token);
                    if (this.userName.Token != token)
                        this.UpdateToken();
                    this.OnMessage();
                }));
            }));
            this.EventFocusMensajes();
        }));
        return promise;
    }
    /**
     * @private
     * @param {?} swReg
     * @return {?}
     */
    AutenticarUsuarioAndRecibirNotificacion(swReg) {
        /** @type {?} */
        let promise = new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => Object(tslib__WEBPACK_IMPORTED_MODULE_2__["__awaiter"])(this, void 0, void 0, function* () {
            /** @type {?} */
            let token = yield this.GetTokenHr();
            if (token == null)
                return void 0;
            token.subscribe((/**
             * @param {?} response
             * @return {?}
             */
            response => {
                this.TokenAuth = response;
                this.fireBaseConnect.Auth.signInWithCustomToken(this.TokenAuth).then((/**
                 * @param {?} user
                 * @return {?}
                 */
                (user) => {
                    resolve(true);
                    this.ValidTimeAuthentication()
                        .then((/**
                     * @param {?} id
                     * @return {?}
                     */
                    (id) => Object(tslib__WEBPACK_IMPORTED_MODULE_2__["__awaiter"])(this, void 0, void 0, function* () {
                        this.NotificacionUserRegistrado(swReg);
                    }))).catch((/**
                     * @param {?} error
                     * @return {?}
                     */
                    error => {
                        console.error(error);
                    }));
                }), (/**
                 * @param {?} error
                 * @return {?}
                 */
                error => {
                    console.log(error.code);
                    console.error(error.message);
                    resolve(false);
                }));
            }));
        })));
        return promise;
    }
    /**
     * @private
     * @return {?}
     */
    CheckTokenIdUser() {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_2__["__awaiter"])(this, void 0, void 0, function* () {
            /** @type {?} */
            let time = yield this.time();
            if (this._Timer == null)
                this.TimerInit(time);
            else
                this.ResetTimer(time);
        });
    }
    /**
     * @private
     * @param {?} time
     * @return {?}
     */
    TimerInit(time) {
        /** @type {?} */
        let timeToken = moment(localStorage.getItem(Key_FireBase_DateTime));
        /** @type {?} */
        let timeNow = moment(time.datetime);
        /** @type {?} */
        let diff = timeNow.diff(timeToken, 'milliseconds');
        this._Timer = setInterval((/**
         * @return {?}
         */
        () => {
            diff += 10000;
            timeNow.add(10000, 'milliseconds');
            console.debug(`Check Time Token Id Firebase`, diff);
            console.debug(`Check Time Token Id Firebase`, timeNow.toDate());
            if (diff >= 3590000) {
                diff = 0; //timeNow.diff(timeToken, 'milliseconds');
                this.TokenIdNotificacion(true).then((/**
                 * @param {?} id
                 * @return {?}
                 */
                (id) => {
                    timeToken = moment(localStorage.getItem(Key_FireBase_DateTime));
                    diff = timeNow.diff(timeToken, 'milliseconds');
                }));
            }
        }), 10000);
    }
    /**
     * @private
     * @param {?} time
     * @return {?}
     */
    ResetTimer(time) {
        clearTimeout(this._Timer);
        this.TimerInit(time);
    }
    /**
     * @private
     * @param {?=} refresh
     * @param {?=} first
     * @return {?}
     */
    TokenIdNotificacion(refresh = false, first = false) {
        /** @type {?} */
        let promise = new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            //let force = refresh ? true : null;
            this.fireBaseConnect.Auth.currentUser.getIdToken(refresh).then((/**
             * @param {?} id
             * @return {?}
             */
            (id) => Object(tslib__WEBPACK_IMPORTED_MODULE_2__["__awaiter"])(this, void 0, void 0, function* () {
                if (refresh) {
                    console.log(`Refresh Token id ------ ${id}`);
                    yield this.SaveTime();
                }
                ;
                if (!refresh)
                    console.log(`Token id ------ ${id}`);
                if (first)
                    yield this.SaveTime();
                this.TokenId = id;
                resolve(id);
            }))).catch((/**
             * @param {?} error
             * @return {?}
             */
            error => {
                reject(error);
            }));
        }));
        return promise;
    }
    /**
     * @private
     * @return {?}
     */
    SaveTime() {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_2__["__awaiter"])(this, void 0, void 0, function* () {
            /** @type {?} */
            let time = yield this.time();
            localStorage.setItem(Key_FireBase_DateTime, time.datetime);
            console.debug(`Start Token Id Firebase`, moment(time.datetime).toDate());
        });
    }
    /**
     * @private
     * @return {?}
     */
    time() {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_2__["__awaiter"])(this, void 0, void 0, function* () {
            /** @type {?} */
            let time = yield fetch(`https://worldtimeapi.org/api/ip`);
            if (time.ok) {
                return time.json();
            }
        });
    }
    /**
     * @private
     * @return {?}
     */
    ValidTimeAuthentication() {
        /** @type {?} */
        let promise = new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => Object(tslib__WEBPACK_IMPORTED_MODULE_2__["__awaiter"])(this, void 0, void 0, function* () {
            /** @type {?} */
            let timeLocalStorage = localStorage.getItem(Key_FireBase_DateTime);
            /** @type {?} */
            let timeNow = yield this.time();
            /** @type {?} */
            let first = false;
            if (timeLocalStorage == null) {
                timeLocalStorage = timeNow.datetime;
                first = true;
            }
            ;
            /** @type {?} */
            let time = moment(timeLocalStorage);
            /** @type {?} */
            let now = moment(timeNow.datetime);
            /** @type {?} */
            let diff = now.diff(time, 'hours');
            console.log(diff, 'h');
            if (diff > 0) {
                this.TokenIdNotificacion(true).then((/**
                 * @param {?} id
                 * @return {?}
                 */
                id => {
                    resolve(id);
                })).catch((/**
                 * @param {?} error
                 * @return {?}
                 */
                error => {
                    reject(error);
                }));
            }
            else {
                this.TokenIdNotificacion(false, first).then((/**
                 * @param {?} id
                 * @return {?}
                 */
                id => {
                    resolve(id);
                })).catch((/**
                 * @param {?} error
                 * @return {?}
                 */
                error => {
                    reject(error);
                }));
            }
        })));
        return promise;
    }
    /**
     * @private
     * @param {?} swReg
     * @return {?}
     */
    NotificacionUserRegistrado(swReg) {
        this.GetUser().then((/**
         * @param {?} snapshot
         * @return {?}
         */
        (snapshot) => {
            this.userName = (snapshot.val()) || {};
            this.fireBaseConnect.Messaging.useServiceWorker(swReg);
            this.fireBaseConnect.Messaging.usePublicVapidKey(this.settings.PublicVapidKey);
            this.fireBaseConnect.Messaging.getToken().then((/**
             * @param {?} token
             * @return {?}
             */
            (token) => {
                this.TokenMessaging = token;
                console.log(`Messaging -----   ${token}`);
                if (this.userName.Token == null)
                    this.SaveDataBase(token);
                if (this.userName.Token != token)
                    this.UpdateToken();
                this.CheckTokenIdUser();
                this.OnMessage();
            }));
        }));
    }
    /**
     * @private
     * @return {?}
     */
    EventFocusMensajes() {
        window.addEventListener('focus', (/**
         * @return {?}
         */
        () => Object(tslib__WEBPACK_IMPORTED_MODULE_2__["__awaiter"])(this, void 0, void 0, function* () {
            /** @type {?} */
            let mensajes = yield this.GetDataMensajes();
            if (mensajes.length > 0) {
                this.FocusSubject.next(mensajes);
                //mensajes.forEach(f => {
                //  this.SaveNotificacionWebPush(f);
                //})
            }
        })));
    }
    /**
     * @return {?}
     */
    GetMensajesUsuario() {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_2__["__awaiter"])(this, void 0, void 0, function* () {
            /** @type {?} */
            let promise = new Promise((/**
             * @param {?} resolve
             * @param {?} reject
             * @return {?}
             */
            (resolve, reject) => Object(tslib__WEBPACK_IMPORTED_MODULE_2__["__awaiter"])(this, void 0, void 0, function* () {
                /** @type {?} */
                let mensajes = yield this.fireBaseConnect.DataBase.ref(`sistemas/${this.settings.SistemaId}/notificacion/${this.user.Id}`).once('value');
                /** @type {?} */
                var mensajesArray = [];
                mensajes.forEach((/**
                 * @param {?} f
                 * @return {?}
                 */
                f => {
                    mensajesArray.push(f.val());
                }));
                resolve(mensajesArray);
            })));
            return promise;
        });
    }
    /**
     * @private
     * @return {?}
     */
    GetDataMensajes() {
        /** @type {?} */
        let promise = new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => Object(tslib__WEBPACK_IMPORTED_MODULE_2__["__awaiter"])(this, void 0, void 0, function* () {
            /** @type {?} */
            let request = indexedDB.open('mensajes', 2);
            request.onupgradeneeded = (/**
             * @param {?} e
             * @return {?}
             */
            function (e) {
                if (request.transaction.objectStoreNames.length == 0)
                    e.target.transaction.abort();
            });
            request.onsuccess = (/**
             * @param {?} event
             * @return {?}
             */
            (event) => {
                /** @type {?} */
                let db = request.result;
                db.onerror = (/**
                 * @param {?} event
                 * @return {?}
                 */
                (event) => {
                    console.log(event);
                });
                /** @type {?} */
                let transaccion = null;
                try {
                    transaccion = db.transaction('mensaje.' + this.user.Id, 'readwrite');
                }
                catch (ex) {
                    console.debug(ex);
                }
                if (transaccion != null) {
                    /** @type {?} */
                    let store = transaccion.objectStore('mensaje.' + this.user.Id);
                    /** @type {?} */
                    let all = store.getAll();
                    all.onsuccess = (/**
                     * @param {?} data
                     * @return {?}
                     */
                    (data) => {
                        /** @type {?} */
                        let mensajes = data.target.result;
                        //: Array<MensajeNavBar>
                        /** @type {?} */
                        let clone = [...mensajes];
                        if (mensajes.length > 0) {
                            store.clear();
                        }
                        resolve(clone);
                    });
                }
                else {
                    resolve([]);
                }
            });
        })));
        return promise;
    }
    //mensajesTest() {
    //}
    //SaveNotificacionWebPush(payload) {
    //  this.fireBaseConnect.DataBase.ref(`notificacion/${this.user.Id}/${payload.notification.NotificacionId}`).push(payload.notification).catch(error => {
    //    console.log(error);
    //  })
    //}
    /**
     * @private
     * @return {?}
     */
    OnMessage() {
        this.fireBaseConnect.Messaging.onMessage((/**
         * @param {?} payload
         * @return {?}
         */
        (payload) => {
            console.log(payload);
            this.OnMessaging.emit(payload);
            //this.SaveNotificacionWebPush(payload);
        }), (/**
         * @param {?} error
         * @return {?}
         */
        error => { console.log(error); }), (/**
         * @return {?}
         */
        () => {
            console.log('Completo');
        }));
    }
    /**
     * @param {?} id
     * @return {?}
     */
    DeleteNotificacion(id) {
        this.fireBaseConnect.DataBase.ref(`sistemas/${this.settings.SistemaId}/notificacion/${this.user.Id}/${id}`).remove().then((/**
         * @param {?} error
         * @return {?}
         */
        error => {
            console.log(error);
        }));
    }
    //OnMessaging() {
    //    this.fireBaseConnect.Messaging.onMessage((payload) => {
    //        //console.log('Message received. ', payload);
    //        this.dialogService.NotificacionInfoTitle(payload.notificacion.body, payload.notificacion.title);
    //    })
    //}
    /**
     * @private
     * @return {?}
     */
    GetToken() {
        this.fireBaseConnect.Messaging.getToken().then((/**
         * @param {?} token
         * @return {?}
         */
        (token) => {
            localStorage.setItem("userHr", this.user.Id);
            this.TokenMessaging = token;
            this.SaveDataBase(token);
        }));
    }
    /**
     * @private
     * @return {?}
     */
    UpdateToken() {
        this.fireBaseConnect.Messaging.getToken().then((/**
         * @param {?} token
         * @return {?}
         */
        (token) => {
            this.TokenMessaging = token;
            //console.log(token);
            this.UpdateDataBase(token);
            console.log(`Messaging update-----   ${token}`);
        }));
    }
    /**
     * @private
     * @param {?} token
     * @return {?}
     */
    SaveDataBase(token) {
        /** @type {?} */
        let user = { Token: token };
        console.log(`Messaging Nuevo-----   ${token}`);
        //this.fireBaseConnect.DataBase.ref(`notificacion/${this.user.Id}`).
        this.fireBaseConnect.DataBase.ref(`sistemas/${this.settings.SistemaId}/users/${this.user.Id}`).set(user).catch((/**
         * @param {?} error
         * @return {?}
         */
        (error) => {
            console.log(error);
        }));
    }
    /**
     * @private
     * @param {?} token
     * @return {?}
     */
    UpdateDataBase(token) {
        /** @type {?} */
        let user = { Token: token };
        this.fireBaseConnect.DataBase.ref(`sistemas/${this.settings.SistemaId}/users/${this.user.Id}`).update(user).catch((/**
         * @param {?} error
         * @return {?}
         */
        (error) => {
            console.log(error);
        }));
    }
    /**
     * @private
     * @return {?}
     */
    GetTokenHr() {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_2__["__awaiter"])(this, void 0, void 0, function* () {
            //let user = await this.user.User;//
            if (this.user.Id != null)
                return this.callHttp.httpGetText(`${this.baseURL}api/FireBaseApi/GetToken?id=${this.user.Id.toLocaleLowerCase()}$${this.settings.SistemaId}`);
        });
    }
    /**
     * @private
     * @return {?}
     */
    GetUser() {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_2__["__awaiter"])(this, void 0, void 0, function* () {
            //let user = await this.user.User;
            return this.fireBaseConnect.DataBase.ref(`sistemas/${this.settings.SistemaId}/users/${this.user.Id}`).once('value');
        });
    }
    /**
     * @return {?}
     */
    Connection() {
        return this.fireBaseConnect;
    }
}
WebPushFirebaseService.decorators = [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"], args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
WebPushFirebaseService.ctorParameters = () => [
    { type: FirebaseConnectService },
    { type: vesta__WEBPACK_IMPORTED_MODULE_3__["CallHttp"] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [Settings_FireBase,] }] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [EnvironmentToken,] }] },
    { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [BASEURL_FIREBASE,] }] }
];
/** @nocollapse */ WebPushFirebaseService.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵdefineInjectable"])({ factory: function WebPushFirebaseService_Factory() { return new WebPushFirebaseService(Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵinject"])(FirebaseConnectService), Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵinject"])(vesta__WEBPACK_IMPORTED_MODULE_3__["CallHttp"]), Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵinject"])(Settings_FireBase), Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵinject"])(EnvironmentToken), Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵinject"])(BASEURL_FIREBASE)); }, token: WebPushFirebaseService, providedIn: "root" });
if (false) {}
/**
 * @record
 */
function Time() { }
if (false) {}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/firebase-token-id.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function FirebaseTokenId() { }
if (false) {}
/** @type {?} */
let FIREBASE_TOKENID = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["InjectionToken"]('FireBaseTokenId');

/**
 * @fileoverview added by tsickle
 * Generated from: lib/firebase-token-id.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FirebaseTokenIdService {
    /**
     * @param {?} webPushService
     */
    constructor(webPushService) {
        if (webPushService.TokenId != null) {
            this.TokenId = webPushService.TokenId;
        }
        webPushService.TokenIdSubject.subscribe((/**
         * @param {?} tokenId
         * @return {?}
         */
        tokenId => {
            this.TokenId = tokenId;
        }));
    }
}
FirebaseTokenIdService.decorators = [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"], args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
FirebaseTokenIdService.ctorParameters = () => [
    { type: WebPushFirebaseService }
];
/** @nocollapse */ FirebaseTokenIdService.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵdefineInjectable"])({ factory: function FirebaseTokenIdService_Factory() { return new FirebaseTokenIdService(Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵinject"])(WebPushFirebaseService)); }, token: FirebaseTokenIdService, providedIn: "root" });
if (false) {}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/vesta-firebase.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} settings
 * @return {?}
 */
function InitWebApi(settings) {
    //if (settings.SistemaId == null) {
    //  throw 'vesta firebase sistemaId, es obligatorio';
    //} else {
    //  settings.SistemaId = settings.SistemaId.toLowerCase();
    //}
    //if (settings.SistemaId == null) {
    //  throw 'vesta firebase sistemaId, es obligatorio';
    //} else {
    //  settings.SistemaId = settings.SistemaId.toLowerCase();
    //}
    /** @type {?} */
    let direccion = 'https://notificacionesvesta.azurewebsites.net/';
    if (!settings.production)
        direccion = 'https://notificacionesvesta-stage.azurewebsites.net/';
    return direccion;
}
/**
 * @param {?} settings
 * @return {?}
 */
function Init(settings) {
    if (settings.SistemaId == null) {
        throw 'vesta firebase sistemaId, es obligatorio';
    }
    else {
        settings.SistemaId = settings.SistemaId.toLowerCase();
    }
    return settings;
}
class VestaFirebaseModule {
    /**
     * @param {?} setting
     * @param {?=} environment
     * @return {?}
     */
    static forRoot(setting, environment = { production: true }) {
        return {
            ngModule: VestaFirebaseModule,
            providers: [
                { provide: Settings_FireBase_Temp, useValue: setting },
                { provide: Settings_FireBase, useFactory: Init, deps: [Settings_FireBase_Temp] },
                { provide: EnvironmentToken, useValue: environment },
                { provide: BASEURL_FIREBASE, useFactory: InitWebApi, deps: [EnvironmentToken] },
            ]
        };
    }
}
VestaFirebaseModule.decorators = [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"], args: [{
                declarations: [],
                imports: [
                    _angular_common__WEBPACK_IMPORTED_MODULE_1__["CommonModule"],
                ],
                providers: [
                    WebPushFirebaseService,
                    FirebaseConnectService,
                    { provide: FIREBASE_TOKENID, useClass: FirebaseTokenIdService }
                ]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/firebase.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class WebpushNotificationFireBase {
    /**
     * @param {?} body
     * @param {?} title
     * @param {?=} data
     * @param {?=} requireInteraction
     * @param {?=} renotify
     * @param {?=} click
     * @return {?}
     */
    static GetWebpushNotificationFireBase(body, title, data = null, requireInteraction = false, renotify = false, click = null) {
        /** @type {?} */
        let obj = new WebpushNotificationFireBase();
        obj.Body = body;
        obj.Title = title;
        obj.Data = data;
        obj.RequireInteraction = requireInteraction;
        obj.Renotify = renotify;
        obj.Click = click;
        return obj;
    }
}
if (false) {}
class MessageFireBase {
    /**
     * @param {?} idToken
     * @param {?} id
     * @param {?} title
     * @param {?} body
     * @param {?} notificationWebPush
     * @param {?} data
     * @param {?} sistemaId
     * @return {?}
     */
    static GetMessageFireBase(idToken, id, title, body, notificationWebPush, data, sistemaId) {
        /** @type {?} */
        let obj = new MessageFireBase();
        obj.IdToken = idToken;
        obj.Id = id;
        obj.Title = title;
        obj.Body = body;
        obj.NotificationWebPush = notificationWebPush;
        obj.Data = data;
        obj.SistemaId = sistemaId;
        return obj;
    }
}
if (false) {}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/notificacion-firebase.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NotificacionFirebaseService {
    /**
     * @param {?} callHttp
     * @param {?} dialogService
     * @param {?} token
     * @param {?} baseURL
     * @param {?} settings
     */
    constructor(callHttp, dialogService, token, baseURL, settings) {
        this.callHttp = callHttp;
        this.dialogService = dialogService;
        this.token = token;
        this.baseURL = baseURL;
        this.settings = settings;
    }
    /**
     * @param {?} notificacion
     * @param {?} usuarioNotificacionId
     * @param {?=} sistemaId
     * @return {?}
     */
    SendNotificacion(notificacion, usuarioNotificacionId, sistemaId = this.settings.SistemaId) {
        if (usuarioNotificacionId == "00000000-0000-0000-0000-000000000000" ||
            usuarioNotificacionId == null) {
            this.dialogService.NotificacionAlert('Id de usuario invalido, notificacion no enviada...');
            return void 0;
        }
        /** @type {?} */
        let webPushMensaje = MessageFireBase.GetMessageFireBase(this.token.TokenId, usuarioNotificacionId, null, null, notificacion, null, sistemaId);
        this.callHttp.httpPostText(`${this.baseURL}api/FireBaseApi/sendmessaging`, webPushMensaje)
            .subscribe((/**
         * @param {?} response
         * @return {?}
         */
        response => {
            console.log(response);
        }));
    }
}
NotificacionFirebaseService.decorators = [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"], args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
NotificacionFirebaseService.ctorParameters = () => [
    { type: vesta__WEBPACK_IMPORTED_MODULE_3__["CallHttp"] },
    { type: vesta__WEBPACK_IMPORTED_MODULE_3__["DialogService"] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [FIREBASE_TOKENID,] }] },
    { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [BASEURL_FIREBASE,] }] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [Settings_FireBase,] }] }
];
/** @nocollapse */ NotificacionFirebaseService.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵdefineInjectable"])({ factory: function NotificacionFirebaseService_Factory() { return new NotificacionFirebaseService(Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵinject"])(vesta__WEBPACK_IMPORTED_MODULE_3__["CallHttp"]), Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵinject"])(vesta__WEBPACK_IMPORTED_MODULE_3__["DialogService"]), Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵinject"])(FIREBASE_TOKENID), Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵinject"])(BASEURL_FIREBASE), Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵinject"])(Settings_FireBase)); }, token: NotificacionFirebaseService, providedIn: "root" });
if (false) {}

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: vesta-firebase.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */


//# sourceMappingURL=vesta-firebase.js.map


/***/ }),

/***/ "./dist-library/vesta-menu/fesm2015/vesta-menu.js":
/*!********************************************************!*\
  !*** ./dist-library/vesta-menu/fesm2015/vesta-menu.js ***!
  \********************************************************/
/*! exports provided: VestaMenuComponent, VestaMenuModule, VestaMenuObjects, VestaMenuService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VestaMenuComponent", function() { return VestaMenuComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VestaMenuModule", function() { return VestaMenuModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VestaMenuObjects", function() { return VestaMenuObjects; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VestaMenuService", function() { return VestaMenuService; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var vesta_authentication__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! vesta-authentication */ "./dist-library/vesta-authentication/fesm2015/vesta-authentication.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var angular_sortablejs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! angular-sortablejs */ "./node_modules/angular-sortablejs/dist/index.js");
/* harmony import */ var angular_sortablejs__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(angular_sortablejs__WEBPACK_IMPORTED_MODULE_6__);








/**
 * @fileoverview added by tsickle
 * Generated from: lib/vesta-menu.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class VestaMenuService {
    constructor() {
        this.FavoriteSuject = new rxjs__WEBPACK_IMPORTED_MODULE_1__["Subject"]();
        this.FavoritesEvent = new rxjs__WEBPACK_IMPORTED_MODULE_1__["Subject"]();
        this._Favorites = [];
    }
    /**
     * @param {?} favorites
     * @return {?}
     */
    set Favorites(favorites) {
        if (!Array.isArray(favorites))
            favorites = [];
        this._Favorites = favorites;
        this.FavoriteSuject.next(favorites);
    }
    /**
     * @return {?}
     */
    get Favorites() {
        return this._Favorites;
    }
}
VestaMenuService.decorators = [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"], args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
VestaMenuService.ctorParameters = () => [];
/** @nocollapse */ VestaMenuService.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵdefineInjectable"])({ factory: function VestaMenuService_Factory() { return new VestaMenuService(); }, token: VestaMenuService, providedIn: "root" });
if (false) {}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/vesta-menu.objects.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var VestaMenuObjects;
(function (VestaMenuObjects) {
    class FavoritesOrder {
        /**
         * @param {?} id
         * @param {?} tittle
         * @param {?} ordenPrioridad
         * @param {?} icon
         * @param {?} count
         * @param {?} routerLink
         * @param {?} isStarFull
         * @return {?}
         */
        static getFavoritesOrder(id, tittle, ordenPrioridad, icon, count, routerLink, isStarFull) {
            /** @type {?} */
            let objectFavoritesOrder = new FavoritesOrder();
            objectFavoritesOrder.Id = id;
            objectFavoritesOrder.Tittle = tittle;
            objectFavoritesOrder.OrdenPrioridad = ordenPrioridad;
            objectFavoritesOrder.Icon = icon;
            objectFavoritesOrder.Count = count;
            objectFavoritesOrder.RouterLink = routerLink;
            objectFavoritesOrder.IsStarFull = isStarFull;
            return objectFavoritesOrder;
        }
        /**
         * @return {?}
         */
        static Mock() {
            return [{ 'id': '1', 'ordenPrioridad': 1 },
                { 'id': '2', 'ordenPrioridad': 3 },
                { 'id': '5', 'ordenPrioridad': 5 },
                { 'id': '8', 'ordenPrioridad': 6 },
                { 'id': '10', 'ordenPrioridad': 2 },
                { 'id': '12', 'ordenPrioridad': 4 },
                { 'id': '15', 'ordenPrioridad': 7 },
                { 'id': '18', 'ordenPrioridad': 9 },
                { 'id': '20', 'ordenPrioridad': 8 },
                { 'id': '23', 'ordenPrioridad': 12 },
                { 'id': '28', 'ordenPrioridad': 10 },
                { 'id': '30', 'ordenPrioridad': 11 }];
        }
    }
    VestaMenuObjects.FavoritesOrder = FavoritesOrder;
    if (false) {}
    class ObjetoSubmenu {
        /**
         * @param {?} id
         * @param {?} name
         * @param {?} urlicon
         * @param {?} count
         * @param {?} routerLink
         * @param {?} isStarFull
         * @return {?}
         */
        static getObjetoSubmenu(id, name, urlicon, count, routerLink, isStarFull) {
            /** @type {?} */
            let objectObjetoSubmenu = new ObjetoSubmenu();
            objectObjetoSubmenu.id = id;
            objectObjetoSubmenu.name = name;
            objectObjetoSubmenu.urlicon = urlicon;
            objectObjetoSubmenu.count = count;
            objectObjetoSubmenu.routerLink = routerLink;
            objectObjetoSubmenu.isStarFull = isStarFull;
            return objectObjetoSubmenu;
        }
    }
    VestaMenuObjects.ObjetoSubmenu = ObjetoSubmenu;
    if (false) {}
    class Data {
        /**
         * @param {?} menu
         * @param {?} submenu
         * @return {?}
         */
        static getData(menu, submenu) {
            /** @type {?} */
            let objectData = new Data();
            objectData.menu = menu;
            objectData.submenu = submenu;
            return objectData;
        }
        /**
         * @return {?}
         */
        static Mock() {
            return [
                {
                    menu: 'Aduanas', submenu: [
                        { id: '1', name: 'Cola Trabajo Analista Documentos', urlicon: 'images/transit.png', count: 7, routerLink: '/colatrabajoanalistadocumentos/index', 'isStarFull': 0 },
                        { id: '2', name: 'Principal Gestor Logistico', urlicon: 'images/transit.png', count: 19, routerLink: '/principal/index', 'isStarFull': 0 },
                        { id: '3', name: 'Submenu Aduanas 3', urlicon: 'images/transit.png', count: 4, routerLink: '', 'isStarFull': 0 },
                        { id: '4', name: 'Submenu Aduanas 4', urlicon: 'images/transit.png', count: 3, routerLink: '', 'isStarFull': 0 },
                        { id: '5', name: 'Submenu Aduanas 5', urlicon: 'images/transit.png', count: 2, routerLink: '', 'isStarFull': 0 },
                        { id: '6', name: 'Submenu Aduanas 6', urlicon: 'images/transit.png', count: 6, routerLink: '', 'isStarFull': 0 },
                        { id: '7', name: 'Submenu Aduanas 7', urlicon: 'images/transit.png', count: 7, routerLink: '', 'isStarFull': 0 },
                        { id: '8', name: 'Submenu Aduanas 8', urlicon: 'images/transit.png', count: 9, routerLink: '', 'isStarFull': 0 },
                        { id: '9', name: 'Submenu Aduanas 9', urlicon: 'images/transit.png', count: 11, routerLink: '', 'isStarFull': 0 },
                        { id: '10', name: 'Submenu Aduanas 10', urlicon: 'images/transit.png', count: 3, routerLink: '', 'isStarFull': 0 },
                        { id: '11', name: 'Submenu Aduanas 11', urlicon: 'images/transit.png', count: 1, routerLink: '', 'isStarFull': 0 },
                        { id: '12', name: 'Submenu Aduanas 12', urlicon: 'images/transit.png', count: 6, routerLink: '', 'isStarFull': 0 },
                        { id: '13', name: 'Submenu Aduanas 13', urlicon: 'images/transit.png', count: 0, routerLink: '', 'isStarFull': 0 }
                    ]
                },
                {
                    menu: 'Torre',
                    submenu: [
                        { id: '14', name: 'Submenu Torre 1', urlicon: 'images/transit.png', count: 10, routerLink: '', 'isStarFull': 0 },
                        { id: '15', name: 'Submenu Torre 2', urlicon: 'images/transit.png', count: 20, routerLink: '', 'isStarFull': 0 },
                        { id: '16', name: 'Submenu Torre 3', urlicon: 'images/transit.png', count: 30, routerLink: '', 'isStarFull': 0 },
                        { id: '17', name: 'Submenu Torre 4', urlicon: 'images/transit.png', count: 1, routerLink: '', 'isStarFull': 0 },
                        { id: '18', name: 'Submenu Torre 5', urlicon: 'images/transit.png', count: 7, routerLink: '', 'isStarFull': 0 },
                        { id: '19', name: 'Submenu Torre 6', urlicon: 'images/transit.png', count: 9, routerLink: '', 'isStarFull': 0 },
                        { id: '20', name: 'Submenu Torre 7', urlicon: 'images/transit.png', count: 11, routerLink: '', 'isStarFull': 0 },
                        { id: '21', name: 'Submenu Torre 8', urlicon: 'images/transit.png', count: 23, routerLink: '', 'isStarFull': 0 },
                        { id: '22', name: 'Submenu Torre 9', urlicon: 'images/transit.png', count: 14, routerLink: '', 'isStarFull': 0 }
                    ]
                },
            ];
        }
    }
    VestaMenuObjects.Data = Data;
    if (false) {}
})(VestaMenuObjects || (VestaMenuObjects = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: lib/vesta-menu.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class VestaMenuComponent {
    /**
     * @param {?} menu
     * @param {?} menuAuthentication
     */
    constructor(menu, menuAuthentication) {
        this.menu = menu;
        this.menuAuthentication = menuAuthentication;
        this.btnsChangeOrd = false;
        this.data = [];
        this.favoritesOrder = [];
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_2__["__awaiter"])(this, void 0, void 0, function* () {
            yield this.GetMenu();
            if (this.menu.Favorites.length > 0) {
                this.favoritesOrder = this.menu.Favorites;
                this.matchFavorites();
            }
            this.menu.FavoriteSuject.subscribe((/**
             * @param {?} response
             * @return {?}
             */
            response => {
                this.favoritesOrder = response;
                this.matchFavorites();
            }));
        });
    }
    //async GetMenu() {
    //  this.data = await this.menu.GetMenu();
    //  this.matchFavorites();
    //}
    /**
     * @return {?}
     */
    GetMenu() {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_2__["__awaiter"])(this, void 0, void 0, function* () {
            /** @type {?} */
            let menu = yield this.menuAuthentication.MenuAuthentication;
            /** @type {?} */
            let arrayMenu = [];
            menu.Epics.forEach((/**
             * @param {?} f
             * @return {?}
             */
            f => {
                /** @type {?} */
                let submenu = [];
                f.Features.forEach((/**
                 * @param {?} ff
                 * @return {?}
                 */
                ff => {
                    if (ff.Backlogs.length == 1) {
                        let [backlogs] = ff.Backlogs;
                        /** @type {?} */
                        let obj = { id: backlogs.Id, name: ff.Nombre, urlicon: "", count: 0, routerLink: backlogs.Uri, isStarFull: false };
                        submenu.push(obj);
                    }
                }));
                /** @type {?} */
                let menuItem = VestaMenuObjects.Data.getData(f.Nombre, submenu);
                arrayMenu.push(menuItem);
            }));
            //console.log(arrayMenu);
            this.data = arrayMenu;
        });
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        $('.btn-close').click((/**
         * @return {?}
         */
        function () {
            $('#btnFavorites').removeClass('active');
        }));
    }
    //showModalFavorites() {
    //  this.modalFavorites.showModal();
    //}
    //Prueba(id: string) {
    //  console.log("prueba " + id);
    //  let ids = '#' + id;
    //  $(ids).removeClass('mif-star-empty').addClass('mif-star-full');
    //  //this.renderer.removeClass(this.btnFavorite.nativeElement, 'mif-star-empty');
    //  //this.renderer.addClass(this.btnFavorite.nativeElement, 'mif-star-full');
    //}
    /**
     * @return {?}
     */
    matchFavorites() {
        //let listaSubmenu = this.data.map(d => d.submenu).reduce((acc, val) => acc.concat(val), [])
        //  .map(m => VestaMenuObjects.ObjetoSubmenu.getObjetoSubmenu(m.id, m.name, m.urlicon, m.count, m.routerLink, m.isStarFull));//.toArray();
        //let listaSubmenu = [];
        //for (let i = 0; i < submenus.length; i++) {
        //  for (let j = 0; j < submenus[i].length; j++) {
        //    listaSubmenu.push(VestaMenuObjects.ObjetoSubmenu.getObjetoSubmenu(submenus[i][j].id, submenus[i][j].name,
        //      submenus[i][j].urlicon, submenus[i][j].count, submenus[i][j].routerLink, submenus[i][j].isStarFull))
        //  }
        //}
        //Ordenar los favoritos por orden de prioridad
        //this.favoritesOrder = listaSubmenu;
        //listaSubmenu.Enumerable().join(this.favorites, s => s.id, z => z.id,
        //  (x, y) => VestaMenuObjects.FavoritesOrder.getFavoritesOrder(y.id, x.name, y.ordenPrioridad, x.urlicon,
        //    x.count, x.routerLink, x.isStarFull))
        //  .orderBy(o => o.ordenPrioridad).toArray();
        //Actualizar la data, es decir cambiar en la clase del icono 'mif-star-empty' por 'mif-star-full' eso no se harìa aqui, sino que en el template
        for (let i = 0; i < this.favoritesOrder.length; i++) {
            for (let j = 0; j < this.data.length; j++) {
                for (let k = 0; k < this.data[j].submenu.length; k++) {
                    if (this.favoritesOrder[i].Id === this.data[j].submenu[k].id) {
                        this.data[j].submenu[k].isStarFull = true;
                    }
                }
            }
        }
        //No lo borre, quiero ver si se puede hacer de esta forma... Por ahora, no funciona
        //this.data = Enumerable.from(this.favoritesOrder)
        //    .join(submenus, f => f.id, d => d.id,
        //        (x, y) => Data.getData('Prueba', [x.id, x.name, x.urltransit, x.count, x.routerLink, 1])).toArray();
        //this.data2 = Enumerable.from(this.data).select((s,i) =>
        //    Enumerable.from(s[i].submenu).join(this.favoritesOrder, r => s[i].id, f => f.id,
        //        (xsub, yf) => Data.getData(s.menu,
        //            [{ id: s[i].id, name: s[i].name, urltransit: s[i].urltransit, count: s[i].count, routerLink: s[i].routerLink, isStarFull: 1 }]))).toArray();
        //console.log(this.data2);
    }
    /**
     * @param {?} id
     * @param {?} index
     * @return {?}
     */
    getFavorites(id, index) {
        /** @type {?} */
        let favorite = this.favoritesOrder[index];
        this.favoritesOrder.splice(index, 1);
        this.menu.FavoritesEvent.next({ Add: false, Favorite: favorite });
        let [submenu] = this.data.filter((/**
         * @param {?} s
         * @return {?}
         */
        s => s.submenu.some((/**
         * @param {?} ss
         * @return {?}
         */
        ss => ss.id == id)))).map((/**
         * @param {?} m
         * @return {?}
         */
        m => m.submenu))
            .reduce((/**
         * @param {?} acc
         * @param {?} val
         * @return {?}
         */
        (acc, val) => acc.concat(val)), []).filter((/**
         * @param {?} f
         * @return {?}
         */
        f => f.id == id));
        submenu.isStarFull = false;
    }
    /**
     * @param {?} id
     * @param {?} subMenuIndex
     * @param {?} dataIndex
     * @param {?} boolStar
     * @return {?}
     */
    setFavorites(id, subMenuIndex, dataIndex, boolStar) {
        if (!boolStar) {
            this.SetFavoritesAdd(subMenuIndex, dataIndex);
        }
        else if (boolStar) {
            this.SetFavoritesDeleted(subMenuIndex, dataIndex, id);
        }
    }
    /**
     * @private
     * @param {?} subMenuIndex
     * @param {?} dataIndex
     * @return {?}
     */
    SetFavoritesAdd(subMenuIndex, dataIndex) {
        /** @type {?} */
        let submenu = this.data[dataIndex].submenu[subMenuIndex];
        submenu.isStarFull = true;
        /** @type {?} */
        let favorite = VestaMenuObjects.FavoritesOrder.getFavoritesOrder(submenu.id, submenu.name, this.favoritesOrder.length + 1, submenu.urlicon, submenu.count, submenu.routerLink, true);
        this.favoritesOrder.push(favorite);
        this.menu.FavoritesEvent.next({ Add: true, Favorite: favorite });
    }
    /**
     * @private
     * @param {?} subMenuIndex
     * @param {?} dataIndex
     * @param {?} id
     * @return {?}
     */
    SetFavoritesDeleted(subMenuIndex, dataIndex, id) {
        this.data[dataIndex].submenu[subMenuIndex].isStarFull = false;
        /** @type {?} */
        let index = this.favoritesOrder.Enumerable().indexOf((/**
         * @param {?} i
         * @return {?}
         */
        i => i.Id == id));
        /** @type {?} */
        let favorite = this.favoritesOrder[index];
        this.favoritesOrder.splice(index, 1);
        this.menu.FavoritesEvent.next({ Add: false, Favorite: favorite });
        //this.favoritesOrder = this.favoritesOrder.Enumerable().select((s, i) =>
        //  VestaMenuObjects.FavoritesOrder.getFavoritesOrder(s.id, s.tittle, i + 1, s.icon, s.count, s.routerLink, s.isStarFull)).toArray();
    }
}
VestaMenuComponent.decorators = [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{
                selector: 'vesta-menu',
                template: "<div class=\"\">\r\n  <div class=\"imagenFondo\">\r\n    <br /><br />\r\n\r\n    <!--Lista de favoritos-->\r\n    <h2 style=\"font-size:24px; margin-top:25px; padding-left:18px; font-weight:600\">Favoritos</h2>\r\n    <div class=\"grid\">\r\n      <div class=\"flex-grid\">\r\n        <div class=\"row flex-wrap\" [sortablejs]=\"favoritesOrder\">\r\n          <div class=\"cell-auto-size\" *ngFor=\"let subitem of favoritesOrder;let i = index\">\r\n            <!---->\r\n            <div class=\"card divOpMenu border bd-grayLight bd-darkAmber-hover fg-darkBlue text-bold bg-white cell\" [routerLink]='[\"/\" + subitem.RouterLink]'>\r\n              <!---->\r\n              <div class=\"card-body\" style=\"cursor: pointer; height:130px;\">\r\n                <button class=\"iconFavorite bg-white border bd-white\" (click)=\"getFavorites(subitem.Id,i)\">\r\n                  <span [attr.id]=\"subitem.Id\" class=\"mif-star-full fg-darkOrange\"></span>\r\n                </button>\r\n                <span class=\"tittleOpMenu text-left\">{{subitem.Tittle}}</span>\r\n                <span class=\"mif-infinite iconOpMenu\"></span>\r\n                <span class=\"countBottom bg-darkOrange fg-white\">{{subitem.Count}}</span>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <!--Submenus-->\r\n    <div class=\"grid\">\r\n      <div class=\"flex-grid\">\r\n        <ng-template ngFor let-j=\"index\" let-item [ngForOf]=\"data\">\r\n          <h2 class=\"cell-auto-size fg-darkGrayBlue\" style=\"font-size:24px; padding-left:18px; font-weight:600\">{{item.menu}}</h2>\r\n          <div class=\"row flex-wrap\">\r\n            <div class=\"cell-auto-size\" *ngFor=\"let subitem of item.submenu; let i=index\">\r\n              <!---->\r\n              <div class=\"card divOpMenu border bd-grayLight bd-dark-grayBlue text-bold bg-white cell\">\r\n                <!---->\r\n                <div class=\"card-body\">\r\n                  <button class=\"iconFavorite bg-white border bd-white\" (click)=\"setFavorites(subitem.id, i, j, subitem.isStarFull)\">\r\n                    <span [attr.id]=\"subitem.id\" class=\"fg-darkOrange\"\r\n                          [ngClass]=\"{\r\n                          'mif-star-empty': !subitem.isStarFull,\r\n                          'mif-star-full': subitem.isStarFull\r\n                          }\">\r\n                    </span>\r\n                  </button>\r\n                  <div [routerLink]='[\"/\" + subitem.routerLink]' style=\"height:130px; width: auto;cursor: pointer;\">\r\n                    <span class=\"tittleOpMenu text-left\">{{subitem.name}}</span>\r\n                    <span class=\"mif-infinite iconOpMenu\"></span>\r\n                    <span class=\"countBottom bg-darkOrange fg-white\">{{subitem.count}}</span>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </ng-template>\r\n      </div>\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n",
                styles: [".imagenFondo{background-image:url(data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBxITEhUTExMVFhUXGBsYFxgYFxoaGhgaGBsYGhsZGhcYHSggGholGxgbITEhJSkrLi4uGB8zODMtNygtMCsBCgoKDQ0NDg0NDisZFRkrNzcrKzcrKzcrKzcrNzcrKysrKzcrKysrKysrKysrKysrKysrKysrKzcrKysrKysrK//AABEIAMkA+wMBIgACEQEDEQH/xAAYAAEBAQEBAAAAAAAAAAAAAAABAAIDB//EADYQAAEDAQcEAgIBAwMEAwEAAAEAESExAkFRYXGBkaGxwfDR4QPxEiIyQlJyghOywtJzkqIE/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAH/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwD2Zg/rzf0UQ/TlIEjnr9rItQ4YxGZlh1UGSBGg7+TCmwz92WrOD1G/oQRL4AucDegv48/TPoixZfnnI5XrV7HUcwFB5F42dkHO0Hka9ejLX5KaA6ZmMVWSK3ROhPRLQ1/RyEGTZ7/+NOJVZZhUwOLtxCbTsBiJ0pzRQtdxPDNkaID+MHFq4Ew4GBSbLxNKYg1BzhFsXZvs57rZktdfnnsUGI8k+dUtjWPPQpsmcA/WehRYFA2uTUHfhBke8/MLbb/Zjog2hV4FdMc5C0OJPeu47oMkDq3RmVbqeu4hs01mXvxYXayoEVePWIxd0ERXtm4bZRZjBeeb/kKaM26TTVIF+NdbzsgPeleEicvsUynsizRzdTXLVloDnDJ4jH4QZIkAYHeZfMFaYV16/pZs1Jugcdi7jhaFX6b/AGgRX3CQssO27UTZzqCHyj4KLJv40u0QQ95r4VaHHZyzalNoVzp5U7T7UnogAKj39hUduvyyrMae8qa6uuFEAR54w1Wbdib9jC1bO48RJzeFv/pZoIXYy+rDx3CP40uFAMvlaOFLt26x2V70rkgyQd6+5KrPfCe6WnPHJ6K6/oxmgyS75M2rO2rJNAee/uq1Yb5+Vlv6Qgw1cbxnDDJatX9MYqq0Hpn2HKadUB+Shapv88LFlsNrhC6fkDtkfHa5Z/HTDK9rhkg08vU37UGVVhms9ScrzofK0BBB5x0xTau38QgGqBtlgM0WRBGPRz3C1cR7SBkqxfccdGlACJxrr8IAw/UdVqzFzXbz3RjcK7MOGZAO08+CdkMzi58oDdlr8t2vivhNoduckGSGGXanJvT8Trj8qap31wOTJPz27FAWhPQasT2Ka6NOjdCr+M6/H1VL379LsUAZYZ9r9HbhRMnIR57hIqNCOohA+Sgm49Yp6esq0IetSk+hBk4cazGafdYqgiGvI8Rotsg5gQRhRJH0te9EPF8j44KAtXPT7DHL3BZH5GgkuI4W3nr4WLdkklm6IOgF222WlEWTfj6IS+POT/SvgCEBSP366uwr1cdkWbbB757t3VQDER25QVsRF8fvI0Sage4fKhybh46rIEGaw/fdAChw7ii0RUYn7bdFmZyHcqLARnOiBrHHuSAbzlDTSuqmDe4OB7gqs317TwgbIuP7f5WbINLx6W8Jt0fN+rHl4VpUjciOyCPk7Z7Moh4vu0LtsWULQrT133WbhGHW7OUCSNverrTU8XXItGnPEJnr5jYoJnIy7oBcOfT8hFujXUOdQ32tmoy83oAjqOFZ7D95os0b2/og9B4Y8hBo48/Oym+d6Twi0Z1P2+b3q96u2iDWev2FCji+/wA+4IvbEc3IsmN9gXppCDTd9ip7x7hCCKapBnKDz9oE3C8qJ785IF59r8K14yc9ZQVqjY+npCjgMK4XOqxWawWw+kWJ6Hcjsg0Mdd59KLNnThVowScO0J/kqDr2o76KA8d5UzN7qNPhDmu5zpOygQffckO77qtVinjBFqfGZn5QNk/L9eiLMgZzlS5VrDEdJkZqtVa4Vweo7dUE75C/QjpegsAd/Crd/QdCq0HLYycsGQO946j5QS12GmigZbjzsodYjh+EEOYjYX7qtGPOdVCGwPjylrtPdCgLZlj6wdtJVRhkN5n6QeXJBGTM3RL3ExUHCY4hBWoGf3G2KiPIbq3RAq50A9xqkd3BOkcoK2aZmOH5C0T9cX5LNm1/lcB6UWcTUwB42QVqzV8CwyLEjso95GzTzVFkPvU09MLYmeN6cugrWF/avR4UGA28QFklxo4+RmaJFNoOdJGIjlA2ffkKvOT/AEM3dRl8R7wVn+TiMG+N5rkg6Wa+3CizYPj98JId5bA8fpH8sK+YA4QL3e1+Fffz5Cj+/jqoltqcQ+SC/wBWVNWvyUP30MKMAVf7dVvC6kbwMCEEcs+h+eyHzZNomMaDDU5Mt2LMfKDBpNK9YGtFdYA69vtT3U/dVA/Pzz5QTtSs/H2s/wAbtnwESPcFM7nWN35UTHJ4pF6DVk3Zl9XWXg5kD5Gf2mzV8PeFzFLWR7YINgF8KTvG3yskQwzc8v1WrBJGND1iOHQTeMPknaiBtC7CmrUzQcOORIQwA/7RoLs4Sc9QMn61lAW7UH/7aVniqrZkXXcEPrFFfkNd7O5I6XohxfB4iNfhBoZ18DPFyhoaNsTHCrNZy7wWQSSNWjOp2+UGrRpvvcokbdwSGOrouf2vhJPGODEX5oM2qakDqT1DQtUZpZm5ncBFsRjf1psq0JBvLDr3QTbU7wU2avTDXDPJT45TuYfNuqycDt7iEGx1LBvbwh+vFaoJYsK1fieIUGfTpMh0HQH+p2rHHyCj8Y93q6LI/qGT9TTVX4zhfPXuyAstGEHvO60NK3a1HlY/HQETScmN/tVp+jT3QNbqzuD4UOT9lTM+Xr6Kyp+8M0GrNdP2sWJa+hnN8PZWrJmbx9VxRZFLqDDVBdz9juFCLxjzKNIgRo8ZGVm3ZskubLnFgg28zRyB0nkLLOGvoehI3FFq9s/Qe6sQMp9vAQX8uB66yzeMA9yePaciqrUbPwPYQVsfe9d1m0f6nuNfcVuywb2G7rNgNGj/AD2QRcdgcDVtEuxjIHoyLIMi6k4Xgoxzd8aRugBUk0DnNqk8psjnoHq2RZRs3Zj3RwoXA0jmfdkBBOXfPKqLJd7WLNlh9pIcE0il5i9JBbru1dEFYLOcDPctkoBpaA7D28sE/wAB9YRTSqwC44PuYQIvmsg/GlE2XgMLyfc5KCK4y3MbEVSfnpHlBWbU5EdM8JKgIY1Ev5GshRs0yYvsz8qtztTi/JBPSGYSNqcLP8mi6CPB5SfniHPZFqoyp7qg0zal3PnKqLJv4GJkkLV/T65WTGZbw4PuKBuJvPbHPBRgNS/9cJAl9SctMkC87fCBpdoOH4qm1GtSfLZoh3d/XQB4fzsg0f2NP0p33pwWdRFe2/eVETn3aO6BOVQos7wR+y77qDuTvu3ZQs4caMzIICgvqOlc2K1Y/LF/CyT55eTysWvxFy1ppog3aETT7jcOonGLztf8o/lL1ngY8hFWA3PBDZGUGhZ5Y9ZUbXYlvcFm0XkXD9/SbVXF/INAQMECOvmj5osUPO9Tsh8Lg/N3lD0OMe5/CBGWHnwklw+p6d6LNqhNxvwz0VbN+HUR0QLtjUMNAzI/izXx2PRnVaN91w1u1dAwN7EnE3dAgfyGDi5A3LVxA7JtQ2NNHuOqyKgmAKdHcKeHvMAYZPkg0OT41yWSYEydqGvZ0ExoSXxh4WnqToOY6FBWxhmOZU/cvyzZrIqXpans+lYTZMydDrTsgSOHnu+irVRnHEosHEVuwyzvKBeC9ebx7ggQb6g+0S087OAJ1UARJu6wHIyuWXY0giB47FBo5XX6BmyKXiLr9Cz6LD3PUOc/2/RT8szXAyxORfsg2B/Vo+xMtoqtKY71fdFqAwqT9n3NH5MMA+u2I8oNWTRqOPckipFwYcftBMxXoKQi1/pHuAdAmp/dT3W3ljzu4nZYfEyPCfxl3xemEe8oNWYM1prl1WfxhhuBGTouOI7eLjwtfyv093dBA4tTafDp/jXU111Q0AZnY4d1r8dstRBgCOvjgrJmGYXjWoKRZpiSx1AbgsOiSJY7HvGKAtlvi8sROyKS7SPJffwk2mk1oOpHN6iGzPj4QP4xSGyyAouYP9O4+FsiHmg5HlZs2WFkcxwcpQNoN2ba7VQEYO7vwx0Q25p0+k/kv6bhiWyQZNruHGTV5TZs0fTRhaL703S1WqJ4+RCLNgQ0QBk0xqgyJsu10DaQE2/8cGJ6Ra1numzMHJ9CKHlFRmK710CBI9wLV0YIsTOF2rOPKhZqRceYEDe9QxFb85rqAEED/U1Zf/8AUcIEZz3EnxC1ewi86mRsZdFjAUx5jZBERuGGgZNquw2LEPwizZoJxL1jHOiSH/lx0pogLVq7MhsIectFNvPRvDLNmaUY6mKZFbIPRzrR+O6DFuDxO3aei0YDNl0dnT+StmjVyBZuoLIswBpQ1AaZx+UCRI3c406oMnl92A2hloi8XHhwPSi1XUR5HR0Dah9SOntVMMWep37/ACppOF+kKNlhlXz+kFnQ/thpekPh6yGeTsORyQU1bC8YBmLoGyA508LNmj0g7mOaJs0JF9Mrhtepm7Abf29ED+ny+Vy/NbIJgnQ2QOsrs2NJ4u+Fg/jF78INYEVw4jZQEtkOhhVqr5DweyfescoM2ZYm73qgGHN4L8UCY6Wu89aKPVzywYoHsPQVkGpOX6zWhnj37iFmzQZn5PCCumhE7me6nvN1Ncjmk+5X+UkbVbhAAS9/t+QWGiKV0ZuSn8Ywy7U8psZG4fZ1QFq1U4Hpjq7PumkjfLHlApgWOzz1ZQuwmOs6IFuPsxGCCYFq922u+1CzeDB9/koeBs58lBWu/wCyMkWjvJbp1Uwm8Me8jVaxzv7H3BAmHxN+FWOlEflshhZuw8LN2fl6aFat9GHAnkIMPS8+HYziGW7MPjfrHdFrLOczQ91ATrdtTiUB+QXYmNZjZJtNq0HIGp5QCNoxmI3aVr+ObwOZe1gxZAgSRcZ5x1KAJ/idjfUP2RZLsdWGskFaYSDj2nogBaIk1LTdMdgn+Amzd2wlVl2EvTrU6fKm8d/lBWr8oGjh02ppfXO7g4oI891GY17uOgQIlsLs/ZVe+Yrh8uqzWLgPkd0MOkbX9UEDtZZzrUuGp5W/+q0R7sskcMeFm0zyHQas1apB8FjwgGMQfqHzWn2N3R9kBqUDeWCAOfPY7JJbV3KrFxIdnQI1vzLUPt6CJvgwGzMxpnqh2YD3NJF/Ay+lWTNo7DwgLRYMLqnCoqq0W3LDid1WY4MYl57ppJwgdoQV5ArB+FmINBE+/wCJ8p/iWrNecFWquK3jOGGSAszBr5adWcqBcNLi73Iqt35ORoK9Q/C1bEviOo+QeiDJN+Mg5swfLJVYvu0ee0JNnDGRvMoBh3l+j+HQJtPFzT7k0oBpcH637EK/KIwkk5XknI+Vp2LD9ZZ/SDAsv/EYCW0geUi05yBDHz1ZJLCP0SW5WbZY2Q0POGQORKBJ2qw1uOI+VETp5noG5SCbpOLZyG7IEQHhp5vxiUELYi1l+iByqwKRLSBS+GQzObi4OW+C1QOMN7o1QDx/If8AL5JyWsTj3+FWQAcqHUGftAhgaUPLB9UDQxdUcMBhCv5CtyrQPbWv0rHAsckCccaDIqs1bCvF2dEWv1sRctEcfBgugyLVS1TGeG7Dum/M/DOcoChJFzTuX93UDJfHWKNpegrLSbpfmQNwsWgXo+brdzmBHMy6haNzDL0oEigy8hx8K3z2eOFrLGvuKyDf7Jr1lBm1fv1NM3UTdi4SA0e3R3VrSd8/CCsmXzftxosihGflNmmRuwwDYKDORcfW1ed0EMPYMlBLFzR64OfOCcXuk5tQsNKKHQ956YIBjuKnGJCrcmMCH4L50SLP+I+2ulFqRlTV2nnogLZg6WukKI/tfP3IFP5LN2b6Zdks5yA5Bk9hwgLQemnBn95qJj3FRMPURvQi0kCW1JyyQZt/+z8+UmYyY50l8R5UL8pGiq9dkC91GPp0KCJdrgG3p1TZs1BzbeR8osUGIuvY9jfsgQXppqxrsyrBlqGvPgsiyHZzuLg78F02A90j1s0GbIYGGB/x0g2c6dVAQ9K7uYOo8psmP5G+nUiMcUt2rg+HCCtGm+n6S7Hem/pQDe1IHwkXXn03IKyKXXd2KCcsA26TZzwn265OfS/TaqDIjOvdN/ryfCswa3547pGWOxvKBB/q2+VmwW6eRykGAbmnvsyDwCROc04QQsnVgOXM6LFqyTNm0QDQLppxjXuUixZMkOgAaavy8zcjXCnAZ8ytGsemIQwfGveRqEGXF/OhI6KyNxZ+vVLxGf19o6/qUER2AjfhFk3ktc+ZN2aSb6iubAd1NBMVfLXhAWjcYI74ZiVWxUYxuA+whTwd+7VuJdaN2H18oMXNi3W/VnSDeBcNL7s3WrI8c37LNgkh9DgghlJbga7I/GzRfL4sHTQHAA9KJ/GIfAl/eUASZa/yLsLkGB3N/wDd5LpsHYXcx4Vd7igCa5Pv/HwPKR1v7nlV3LZ4c3pAx/cBBkXZeajUEBRNSK1PWdYATdrQ5Z5ptZM7U77IBsM42pkoig21h+irYHffFatV38XboMi1Q5PTGX0hTGBQBuxcPeCEl4gXBuX2wVbGMxy3kIA2nbC7O/kMkn+onbgPw5STIG+1x+VS+d2QehzZBWbL10bW7NALzpw5D64pIniMvpXwD1rwEA7aOdm8JAoM+3dRvGobhhuEgVxfq/hBA8VnP7QKZY7S+C0JPvsrNmmN3WRsgTUHBz2jVYtECJ2H2tfZ3x+lj8jvFoDJkHVrrr/gZhZJgXG4bhz7im1d/vPa0g1Oh7BBEs3WcflV/O4/ZV+Sh2T+Wm4/7ggwSQx3I4D6ALQg5GmAyzxXP8tT/wDGe61/p18BAkNsIzw3hBiecneTrRX5Kf8ALwUW629PAQa/jLXX4YtsivEDJ2fom3/l/t/9k2P77On/ALIC1VhUycsNslWOgjj1tln/APlu/wCSyP7OEGzacO1LsvpI8l9T4WbVfyaf+KrP9v8AxHlBoGCIxGjln1ZZE4y4PuyfyUGnwi3/AHjTzaQaMxcaG77aFWcLwce+08LFmlnS13srdr+46jsUAJDM4qa4uOtyRdyDt2KbNbfv+NlcrF3+3yEHTvRr9NnU2dQ5PlaP91nUrjau1/8AG0g64k7Z3DlVBn19hVv+0+3rVq/Q9igzZaf9LA54plszdp9LldY9uXQ0H+0IK1IyNa00xSR4Y9YfGibNTr4C5fi/ssbdig2TD337VBOSbQxoW6dmZQoNEGh0P/aUDaHN2dW5ULVm/wDjuqzQaLn+SqD/2Q==)}.tittleOpMenuFavorite{height:32px;position:absolute;top:26px;font-size:11px;right:9px;line-height:13px;word-break:break-word;padding:3px 1px;width:90%;font-weight:600}.divOpMenu{height:130px;width:130px}.iconOpMenuFavorite{max-width:33%;height:33%;position:absolute;top:75%;left:25%;-webkit-transform:translateY(-50%) translateX(-50%);transform:translateY(-50%) translateX(-50%);font-size:50px;line-height:50px;z-index:2}.multi-action{display:inline-block;position:relative;width:56px;height:56px}.button-position{position:fixed;width:60px;height:60px;bottom:40px;right:40px}.countBottomFavorite{right:10px;bottom:15px;position:absolute;display:block;padding:4px 8px;font-size:12px;text-align:center;z-index:2}.iconFavorite{top:1px;right:10px;position:absolute;display:block;padding:4px 8px;font-size:15px;text-align:center}.ul-Favorites{border:1px solid #dbdbd3;font-size:15px;background-color:#f5f5f2;padding:0;min-height:50px}.li-Favorites{color:#66665d;list-style-type:none;padding:10px;cursor:pointer;border-bottom:1px solid #dbdbd3}.leftButton{bottom:68px;right:10px}.rightButton{bottom:68px;left:37px}.countBottom{right:10px;top:102px;position:absolute;display:block;padding:4px 8px;font-size:12px;text-align:center;z-index:2;border-top-left-radius:3px;border-top-right-radius:3px}.iconOpMenu{max-width:33%;height:33%;left:4%;-webkit-transform:translateY(150%) translateX(10%);transform:translateY(150%) translateX(10%);font-size:50px;line-height:50px;z-index:2}.tittleOpMenu{height:32px;position:absolute;top:26px;font-size:11px;right:9px;line-height:13px;word-break:break-word;padding:3px 1px;width:90%;font-weight:600}.card{border-radius:5px;margin-left:10px;margin-right:10px;z-index:3}.card-header{border-bottom:1px solid #eee;padding:1rem;font-size:16px;border-radius:2px 2px 0 0;display:block}.card-content{display:block}"]
            }] }
];
/** @nocollapse */
VestaMenuComponent.ctorParameters = () => [
    { type: VestaMenuService },
    { type: vesta_authentication__WEBPACK_IMPORTED_MODULE_3__["MenuAuthenticationService"] }
];
if (false) {}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/vesta-menu.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class VestaMenuModule {
}
VestaMenuModule.decorators = [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"], args: [{
                declarations: [VestaMenuComponent],
                imports: [
                    _angular_common__WEBPACK_IMPORTED_MODULE_5__["CommonModule"], _angular_router__WEBPACK_IMPORTED_MODULE_4__["RouterModule"], angular_sortablejs__WEBPACK_IMPORTED_MODULE_6__["SortablejsModule"] //ModalModule
                ],
                exports: [VestaMenuComponent],
                providers: [VestaMenuService]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: vesta-menu.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */


//# sourceMappingURL=vesta-menu.js.map


/***/ }),

/***/ "./dist-library/vesta/esm5/lib/service/array-extends.js":
/*!**************************************************************!*\
  !*** ./dist-library/vesta/esm5/lib/service/array-extends.js ***!
  \**************************************************************/
/*! exports provided: ArrayExtends */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ArrayExtends", function() { return ArrayExtends; });
/**
 * @fileoverview added by tsickle
 * Generated from: lib/service/array-extends.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var Enumerable = __webpack_require__(/*! linq */ "./node_modules/linq/linq.js");
Array.prototype.Enumerable = (/**
 * @template T
 * @return {?}
 */
function () {
    /** @type {?} */
    var array = this;
    return Enumerable.from(array);
});
var ArrayExtends = /** @class */ (function () {
    function ArrayExtends() {
    }
    return ArrayExtends;
}());

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXJyYXktZXh0ZW5kcy5qcyIsInNvdXJjZVJvb3QiOiJuZzovL3Zlc3RhLyIsInNvdXJjZXMiOlsibGliL3NlcnZpY2UvYXJyYXktZXh0ZW5kcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7SUFBSSxVQUFVLEdBQUcsT0FBTyxDQUFDLE1BQU0sQ0FBQztBQUVoQyxLQUFLLENBQUMsU0FBUyxDQUFDLFVBQVU7Ozs7QUFBRzs7UUFDckIsS0FBSyxHQUFhLElBQUk7SUFDMUIsT0FBTyxVQUFVLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxDQUFDO0FBQ2xDLENBQUMsQ0FBQSxDQUFBO0FBRUQ7SUFBQTtJQUEwQixDQUFDO0lBQUQsbUJBQUM7QUFBRCxDQUFDLEFBQTNCLElBQTJCIiwic291cmNlc0NvbnRlbnQiOlsidmFyIEVudW1lcmFibGUgPSByZXF1aXJlKFwibGlucVwiKTtcclxuXHJcbkFycmF5LnByb3RvdHlwZS5FbnVtZXJhYmxlID0gZnVuY3Rpb24gPFQ+KCkge1xyXG4gICAgbGV0IGFycmF5OiBBcnJheTxUPiA9IHRoaXM7XHJcbiAgICByZXR1cm4gRW51bWVyYWJsZS5mcm9tKGFycmF5KTtcclxufVxyXG5cclxuZXhwb3J0IGNsYXNzIEFycmF5RXh0ZW5kc3t9XHJcbiJdfQ==

/***/ }),

/***/ "./dist-library/vesta/fesm2015/vesta.js":
/*!**********************************************!*\
  !*** ./dist-library/vesta/fesm2015/vesta.js ***!
  \**********************************************/
/*! exports provided: AccesoDenegadoComponent, ArrayExtends, CallHttp, DialogService, InterceptorSpinnerService, Mapper, PageNotFoundComponent, VestaModule, ɵa, ɵb, ɵc */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AccesoDenegadoComponent", function() { return AccesoDenegadoComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ArrayExtends", function() { return ArrayExtends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CallHttp", function() { return CallHttp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DialogService", function() { return DialogService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InterceptorSpinnerService", function() { return InterceptorSpinnerService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Mapper", function() { return Mapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PageNotFoundComponent", function() { return PageNotFoundComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VestaModule", function() { return VestaModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵa", function() { return AUTHENTICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵb", function() { return HttpCancelService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵc", function() { return ManageHttpInterceptor; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");







/**
 * @fileoverview added by tsickle
 * Generated from: lib/service/dialog.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DialogService {
    /**
     * @param {?} mensaje
     * @param {?=} tittle
     * @return {?}
     */
    ShowDialog(mensaje, tittle = "Error") {
        mensaje = (mensaje == null) ? "" : mensaje;
        metroDialog.create({
            title: tittle,
            content: `<div style="min-width:300px;max-width: 600px;width:auto;">${mensaje}</div>`,
            actions: [
                {
                    title: "Ok",
                    onclick: (/**
                     * @param {?} el
                     * @return {?}
                     */
                    function (el) {
                        $(el).data("dialog").close();
                    })
                }
            ],
            options: {
                overlay: true,
                overlayColor: "op-dark",
                overlayClickClose: true,
            }
        });
    }
    /**
     * @param {?} mensaje
     * @param {?=} tittle
     * @return {?}
     */
    ShowConfirm(mensaje, tittle = "") {
        /** @type {?} */
        let subject = new rxjs__WEBPACK_IMPORTED_MODULE_1__["Subject"]();
        //let promesa = new Promise();
        metroDialog.create({
            title: tittle,
            content: `<div style="min-width:300px;max-width: 600px;width:auto;"><strong>${mensaje}<strong></div>`,
            actions: [
                {
                    title: "Ok",
                    onclick: (/**
                     * @param {?} el
                     * @return {?}
                     */
                    function (el) {
                        $(el).data("dialog").close();
                        // observable.
                        subject.next(true);
                    })
                },
                {
                    title: "Cancel",
                    onclick: (/**
                     * @param {?} el
                     * @return {?}
                     */
                    function (el) {
                        $(el).data("dialog").close();
                        subject.next(false);
                    })
                }
            ],
            options: {
                overlay: true,
                overlayColor: "op-dark",
                overlayClickClose: false
            }
        });
        return subject;
    }
    /**
     * @param {?} mensaje
     * @param {?=} tittle
     * @return {?}
     */
    ShowConfirmYesNo(mensaje, tittle = "") {
        /** @type {?} */
        let subject = new rxjs__WEBPACK_IMPORTED_MODULE_1__["Subject"]();
        metroDialog.create({
            title: tittle.toLocaleUpperCase(),
            content: `<div style="min-width:300px;max-width: 600px;width:auto;"><strong>${mensaje}</strong></div>`,
            actions: [
                {
                    title: "Si",
                    onclick: (/**
                     * @param {?} el
                     * @return {?}
                     */
                    function (el) {
                        $(el).data("dialog").close();
                        // observable.
                        subject.next(true);
                    })
                },
                {
                    title: "No",
                    onclick: (/**
                     * @param {?} el
                     * @return {?}
                     */
                    function (el) {
                        $(el).data("dialog").close();
                        subject.next(false);
                    })
                }
            ],
            options: {
                overlay: true,
                overlayColor: "op-dark",
                overlayClickClose: false
            }
        });
        return subject;
    }
    /**
     * @return {?}
     */
    Snniper() {
        if (this.idSnipper === void 0) {
            /** @type {?} */
            var dialog = metroDialog.create({
                //  title: "",
                content: "<div data-role='preloader' data-type='cycle' data-style='color'></div>"
                //  actions: [],
                //  options: {}
            });
            this.idSnipper = $(dialog["0"]).attr("id");
        }
        else {
            metroDialog.open("#" + this.idSnipper);
        }
    }
    /**
     * @return {?}
     */
    SnniperClose() {
        if (this.idSnipper != undefined) {
            metroDialog.close("#" + this.idSnipper);
            this.idSnipper = undefined;
        }
    }
    // Notificacion(mensaje:string) {
    //     $.Notify({
    //         // caption: 'Notify title',
    //         content: mensaje,
    //         // type: typeNotificion,
    //         keepOpen: true
    //     });
    // }
    /**
     * @param {?} mensaje
     * @param {?=} keepOpen
     * @return {?}
     */
    NotificacionSucess(mensaje, keepOpen = false) {
        $.Notify({
            // caption: 'Notify title',
            content: mensaje,
            type: "success",
            keepOpen: keepOpen,
            timeout: 30000
        });
    }
    /**
     * @param {?} mensaje
     * @param {?=} keepOpen
     * @return {?}
     */
    NotificacionAlert(mensaje, keepOpen = false) {
        $.Notify({
            // caption: 'Notify title',
            content: mensaje,
            type: "alert",
            keepOpen: keepOpen,
            timeout: 30000
        });
    }
    /**
     * @param {?} mensaje
     * @param {?=} keepOpen
     * @return {?}
     */
    NotificacionWarning(mensaje, keepOpen = false) {
        $.Notify({
            // caption: 'Notify title',
            content: mensaje,
            type: "warning",
            keepOpen: keepOpen,
            timeout: 30000
        });
    }
    /**
     * @param {?} mensaje
     * @param {?=} keepOpen
     * @return {?}
     */
    NotificacionInfo(mensaje, keepOpen = false) {
        $.Notify({
            // caption: 'Notify title',
            content: mensaje,
            type: "info",
            keepOpen: keepOpen,
            timeout: 30000
        });
    }
    /**
     * @param {?} mensaje
     * @param {?} title
     * @param {?=} keepOpen
     * @return {?}
     */
    NotificacionWarningTitle(mensaje, title, keepOpen = false) {
        $.Notify({
            caption: title,
            content: mensaje,
            type: "warning",
            keepOpen: keepOpen,
            timeout: 30000
        });
    }
}
DialogService.decorators = [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"], args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */ DialogService.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵdefineInjectable"])({ factory: function DialogService_Factory() { return new DialogService(); }, token: DialogService, providedIn: "root" });
if (false) {}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/service/vesta.inject.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
let AUTHENTICATION = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["InjectionToken"]('AUTHENTICATION_VESTA');

/**
 * @fileoverview added by tsickle
 * Generated from: lib/service/call-http.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CallHttp {
    /**
     * @param {?} http
     * @param {?} autentication
     */
    constructor(http, autentication) {
        this.http = http;
        this.autentication = autentication;
    }
    /**
     * @template TResponse
     * @param {?} url
     * @param {?=} param
     * @param {?=} optionsT
     * @return {?}
     */
    httpGet(url, param = null, optionsT = null) {
        /** @type {?} */
        let urlGet = (param == null) ? url : url + "?" + param;
        /** @type {?} */
        let resp = null;
        /** @type {?} */
        let options = optionsT != null ? optionsT : { withCredentials: this.autentication.isAuthentication };
        /** @type {?} */
        var retorna = this.http.get(urlGet, options) //: Observable<TResponse> =
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError("Error", resp)));
        return retorna;
    }
    /**
     * @template TResponse
     * @param {?} url
     * @param {?} object
     * @param {?=} optionsT
     * @return {?}
     */
    httpGetParams(url, object, optionsT = null) {
        /** @type {?} */
        let params = new _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpParams"]({ fromObject: object });
        /** @type {?} */
        let resp = null;
        /** @type {?} */
        let options = optionsT != null ? optionsT : { withCredentials: this.autentication.isAuthentication };
        /** @type {?} */
        var retorna = this.http.get(url, { params: params, withCredentials: options.withCredentials }) //: Observable<TResponse> =
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError("Error", resp)));
        return retorna;
    }
    /**
     * @param {?} url
     * @param {?=} param
     * @param {?=} optionsT
     * @return {?}
     */
    httpGetText(url, param = null, optionsT = null) {
        /** @type {?} */
        let urlGet = (param == null) ? url : url + "?" + param;
        /** @type {?} */
        let resp = null;
        /** @type {?} */
        let options = optionsT != null ? optionsT : { withCredentials: this.autentication.isAuthentication };
        /** @type {?} */
        var retorna = this.http.get(urlGet, { responseType: 'text', withCredentials: options.withCredentials })
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError("Error", resp)));
        return retorna;
    }
    /**
     * @template TResponse
     * @param {?} url
     * @param {?=} contentBody
     * @param {?=} optionsT
     * @return {?}
     */
    httpPost(url, contentBody = {}, optionsT = null) {
        /** @type {?} */
        let resp = null;
        /** @type {?} */
        let options = optionsT != null ? optionsT : { withCredentials: this.autentication.isAuthentication };
        /** @type {?} */
        var retorna = this.http.post(url, contentBody, options)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError("Error", resp)));
        return retorna;
    }
    /**
     * @template TResponse
     * @param {?} url
     * @param {?} contentBody
     * @param {?=} options
     * @return {?}
     */
    httpPut(url, contentBody, options = { withCredentials: true }) {
        /** @type {?} */
        let resp = null;
        /** @type {?} */
        var retorna = this.http.put(url, contentBody)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError("Error", resp)));
        return retorna;
    }
    /**
     * @template TResponse
     * @param {?} url
     * @param {?} contentBody
     * @param {?} contentType
     * @return {?}
     */
    httpPutFileShare(url, contentBody, contentType) {
        /** @type {?} */
        let resp = null;
        //Content-type
        /** @type {?} */
        const headers = new _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpHeaders"]({ 'Content-type': contentType });
        /** @type {?} */
        var retorna = this.http.put(url, contentBody, { headers: headers, withCredentials: false })
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError("Error", resp)));
        return retorna;
    }
    /**
     * @param {?} url
     * @param {?} contentBody
     * @param {?} contentType
     * @return {?}
     */
    httpPutFileShareProgress(url, contentBody, contentType) {
        /** @type {?} */
        let resp = null;
        //Content-type
        /** @type {?} */
        const headers = new _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpHeaders"]({ 'Content-type': contentType });
        /** @type {?} */
        var retorna = this.http.put(url, contentBody, { headers: headers, withCredentials: false, reportProgress: true, observe: 'events' })
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError("Error", resp)));
        return retorna;
    }
    /**
     * @template TResponse
     * @param {?} url
     * @param {?} contentBody
     * @param {?=} optionsT
     * @return {?}
     */
    httpPostFormData(url, contentBody, optionsT = null) {
        /** @type {?} */
        const headers = new _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpHeaders"]({ 'enctype': 'multipart/form-data' });
        headers.append('Accept', 'application/json');
        /** @type {?} */
        let resp = null;
        /** @type {?} */
        let options = optionsT != null ? optionsT : { withCredentials: this.autentication.isAuthentication };
        //headers ?: Headers
        //const options = new RequestOptions({ headers: headers });
        /** @type {?} */
        var retorna = this.http.post(url, contentBody, { headers: headers, withCredentials: options.withCredentials })
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError("Error", resp)));
        return retorna;
    }
    /**
     * @param {?} url
     * @param {?} contentBody
     * @param {?=} optionsT
     * @return {?}
     */
    httpPostText(url, contentBody, optionsT = null) {
        /** @type {?} */
        let resp = null;
        /** @type {?} */
        let options = optionsT != null ? optionsT : { withCredentials: this.autentication.isAuthentication };
        /** @type {?} */
        var retorna = this.http.post(url, contentBody, { responseType: 'text', withCredentials: options.withCredentials })
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError("Error", resp)));
        return retorna;
    }
    /**
     * @param {?} url
     * @param {?} fileName
     * @param {?=} optionsT
     * @return {?}
     */
    httpGetFile(url, fileName, optionsT = null) {
        /** @type {?} */
        let resp = null;
        /** @type {?} */
        let options = optionsT != null ? optionsT : { withCredentials: this.autentication.isAuthentication };
        /** @type {?} */
        var retorna = this.http.get(url, { responseType: 'blob', withCredentials: options.withCredentials })
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError("Error", resp)), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])((/**
         * @param {?} m
         * @return {?}
         */
        m => {
            this.downloadFile(m, fileName);
        }))) //.map(m => );
        ;
        return retorna;
    }
    /**
     * @param {?} url
     * @param {?} fileName
     * @param {?=} contentBody
     * @param {?=} optionsT
     * @return {?}
     */
    httpPostFile(url, fileName, contentBody = {}, optionsT = null) {
        /** @type {?} */
        let resp = null;
        /** @type {?} */
        let options = optionsT != null ? optionsT : { withCredentials: this.autentication.isAuthentication };
        /** @type {?} */
        var retorna = this.http.post(url, contentBody, { responseType: 'blob', withCredentials: options.withCredentials })
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError("Error", resp)), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])((/**
         * @param {?} m
         * @return {?}
         */
        m => {
            this.downloadFile(m, fileName);
        }))) //.map(m => );
        ;
        return retorna;
    }
    /**
     * @private
     * @param {?} blob
     * @param {?} filename
     * @return {?}
     */
    downloadFile(blob, filename) {
        /** @type {?} */
        var a = document.createElement("a");
        a.href = URL.createObjectURL(blob);
        a.download = filename;
        a.click();
    }
    /**
     * @private
     * @template T
     * @param {?=} operation
     * @param {?=} result
     * @return {?}
     */
    handleError(operation = 'operation', result) {
        return (/**
         * @param {?} error
         * @return {?}
         */
        (error) => {
            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead
            // log to console instead
            // TODO: better job of transforming error for user consumption
            //this.log(`${operation} failed: ${error.message}`);
            // Let the app keep running by returning an empty result.
            /** @type {?} */
            let msj = "";
            if (error.error) {
                if (error.error.Message == undefined && error.statusText != "Unknown Error" && (error.status == 404 || error.status == 412)) {
                    /** @type {?} */
                    var keysObject = Object.keys(error.error);
                    for (let k of keysObject) {
                        msj += k + " - " + ((/** @type {?} */ (error.error[k]))).reduce((/**
                         * @param {?} r
                         * @param {?} n
                         * @param {?} i
                         * @return {?}
                         */
                        (r, n, i) => r + "<br />" + n)) + "<br />";
                    }
                }
                else if (error.error.text) {
                    msj = error.error.text;
                }
                else {
                    msj = error.message;
                }
                if (error.error.Message != undefined)
                    msj = error.error.Message;
                if (msj == "")
                    msj = `${error.status} - ${error.statusText}`;
                //msj = error.error.Message != undefined ? error.error.Message : (msj == "") ? error.message : msj;
            }
            else {
                msj = error.message;
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_1__["throwError"])(msj); //of(result as T);
        });
    }
    /**
     * @param {?} str
     * @return {?}
     */
    static isJsonString(str) {
        try {
            str.json();
        }
        catch (e) {
            return false;
        }
        return true;
    }
}
CallHttp.decorators = [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"], args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
CallHttp.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [AUTHENTICATION,] }] }
];
/** @nocollapse */ CallHttp.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵdefineInjectable"])({ factory: function CallHttp_Factory() { return new CallHttp(Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵinject"])(_angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"]), Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵinject"])(AUTHENTICATION)); }, token: CallHttp, providedIn: "root" });
if (false) {}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/service/interceptor-spinner.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class InterceptorSpinnerService {
    /**
     * @param {?} dialogService
     */
    constructor(dialogService) {
        this.dialogService = dialogService;
        this.Snniper = 0;
    }
    /**
     * @param {?} req
     * @param {?} next
     * @return {?}
     */
    intercept(req, next) {
        this.RequestInterceptor();
        /** @type {?} */
        const handler = req.clone();
        return next.handle(handler).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["finalize"])((/**
         * @return {?}
         */
        () => { this.ResponseInterceptor(); })));
    }
    /**
     * @private
     * @return {?}
     */
    RequestInterceptor() {
        this.Snniper += 1;
        if (this.Snniper == 1) {
            this.dialogService.Snniper();
        }
    }
    /**
     * @private
     * @return {?}
     */
    ResponseInterceptor() {
        if (this.Snniper > 0) {
            this.Snniper -= 1;
        }
        if (this.Snniper == 0) {
            this.dialogService.SnniperClose();
        }
    }
}
InterceptorSpinnerService.decorators = [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"], args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
InterceptorSpinnerService.ctorParameters = () => [
    { type: DialogService }
];
/** @nocollapse */ InterceptorSpinnerService.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵdefineInjectable"])({ factory: function InterceptorSpinnerService_Factory() { return new InterceptorSpinnerService(Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵinject"])(DialogService)); }, token: InterceptorSpinnerService, providedIn: "root" });
if (false) {}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/service/mapper.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class Mapper {
    /**
     * @template T, TW
     * @param {?} inputObject
     * @param {?} outputObject
     * @return {?}
     */
    static Convert(inputObject, outputObject) {
        /** @type {?} */
        var keysObject = Object.keys(inputObject);
        for (var propiedad of keysObject) {
            outputObject[propiedad] = inputObject[propiedad];
        }
        return outputObject;
    }
    /**
     * @template T, TW
     * @param {?} inputObjectList
     * @param {?} outputObject
     * @return {?}
     */
    static ConvertListObject(inputObjectList, outputObject) {
        /** @type {?} */
        var list = [];
        //var documento: TW;
        inputObjectList.Enumerable().forEach((/**
         * @param {?} f
         * @return {?}
         */
        f => {
            /** @type {?} */
            var a = ((/** @type {?} */ (Object))).create(outputObject);
            /** @type {?} */
            var objList = this.Convert(f, a);
            list.push(objList);
        }));
        return list;
    }
    /**
     * @template T, TW
     * @param {?} inputObjectList
     * @param {?} outputObject
     * @return {?}
     */
    static ConvertListObject2(inputObjectList, outputObject) {
        /** @type {?} */
        var list = [];
        //var documento: TW;
        inputObjectList.Enumerable().forEach((/**
         * @param {?} f
         * @return {?}
         */
        f => {
            /** @type {?} */
            var a = new outputObject();
            /** @type {?} */
            var objList = this.Convert(f, a);
            list.push(objList);
        }));
        return list;
    }
}
Mapper.decorators = [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"] }
];
/**
 * @record
 */
function IObjectextended() { }
if (false) {}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/acceso-denegado/acceso-denegado.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AccesoDenegadoComponent {
    constructor() { }
    /**
     * @return {?}
     */
    ngOnInit() {
        $("body").css("background-color", "#D4DFE6");
        $(".Container").css("margin-top", "10%");
    }
}
AccesoDenegadoComponent.decorators = [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{
                selector: 'vesta-acceso-denegado',
                template: "<div class=\"Container\">\r\n\r\n  <div class=\"MainGraphic\">\r\n    <svg class=\"Hummingbird\" viewBox=\"0 0 55 41\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M35.5 5L54.7.6H32.3L35.5 5zM12.4 40.8l10.3-10.1-6.2-6.7-4.1 16.8zM33.8 5.3L30.5.8l-5.4 4 8.7.5zM20.8 4.6L8.8 0l1.9 4.1 10.1.5zM0 5l15.2 15.4 7.5-14.2L0 5zM34.2 6.8l-9.9-.5-8 15.2 7.4 8.1 8-7.9 2.5-14.9z\" /></svg>\r\n\r\n    <svg class=\"Cog\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.18 19.07c-1.678-2.908-.668-6.634 2.256-8.328L28.29 5.295c-.897.527-1.942.83-3.057.83-3.36 0-6.085-2.743-6.085-6.126h-6.29c.01 1.043-.25 2.102-.81 3.07-1.68 2.907-5.41 3.896-8.34 2.21L.566 10.727c.905.515 1.69 1.268 2.246 2.234 1.677 2.904.673 6.624-2.24 8.32l3.145 5.447c.895-.522 1.935-.82 3.044-.82 3.35 0 6.066 2.725 6.083 6.092h6.29c-.004-1.035.258-2.08.81-3.04 1.676-2.902 5.4-3.893 8.325-2.218l3.145-5.447c-.9-.515-1.678-1.266-2.232-2.226zM16 22.48c-3.578 0-6.48-2.902-6.48-6.48S12.423 9.52 16 9.52c3.578 0 6.48 2.902 6.48 6.48s-2.902 6.48-6.48 6.48z\" /></svg>\r\n\r\n  </div>\r\n\r\n  <svg class=\"Spanner\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\">\r\n    <path d=\"M20.285 7.12c-.05-.17-.184-.3-.354-.345-.17-.047-.35.003-.476.126L16.838 9.46l-1.914-.383-.38-1.907 2.644-2.585c.126-.123.178-.303.137-.474s-.168-.31-.336-.362c-.532-.166-1.02-.248-1.49-.248-2.757 0-5 2.243-5 5 0 .323.038.65.118 1.01-.562.463-1.096.862-1.7 1.314-.866.646-1.846 1.377-3.183 2.506C4.95 14.016 4.5 14.99 4.5 16c0 1.93 1.57 3.5 3.5 3.5 1.02 0 1.993-.456 2.662-1.25 1.15-1.347 1.89-2.336 2.544-3.21.442-.59.832-1.11 1.283-1.66.36.082.687.12 1.01.12 2.757 0 5-2.243 5-5 0-.437-.068-.875-.215-1.38zM8 17c-.553 0-1-.447-1-1s.447-1 1-1 1 .447 1 1-.447 1-1 1z\" />\r\n  </svg>\r\n  <h1 class=\"MainTitle\">\r\n    Acceso Denegado\r\n  </h1>\r\n  <p class=\"Main Description\">\r\n\r\n  </p>\r\n\r\n</div>\r\n",
                styles: ["body,html{position:relative;background:#d4dfe6;min-height:100%;width:100%;display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center;color:#274c5e}.Container{text-align:center;position:relative}.MainTitle{display:block;font-size:2rem;font-weight:lighter;text-align:center}.MainDescription{max-width:50%;font-size:1.2rem;font-weight:lighter}.MainGraphic{position:relative}.Cog{width:10rem;height:10rem;fill:#6aafe6;-webkit-animation:5s infinite CogAnimation;animation:5s infinite CogAnimation}.Spanner{position:absolute;-webkit-transform:rotate(20deg);transform:rotate(20deg);top:10%;left:20%;width:10rem;height:10rem;fill:#8ec0e4;-webkit-animation:4s infinite SpannerAnimation;animation:4s infinite SpannerAnimation}.Hummingbird{position:absolute;width:3rem;height:3rem;fill:#30a9de;left:50%;top:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}@-webkit-keyframes CogAnimation{0%{-webkit-transform:rotate(0);transform:rotate(0)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes CogAnimation{0%{-webkit-transform:rotate(0);transform:rotate(0)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@-webkit-keyframes SpannerAnimation{0%{-webkit-transform:translate3d(20px,20px,1px) rotate(0);transform:translate3d(20px,20px,1px) rotate(0)}10%,50%{-webkit-transform:translate3d(-1000px,1000px,1px) rotate(180deg);transform:translate3d(-1000px,1000px,1px) rotate(180deg)}15%,30%{-webkit-transform:translate3d(-1000px,1000px,1px) rotate(360deg);transform:translate3d(-1000px,1000px,1px) rotate(360deg)}20%{-webkit-transform:translate3d(1000px,-1000px,1px) rotate(180deg);transform:translate3d(1000px,-1000px,1px) rotate(180deg)}40%{-webkit-transform:translate3d(1000px,-1000px,1px) rotate(360deg);transform:translate3d(1000px,-1000px,1px) rotate(360deg)}100%{-webkit-transform:translate3d(0,0,0) rotate(360deg);transform:translate3d(0,0,0) rotate(360deg)}}@keyframes SpannerAnimation{0%{-webkit-transform:translate3d(20px,20px,1px) rotate(0);transform:translate3d(20px,20px,1px) rotate(0)}10%,50%{-webkit-transform:translate3d(-1000px,1000px,1px) rotate(180deg);transform:translate3d(-1000px,1000px,1px) rotate(180deg)}15%,30%{-webkit-transform:translate3d(-1000px,1000px,1px) rotate(360deg);transform:translate3d(-1000px,1000px,1px) rotate(360deg)}20%{-webkit-transform:translate3d(1000px,-1000px,1px) rotate(180deg);transform:translate3d(1000px,-1000px,1px) rotate(180deg)}40%{-webkit-transform:translate3d(1000px,-1000px,1px) rotate(360deg);transform:translate3d(1000px,-1000px,1px) rotate(360deg)}100%{-webkit-transform:translate3d(0,0,0) rotate(360deg);transform:translate3d(0,0,0) rotate(360deg)}}"]
            }] }
];
/** @nocollapse */
AccesoDenegadoComponent.ctorParameters = () => [];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/page-not-found/page-not-found.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PageNotFoundComponent {
    constructor() { }
    /**
     * @return {?}
     */
    ngOnInit() {
        $("body").css("background-color", "#D4DFE6");
    }
}
PageNotFoundComponent.decorators = [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"], args: [{
                selector: 'vesta-page-not-found',
                template: "<div id=\"clouds\">\r\n  <div class=\"cloud x1\"></div>\r\n  <div class=\"cloud x1_5\"></div>\r\n  <div class=\"cloud x2\"></div>\r\n  <div class=\"cloud x3\"></div>\r\n  <div class=\"cloud x4\"></div>\r\n  <div class=\"cloud x5\"></div>\r\n</div>\r\n<div class='c'>\r\n  <div class='_404'>THE PAGE</div>\r\n  <hr>\r\n  <div class='_2'>WAS NOT FOUND</div>\r\n  <a class=''>BACK TO</a>\r\n</div>\r\n",
                styles: ["body{color:#fff;font-family:'Open Sans',sans-serif;max-height:700px;overflow:hidden}.c{text-align:center;display:block;position:relative;width:80%;margin:100px auto}._404{font-size:4em;position:relative;display:inline-block;z-index:2;letter-spacing:15px}._1{text-align:center;display:block;position:relative;letter-spacing:12px;font-size:4em;line-height:80%}._2{text-align:center;display:block;position:relative;font-size:20px}.text{font-size:70px;text-align:center;position:relative;margin:19px 0 0;z-index:3;width:100%;line-height:1.2em;display:inline-block}.btn{background-color:#fff;position:relative;display:inline-block;width:358px;padding:5px;z-index:5;font-size:25px;margin:0 10px 0 auto;color:#3c9;text-decoration:none}.right{float:right;width:60%}hr{padding:0;border:none;border-top:5px solid #fff;color:#fff;text-align:center;margin:0 auto;width:420px;height:10px;z-index:-10}hr:after{content:\"\\2022\";display:inline-block;position:relative;top:-.75em;font-size:2em;padding:0 .2em;background:#3c9}.cloud{width:350px;height:120px;background:#fff;background:-webkit-gradient(linear,left top,left bottom,to(#fff));background:linear-gradient(to bottom,#fff 100%);background:-o-linear-gradient(top,#fff 100%);border-radius:100px;-webkit-border-radius:100px;-moz-border-radius:100px;position:absolute;margin:120px auto 20px;z-index:-1;-webkit-transition:1s;transition:1s}.cloud:after,.cloud:before{content:'';position:absolute;background:#fff;z-index:-1}.cloud:after{width:100px;height:100px;top:-50px;left:50px;border-radius:100px;-webkit-border-radius:100px;-moz-border-radius:100px}.cloud:before{width:180px;height:180px;top:-90px;right:50px;border-radius:200px;-webkit-border-radius:200px;-moz-border-radius:200px}.x1{top:-50px;left:100px;-webkit-transform:scale(.3);transform:scale(.3);opacity:.9;-webkit-animation:15s linear infinite moveclouds;-moz-animation:15s linear infinite moveclouds;-o-animation:15s linear infinite moveclouds}.x1_5{top:-80px;left:250px;-webkit-transform:scale(.3);transform:scale(.3);-webkit-animation:17s linear infinite moveclouds;-moz-animation:17s linear infinite moveclouds;-o-animation:17s linear infinite moveclouds}.x2{left:250px;top:30px;-webkit-transform:scale(.6);transform:scale(.6);opacity:.6;-webkit-animation:25s linear infinite moveclouds;-moz-animation:25s linear infinite moveclouds;-o-animation:25s linear infinite moveclouds}.x3{left:250px;bottom:-70px;-webkit-transform:scale(.6);transform:scale(.6);opacity:.8;-webkit-animation:25s linear infinite moveclouds;-moz-animation:25s linear infinite moveclouds;-o-animation:25s linear infinite moveclouds}.x4{left:470px;botttom:20px;-webkit-transform:scale(.75);transform:scale(.75);opacity:.75;-webkit-animation:18s linear infinite moveclouds;-moz-animation:18s linear infinite moveclouds;-o-animation:18s linear infinite moveclouds}.x5{left:200px;top:300px;-webkit-transform:scale(.5);transform:scale(.5);opacity:.8;-webkit-animation:20s linear infinite moveclouds;-moz-animation:20s linear infinite moveclouds;-o-animation:20s linear infinite moveclouds}@-webkit-keyframes moveclouds{0%{margin-left:1000px}100%{margin-left:-1000px}}"]
            }] }
];
/** @nocollapse */
PageNotFoundComponent.ctorParameters = () => [];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/service/http-cancel.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class HttpCancelService {
    constructor() {
        this.pendingHTTPRequests$ = new rxjs__WEBPACK_IMPORTED_MODULE_1__["Subject"]();
    }
    /**
     * @return {?}
     */
    cancelPendingRequests() {
        this.pendingHTTPRequests$.next();
    }
    /**
     * @return {?}
     */
    onCancelPendingRequests() {
        return this.pendingHTTPRequests$.asObservable();
    }
}
HttpCancelService.decorators = [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"], args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
HttpCancelService.ctorParameters = () => [];
/** @nocollapse */ HttpCancelService.ngInjectableDef = Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ɵɵdefineInjectable"])({ factory: function HttpCancelService_Factory() { return new HttpCancelService(); }, token: HttpCancelService, providedIn: "root" });
if (false) {}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/service/manage-http-interceptor.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ManageHttpInterceptor {
    /**
     * @param {?} router
     * @param {?} httpCancelService
     */
    constructor(router, httpCancelService) {
        this.router = router;
        this.httpCancelService = httpCancelService;
        router.events.subscribe((/**
         * @param {?} event
         * @return {?}
         */
        event => {
            if (event instanceof _angular_router__WEBPACK_IMPORTED_MODULE_5__["ActivationStart"]) {
                this.httpCancelService.cancelPendingRequests();
            }
        }));
    }
    /**
     * @template T
     * @param {?} req
     * @param {?} next
     * @return {?}
     */
    intercept(req, next) {
        return next.handle(req).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["takeUntil"])(this.httpCancelService.onCancelPendingRequests()));
    }
}
ManageHttpInterceptor.decorators = [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"] }
];
/** @nocollapse */
ManageHttpInterceptor.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_5__["Router"] },
    { type: HttpCancelService }
];
if (false) {}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/vesta.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class VestaModule {
    /**
     * @param {?=} settings
     * @return {?}
     */
    static forRoot(settings = { isAuthentication: false }) {
        return {
            ngModule: VestaModule,
            providers: [
                { provide: AUTHENTICATION, useValue: settings }
            ]
        };
    }
}
VestaModule.decorators = [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"], args: [{
                declarations: [AccesoDenegadoComponent, PageNotFoundComponent],
                imports: [
                    _angular_common__WEBPACK_IMPORTED_MODULE_4__["CommonModule"], _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClientModule"]
                ],
                providers: [CallHttp, DialogService, HttpCancelService,
                    { provide: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HTTP_INTERCEPTORS"], useClass: InterceptorSpinnerService, multi: true },
                    { provide: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HTTP_INTERCEPTORS"], useClass: ManageHttpInterceptor, multi: true }
                ],
                exports: [AccesoDenegadoComponent, PageNotFoundComponent]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/service/array-extends.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var Enumerable = __webpack_require__(/*! linq */ "./node_modules/linq/linq.js");
Array.prototype.Enumerable = (/**
 * @template T
 * @return {?}
 */
function () {
    /** @type {?} */
    let array = this;
    return Enumerable.from(array);
});
class ArrayExtends {
}

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: vesta.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */


//# sourceMappingURL=vesta.js.map


/***/ }),

/***/ "./node_modules/moment/locale sync recursive ^\\.\\/.*$":
/*!**************************************************!*\
  !*** ./node_modules/moment/locale sync ^\.\/.*$ ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "./node_modules/moment/locale/af.js",
	"./af.js": "./node_modules/moment/locale/af.js",
	"./ar": "./node_modules/moment/locale/ar.js",
	"./ar-dz": "./node_modules/moment/locale/ar-dz.js",
	"./ar-dz.js": "./node_modules/moment/locale/ar-dz.js",
	"./ar-kw": "./node_modules/moment/locale/ar-kw.js",
	"./ar-kw.js": "./node_modules/moment/locale/ar-kw.js",
	"./ar-ly": "./node_modules/moment/locale/ar-ly.js",
	"./ar-ly.js": "./node_modules/moment/locale/ar-ly.js",
	"./ar-ma": "./node_modules/moment/locale/ar-ma.js",
	"./ar-ma.js": "./node_modules/moment/locale/ar-ma.js",
	"./ar-sa": "./node_modules/moment/locale/ar-sa.js",
	"./ar-sa.js": "./node_modules/moment/locale/ar-sa.js",
	"./ar-tn": "./node_modules/moment/locale/ar-tn.js",
	"./ar-tn.js": "./node_modules/moment/locale/ar-tn.js",
	"./ar.js": "./node_modules/moment/locale/ar.js",
	"./az": "./node_modules/moment/locale/az.js",
	"./az.js": "./node_modules/moment/locale/az.js",
	"./be": "./node_modules/moment/locale/be.js",
	"./be.js": "./node_modules/moment/locale/be.js",
	"./bg": "./node_modules/moment/locale/bg.js",
	"./bg.js": "./node_modules/moment/locale/bg.js",
	"./bm": "./node_modules/moment/locale/bm.js",
	"./bm.js": "./node_modules/moment/locale/bm.js",
	"./bn": "./node_modules/moment/locale/bn.js",
	"./bn.js": "./node_modules/moment/locale/bn.js",
	"./bo": "./node_modules/moment/locale/bo.js",
	"./bo.js": "./node_modules/moment/locale/bo.js",
	"./br": "./node_modules/moment/locale/br.js",
	"./br.js": "./node_modules/moment/locale/br.js",
	"./bs": "./node_modules/moment/locale/bs.js",
	"./bs.js": "./node_modules/moment/locale/bs.js",
	"./ca": "./node_modules/moment/locale/ca.js",
	"./ca.js": "./node_modules/moment/locale/ca.js",
	"./cs": "./node_modules/moment/locale/cs.js",
	"./cs.js": "./node_modules/moment/locale/cs.js",
	"./cv": "./node_modules/moment/locale/cv.js",
	"./cv.js": "./node_modules/moment/locale/cv.js",
	"./cy": "./node_modules/moment/locale/cy.js",
	"./cy.js": "./node_modules/moment/locale/cy.js",
	"./da": "./node_modules/moment/locale/da.js",
	"./da.js": "./node_modules/moment/locale/da.js",
	"./de": "./node_modules/moment/locale/de.js",
	"./de-at": "./node_modules/moment/locale/de-at.js",
	"./de-at.js": "./node_modules/moment/locale/de-at.js",
	"./de-ch": "./node_modules/moment/locale/de-ch.js",
	"./de-ch.js": "./node_modules/moment/locale/de-ch.js",
	"./de.js": "./node_modules/moment/locale/de.js",
	"./dv": "./node_modules/moment/locale/dv.js",
	"./dv.js": "./node_modules/moment/locale/dv.js",
	"./el": "./node_modules/moment/locale/el.js",
	"./el.js": "./node_modules/moment/locale/el.js",
	"./en-au": "./node_modules/moment/locale/en-au.js",
	"./en-au.js": "./node_modules/moment/locale/en-au.js",
	"./en-ca": "./node_modules/moment/locale/en-ca.js",
	"./en-ca.js": "./node_modules/moment/locale/en-ca.js",
	"./en-gb": "./node_modules/moment/locale/en-gb.js",
	"./en-gb.js": "./node_modules/moment/locale/en-gb.js",
	"./en-ie": "./node_modules/moment/locale/en-ie.js",
	"./en-ie.js": "./node_modules/moment/locale/en-ie.js",
	"./en-il": "./node_modules/moment/locale/en-il.js",
	"./en-il.js": "./node_modules/moment/locale/en-il.js",
	"./en-nz": "./node_modules/moment/locale/en-nz.js",
	"./en-nz.js": "./node_modules/moment/locale/en-nz.js",
	"./eo": "./node_modules/moment/locale/eo.js",
	"./eo.js": "./node_modules/moment/locale/eo.js",
	"./es": "./node_modules/moment/locale/es.js",
	"./es-do": "./node_modules/moment/locale/es-do.js",
	"./es-do.js": "./node_modules/moment/locale/es-do.js",
	"./es-us": "./node_modules/moment/locale/es-us.js",
	"./es-us.js": "./node_modules/moment/locale/es-us.js",
	"./es.js": "./node_modules/moment/locale/es.js",
	"./et": "./node_modules/moment/locale/et.js",
	"./et.js": "./node_modules/moment/locale/et.js",
	"./eu": "./node_modules/moment/locale/eu.js",
	"./eu.js": "./node_modules/moment/locale/eu.js",
	"./fa": "./node_modules/moment/locale/fa.js",
	"./fa.js": "./node_modules/moment/locale/fa.js",
	"./fi": "./node_modules/moment/locale/fi.js",
	"./fi.js": "./node_modules/moment/locale/fi.js",
	"./fo": "./node_modules/moment/locale/fo.js",
	"./fo.js": "./node_modules/moment/locale/fo.js",
	"./fr": "./node_modules/moment/locale/fr.js",
	"./fr-ca": "./node_modules/moment/locale/fr-ca.js",
	"./fr-ca.js": "./node_modules/moment/locale/fr-ca.js",
	"./fr-ch": "./node_modules/moment/locale/fr-ch.js",
	"./fr-ch.js": "./node_modules/moment/locale/fr-ch.js",
	"./fr.js": "./node_modules/moment/locale/fr.js",
	"./fy": "./node_modules/moment/locale/fy.js",
	"./fy.js": "./node_modules/moment/locale/fy.js",
	"./gd": "./node_modules/moment/locale/gd.js",
	"./gd.js": "./node_modules/moment/locale/gd.js",
	"./gl": "./node_modules/moment/locale/gl.js",
	"./gl.js": "./node_modules/moment/locale/gl.js",
	"./gom-latn": "./node_modules/moment/locale/gom-latn.js",
	"./gom-latn.js": "./node_modules/moment/locale/gom-latn.js",
	"./gu": "./node_modules/moment/locale/gu.js",
	"./gu.js": "./node_modules/moment/locale/gu.js",
	"./he": "./node_modules/moment/locale/he.js",
	"./he.js": "./node_modules/moment/locale/he.js",
	"./hi": "./node_modules/moment/locale/hi.js",
	"./hi.js": "./node_modules/moment/locale/hi.js",
	"./hr": "./node_modules/moment/locale/hr.js",
	"./hr.js": "./node_modules/moment/locale/hr.js",
	"./hu": "./node_modules/moment/locale/hu.js",
	"./hu.js": "./node_modules/moment/locale/hu.js",
	"./hy-am": "./node_modules/moment/locale/hy-am.js",
	"./hy-am.js": "./node_modules/moment/locale/hy-am.js",
	"./id": "./node_modules/moment/locale/id.js",
	"./id.js": "./node_modules/moment/locale/id.js",
	"./is": "./node_modules/moment/locale/is.js",
	"./is.js": "./node_modules/moment/locale/is.js",
	"./it": "./node_modules/moment/locale/it.js",
	"./it.js": "./node_modules/moment/locale/it.js",
	"./ja": "./node_modules/moment/locale/ja.js",
	"./ja.js": "./node_modules/moment/locale/ja.js",
	"./jv": "./node_modules/moment/locale/jv.js",
	"./jv.js": "./node_modules/moment/locale/jv.js",
	"./ka": "./node_modules/moment/locale/ka.js",
	"./ka.js": "./node_modules/moment/locale/ka.js",
	"./kk": "./node_modules/moment/locale/kk.js",
	"./kk.js": "./node_modules/moment/locale/kk.js",
	"./km": "./node_modules/moment/locale/km.js",
	"./km.js": "./node_modules/moment/locale/km.js",
	"./kn": "./node_modules/moment/locale/kn.js",
	"./kn.js": "./node_modules/moment/locale/kn.js",
	"./ko": "./node_modules/moment/locale/ko.js",
	"./ko.js": "./node_modules/moment/locale/ko.js",
	"./ky": "./node_modules/moment/locale/ky.js",
	"./ky.js": "./node_modules/moment/locale/ky.js",
	"./lb": "./node_modules/moment/locale/lb.js",
	"./lb.js": "./node_modules/moment/locale/lb.js",
	"./lo": "./node_modules/moment/locale/lo.js",
	"./lo.js": "./node_modules/moment/locale/lo.js",
	"./lt": "./node_modules/moment/locale/lt.js",
	"./lt.js": "./node_modules/moment/locale/lt.js",
	"./lv": "./node_modules/moment/locale/lv.js",
	"./lv.js": "./node_modules/moment/locale/lv.js",
	"./me": "./node_modules/moment/locale/me.js",
	"./me.js": "./node_modules/moment/locale/me.js",
	"./mi": "./node_modules/moment/locale/mi.js",
	"./mi.js": "./node_modules/moment/locale/mi.js",
	"./mk": "./node_modules/moment/locale/mk.js",
	"./mk.js": "./node_modules/moment/locale/mk.js",
	"./ml": "./node_modules/moment/locale/ml.js",
	"./ml.js": "./node_modules/moment/locale/ml.js",
	"./mn": "./node_modules/moment/locale/mn.js",
	"./mn.js": "./node_modules/moment/locale/mn.js",
	"./mr": "./node_modules/moment/locale/mr.js",
	"./mr.js": "./node_modules/moment/locale/mr.js",
	"./ms": "./node_modules/moment/locale/ms.js",
	"./ms-my": "./node_modules/moment/locale/ms-my.js",
	"./ms-my.js": "./node_modules/moment/locale/ms-my.js",
	"./ms.js": "./node_modules/moment/locale/ms.js",
	"./mt": "./node_modules/moment/locale/mt.js",
	"./mt.js": "./node_modules/moment/locale/mt.js",
	"./my": "./node_modules/moment/locale/my.js",
	"./my.js": "./node_modules/moment/locale/my.js",
	"./nb": "./node_modules/moment/locale/nb.js",
	"./nb.js": "./node_modules/moment/locale/nb.js",
	"./ne": "./node_modules/moment/locale/ne.js",
	"./ne.js": "./node_modules/moment/locale/ne.js",
	"./nl": "./node_modules/moment/locale/nl.js",
	"./nl-be": "./node_modules/moment/locale/nl-be.js",
	"./nl-be.js": "./node_modules/moment/locale/nl-be.js",
	"./nl.js": "./node_modules/moment/locale/nl.js",
	"./nn": "./node_modules/moment/locale/nn.js",
	"./nn.js": "./node_modules/moment/locale/nn.js",
	"./pa-in": "./node_modules/moment/locale/pa-in.js",
	"./pa-in.js": "./node_modules/moment/locale/pa-in.js",
	"./pl": "./node_modules/moment/locale/pl.js",
	"./pl.js": "./node_modules/moment/locale/pl.js",
	"./pt": "./node_modules/moment/locale/pt.js",
	"./pt-br": "./node_modules/moment/locale/pt-br.js",
	"./pt-br.js": "./node_modules/moment/locale/pt-br.js",
	"./pt.js": "./node_modules/moment/locale/pt.js",
	"./ro": "./node_modules/moment/locale/ro.js",
	"./ro.js": "./node_modules/moment/locale/ro.js",
	"./ru": "./node_modules/moment/locale/ru.js",
	"./ru.js": "./node_modules/moment/locale/ru.js",
	"./sd": "./node_modules/moment/locale/sd.js",
	"./sd.js": "./node_modules/moment/locale/sd.js",
	"./se": "./node_modules/moment/locale/se.js",
	"./se.js": "./node_modules/moment/locale/se.js",
	"./si": "./node_modules/moment/locale/si.js",
	"./si.js": "./node_modules/moment/locale/si.js",
	"./sk": "./node_modules/moment/locale/sk.js",
	"./sk.js": "./node_modules/moment/locale/sk.js",
	"./sl": "./node_modules/moment/locale/sl.js",
	"./sl.js": "./node_modules/moment/locale/sl.js",
	"./sq": "./node_modules/moment/locale/sq.js",
	"./sq.js": "./node_modules/moment/locale/sq.js",
	"./sr": "./node_modules/moment/locale/sr.js",
	"./sr-cyrl": "./node_modules/moment/locale/sr-cyrl.js",
	"./sr-cyrl.js": "./node_modules/moment/locale/sr-cyrl.js",
	"./sr.js": "./node_modules/moment/locale/sr.js",
	"./ss": "./node_modules/moment/locale/ss.js",
	"./ss.js": "./node_modules/moment/locale/ss.js",
	"./sv": "./node_modules/moment/locale/sv.js",
	"./sv.js": "./node_modules/moment/locale/sv.js",
	"./sw": "./node_modules/moment/locale/sw.js",
	"./sw.js": "./node_modules/moment/locale/sw.js",
	"./ta": "./node_modules/moment/locale/ta.js",
	"./ta.js": "./node_modules/moment/locale/ta.js",
	"./te": "./node_modules/moment/locale/te.js",
	"./te.js": "./node_modules/moment/locale/te.js",
	"./tet": "./node_modules/moment/locale/tet.js",
	"./tet.js": "./node_modules/moment/locale/tet.js",
	"./tg": "./node_modules/moment/locale/tg.js",
	"./tg.js": "./node_modules/moment/locale/tg.js",
	"./th": "./node_modules/moment/locale/th.js",
	"./th.js": "./node_modules/moment/locale/th.js",
	"./tl-ph": "./node_modules/moment/locale/tl-ph.js",
	"./tl-ph.js": "./node_modules/moment/locale/tl-ph.js",
	"./tlh": "./node_modules/moment/locale/tlh.js",
	"./tlh.js": "./node_modules/moment/locale/tlh.js",
	"./tr": "./node_modules/moment/locale/tr.js",
	"./tr.js": "./node_modules/moment/locale/tr.js",
	"./tzl": "./node_modules/moment/locale/tzl.js",
	"./tzl.js": "./node_modules/moment/locale/tzl.js",
	"./tzm": "./node_modules/moment/locale/tzm.js",
	"./tzm-latn": "./node_modules/moment/locale/tzm-latn.js",
	"./tzm-latn.js": "./node_modules/moment/locale/tzm-latn.js",
	"./tzm.js": "./node_modules/moment/locale/tzm.js",
	"./ug-cn": "./node_modules/moment/locale/ug-cn.js",
	"./ug-cn.js": "./node_modules/moment/locale/ug-cn.js",
	"./uk": "./node_modules/moment/locale/uk.js",
	"./uk.js": "./node_modules/moment/locale/uk.js",
	"./ur": "./node_modules/moment/locale/ur.js",
	"./ur.js": "./node_modules/moment/locale/ur.js",
	"./uz": "./node_modules/moment/locale/uz.js",
	"./uz-latn": "./node_modules/moment/locale/uz-latn.js",
	"./uz-latn.js": "./node_modules/moment/locale/uz-latn.js",
	"./uz.js": "./node_modules/moment/locale/uz.js",
	"./vi": "./node_modules/moment/locale/vi.js",
	"./vi.js": "./node_modules/moment/locale/vi.js",
	"./x-pseudo": "./node_modules/moment/locale/x-pseudo.js",
	"./x-pseudo.js": "./node_modules/moment/locale/x-pseudo.js",
	"./yo": "./node_modules/moment/locale/yo.js",
	"./yo.js": "./node_modules/moment/locale/yo.js",
	"./zh-cn": "./node_modules/moment/locale/zh-cn.js",
	"./zh-cn.js": "./node_modules/moment/locale/zh-cn.js",
	"./zh-hk": "./node_modules/moment/locale/zh-hk.js",
	"./zh-hk.js": "./node_modules/moment/locale/zh-hk.js",
	"./zh-tw": "./node_modules/moment/locale/zh-tw.js",
	"./zh-tw.js": "./node_modules/moment/locale/zh-tw.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./node_modules/moment/locale sync recursive ^\\.\\/.*$";

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html":
/*!**************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"container page-content\" style=\"width:100%; height: auto !important;\">\r\n  <header class=\"app-bar fixed-top\" data-role=\"appbar\" *ngIf=\"user.Name != null\">\r\n    <a class=\"app-bar-element\" routerLink=\"/menu\">\r\n      <span id=\"toggle-tiles-dropdown\" class=\"mif-apps mif-2x\"></span>\r\n    </a>\r\n    <div class=\"app-bar-divider\"></div>\r\n\r\n    <ul class=\"app-bar-menu small-dropdown place-right\">\r\n      <li>\r\n        <a class=\"dropdown-toggle place-right right app-bar-element\">{{user.Name}}</a>\r\n        <ul class=\"d-menu\" data-role=\"dropdown\">\r\n          <li><a (click)=\"Logout()\">Logout</a></li>\r\n        </ul>\r\n      </li>\r\n    </ul>\r\n\r\n  </header>\r\n</div>\r\n\r\n\r\n<router-outlet></router-outlet>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-ajustes-carga/grid-ajustes-carga.component.html":
/*!***************************************************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-ajustes-carga/grid-ajustes-carga.component.html ***!
  \***************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<jqxGrid #myGridAjustesCarga\r\n         [width]=\"'100%'\" [height]=\"'285'\" [source]=\"dataAdapter\" [columns]=\"columns\"\r\n         [theme]=\"'metro'\" [rowsheight]=\"35\" [altrows]=\"true\" [columnsresize]=\"true\"\r\n         [enablebrowserselection]=\"true\"\r\n         [filterable]=\"true\" [showfilterrow]=\"true\"\r\n         [pagesize]=\"'5'\" [pageable]=\"true\" [pagermode]=\"'simple'\">\r\n</jqxGrid>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-ajustes-precio/grid-ajustes-precio.component.html":
/*!*****************************************************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-ajustes-precio/grid-ajustes-precio.component.html ***!
  \*****************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<jqxGrid #myGridAjustesPrecio\r\n         [width]=\"'100%'\" [height]=\"'285'\" [source]=\"dataAdapter\" [columns]=\"columns\"\r\n         [theme]=\"'metro'\" [rowsheight]=\"35\" [altrows]=\"true\" [columnsresize]=\"true\"\r\n         [enablebrowserselection]=\"true\"\r\n         [filterable]=\"true\" [showfilterrow]=\"true\"\r\n         [pagesize]=\"'5'\" [pageable]=\"true\" [pagermode]=\"'simple'\">\r\n</jqxGrid>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-codigo-proveedor/grid-codigo-proveedor.component.html":
/*!*********************************************************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-codigo-proveedor/grid-codigo-proveedor.component.html ***!
  \*********************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<jqxGrid #myGridCodigoProveedor\r\n         [width]=\"'100%'\" [height]=\"'390'\" [source]=\"dataAdapter\" [columns]=\"columns\"\r\n         [theme]=\"'metro'\" [rowsheight]=\"35\" [altrows]=\"true\" [columnsresize]=\"true\"\r\n         (onCellclick)=\"CellClick($event)\"\r\n         [enablebrowserselection]=\"true\"\r\n         [filterable]=\"true\" [showfilterrow]=\"true\"\r\n         [pagesize]=\"'8'\" [pageable]=\"true\" [pagermode]=\"'simple'\">\r\n</jqxGrid>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-orden-compra/grid-orden-compra.component.html":
/*!*************************************************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-orden-compra/grid-orden-compra.component.html ***!
  \*************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<jqxGrid #myGridOrdenCompra\r\n         [width]=\"'100%'\" [height]=\"'390'\" [source]=\"dataAdapter\" [columns]=\"columns\"\r\n         [theme]=\"'metro'\" [rowsheight]=\"35\" [altrows]=\"true\" [columnsresize]=\"true\"\r\n         (onCellclick)=\"CellClick($event)\"\r\n         [enablebrowserselection]=\"true\"\r\n         [filterable]=\"true\" [showfilterrow]=\"true\"\r\n         [pagesize]=\"'8'\" [pageable]=\"true\" [pagermode]=\"'simple'\">\r\n</jqxGrid>\r\n\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-tracking-facturas-nacionales/grid-tracking-facturas-nacionales.component.html":
/*!*********************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-tracking-facturas-nacionales/grid-tracking-facturas-nacionales.component.html ***!
  \*********************************************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<jqxGrid #myGridTrackingFacturasNacionales\r\n         [width]=\"'100%'\" [height]=\"'285'\" [source]=\"dataAdapter\" [columns]=\"columns\"\r\n         [theme]=\"'metro'\" [rowsheight]=\"35\" [altrows]=\"true\" [columnsresize]=\"true\"\r\n         [enablebrowserselection]=\"true\"\r\n         [filterable]=\"true\" [showfilterrow]=\"true\"\r\n         [pagesize]=\"'8'\" [pageable]=\"true\" [pagermode]=\"'simple'\">\r\n</jqxGrid>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/screen/reporte-tracking-facturas-nacionales - Copy/reporte-tracking-facturas-nacionales/reporte-tracking-facturas-nacionales.component.html":
/*!***************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/screen/reporte-tracking-facturas-nacionales - Copy/reporte-tracking-facturas-nacionales/reporte-tracking-facturas-nacionales.component.html ***!
  \***************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"body\">\r\n  <h1>Reporte Tracking Facturas</h1>\r\n  <hr /><br />\r\n\r\n  <div class=\"grid demo-grid\">\r\n    <div class=\"row cells12\">\r\n      <div class=\"cell colspan3\">\r\n        <label><strong># Factura</strong><label style=\"color: red;\">*</label></label>\r\n        <div class=\"input-control text full-size sombra\" data-role=\"input\">\r\n          <input type=\"text\" [(ngModel)]=\"Factura\">\r\n          <button class=\"button helper-button clear\" (click)=\"ClearInput()\"><span class=\"mif-cross\"></span></button>\r\n        </div>\r\n      </div>\r\n      <div class=\"cell\">\r\n        <div style=\"margin-top: 0.80rem;\">\r\n          <button class=\"button square-button mif-search mif-lg fg-white sombra\" style=\"background-color: #0072C6;\" (click)=\"BuscarFactura()\"></button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"row cells12\">\r\n      <div class=\"cell colspan6\">\r\n        <div>\r\n          <span><button class=\"button sombra\" style=\"border-radius: 1rem;\" (click)=\"AbrirModalOrdenDeComprar()\"><span><img src=\"../../../../assets/icons/double-click.png\" /></span> Orden de Compra</button></span>\r\n          <span style=\"padding:0.3rem;\"><button class=\"button sombra\" style=\"border-radius: 1rem;\" (click)=\"AbrirModalCodigoproveedor()\"><span><img src=\"../../../../assets/icons/double-click.png\" /></span> Código Proveedor</button></span>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <!--Template Factura Nacional-->\r\n    <div *ngIf=\"MostrarTemplateNacional == true\">\r\n\r\n      <div class=\"row cells12\">\r\n        <div class=\"divContainerSellos sombra\">\r\n          <div style=\"padding: 1rem;\">\r\n            <div class=\"row cells12\">\r\n              <div class=\"cell colspan8\"><span><strong style=\"font-size: 17px; margin: 2px;\">Fecha Factura: </strong><span><label>{{FechaFactura}}</label></span></span></div>\r\n            </div>\r\n            <div class=\"row cells12\">\r\n              <div class=\"cell colspan8\"><span><strong style=\"font-size: 17px; margin: 2px;\">Vencimiento: </strong><span><label>{{Vencimiento}}</label></span></span></div>\r\n            </div>\r\n          </div>\r\n          <div class=\"container\" style=\"margin-top: 3.5rem;\">\r\n            <ul class=\"progressbar\">\r\n              <li *ngIf=\"(Entrada != '-----' && Salida == '-----') || (Entrada == '-----' && Salida == '-----'); else NgProveedor\" class=\"activeyellow\">\r\n                <img style=\"margin: -150px auto 0 auto; width: 3rem;\" src=\"../../../../assets/icons/truck.png\" />\r\n                <div><label><strong>Proveedor</strong></label></div>\r\n                <div><label>Entrada: {{Entrada}}</label></div>\r\n                <div><label>Salida: {{Salida}}</label></div>\r\n\r\n                <!--<div style=\"margin-top: 1rem;\">\r\n                  <div><label>Astrid</label></div>\r\n                  <div><label>1/1</label></div>\r\n                </div>-->\r\n              </li>\r\n              <ng-template #NgProveedor>\r\n                <li class=\"active\">\r\n                  <img style=\"margin: -150px auto 0 auto; width: 3rem;\" src=\"../../../../assets/icons/truck.png\" />\r\n                  <div><label><strong>Proveedor</strong></label></div>\r\n                  <div><label>Entrada: {{Entrada}}</label></div>\r\n                  <div><label>Salida: {{Salida}}</label></div>\r\n\r\n                  <!--<div style=\"margin-top: 1rem;\">\r\n                    <div><label>Astrid</label></div>\r\n                    <div><label>1/1</label></div>\r\n                  </div>-->\r\n                </li>\r\n              </ng-template>\r\n              <li *ngIf=\"(EntradaFin != '-----' && SalidaFin == '-----') || (EntradaFin == '-----' && SalidaFin == '-----'); else NgBascula\" class=\"activeyellow\">\r\n                <img style=\"margin: -150px auto 0 auto; width: 3rem;\" src=\"../../../../assets/icons/pesaje.png\" />\r\n                <div><label><strong>Bascula</strong></label></div>\r\n                <div><label>Entrada: {{EntradaFin}}</label></div>\r\n                <div><label>Salida: {{SalidaFin}}</label></div>\r\n\r\n                <!--<div style=\"margin-top: 1rem;\">\r\n                  <div><label>Astrid</label></div>\r\n                  <div><label>1/1</label></div>\r\n                </div>-->\r\n              </li>\r\n              <ng-template #NgBascula>\r\n                <li class=\"active\">\r\n                  <img style=\"margin: -150px auto 0 auto; width: 3rem;\" src=\"../../../../assets/icons/pesaje.png\" />\r\n                  <div><label><strong>Bascula</strong></label></div>\r\n                  <div><label>Entrada: {{EntradaFin}}</label></div>\r\n                  <div><label>Salida: {{SalidaFin}}</label></div>\r\n\r\n                  <!--<div style=\"margin-top: 1rem;\">\r\n                    <div><label>Astrid</label></div>\r\n                    <div><label>1/1</label></div>\r\n                  </div>-->\r\n                </li>\r\n              </ng-template>\r\n              <li *ngIf=\"Recepcion == '0001-01-01 00:00:00'; else NgRecepcion\" class=\"activeyellow\">\r\n                <img style=\"margin: -150px auto 0 auto; width: 3rem;\" src=\"../../../../assets/icons/trolley.png\" />\r\n                <div><label><strong>Recepción</strong></label></div>\r\n                <div><label> ----- </label></div>\r\n\r\n                <!--<div style=\"margin-top: 1rem;\">\r\n                  <div><label>Astrid</label></div>\r\n                  <div><label>0/1</label></div>\r\n                </div>-->\r\n              </li>\r\n              <ng-template #NgRecepcion>\r\n                <li class=\"active\">\r\n                  <img style=\"margin: -150px auto 0 auto; width: 3rem;\" src=\"../../../../assets/icons/trolley.png\" />\r\n                  <div><label><strong>Recepción</strong></label></div>\r\n                  <div><label>{{Recepcion}}</label></div>\r\n\r\n                  <!--<div style=\"margin-top: 1rem;\">\r\n                    <div><label>Astrid</label></div>\r\n                    <div><label>1/1</label></div>\r\n                  </div>-->\r\n                </li>\r\n              </ng-template>\r\n              <li *ngIf=\"FechaMigo == '0001-01-01 00:00:00'; else NgFechaMigo\" class=\"activeyellow\">\r\n                <img style=\"margin: -150px auto 0 auto; width: 3rem;\" src=\"../../../../assets/icons/boxes.png\" />\r\n                <div><label><strong>Ingreso en Almacén</strong></label></div>\r\n                <div><label> ----- </label></div>\r\n\r\n                <!--<div style=\"margin-top: 1rem;\">\r\n                  <div><label>Astrid</label></div>\r\n                  <div><label>1/1</label></div>\r\n                </div>-->\r\n              </li>\r\n              <ng-template #NgFechaMigo>\r\n                <li class=\"active\">\r\n                  <img style=\"margin: -150px auto 0 auto; width: 3rem;\" src=\"../../../../assets/icons/boxes.png\" />\r\n                  <div><label><strong>Ingreso en Almacén</strong></label></div>\r\n                  <div><label>{{FechaMigo}}</label></div>\r\n\r\n                  <!--<div style=\"margin-top: 1rem;\">\r\n                    <div><label>Astrid</label></div>\r\n                    <div><label>1/1</label></div>\r\n                  </div>-->\r\n                </li>\r\n              </ng-template>\r\n              <li *ngIf=\"FechaMiro == '0001-01-01 00:00:00'; else NgFechaMiro\" class=\"activeyellow\">\r\n                <img style=\"margin: -150px auto 0 auto; width: 3rem;\" src=\"../../../../assets/icons/calculating.png\" />\r\n                <div><label><strong>Registro de Factura</strong></label></div>\r\n                <div><label> ----- </label></div>\r\n\r\n                <!--<div style=\"margin-top: 1rem;\">\r\n                  <div><label>Astrid</label></div>\r\n                  <div><label>1/1</label></div>\r\n                </div>-->\r\n              </li>\r\n              <ng-template #NgFechaMiro>\r\n                <li class=\"active\">\r\n                  <img style=\"margin: -150px auto 0 auto; width: 3rem;\" src=\"../../../../assets/icons/calculating.png\" />\r\n                  <div><label><strong>Registro de Factura</strong></label></div>\r\n                  <div><label>{{FechaMiro}}</label></div>\r\n\r\n                  <!--<div style=\"margin-top: 1rem;\">\r\n                    <div><label>Astrid</label></div>\r\n                    <div><label>1/1</label></div>\r\n                  </div>-->\r\n                </li>\r\n              </ng-template>\r\n            </ul>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row cells12\">\r\n        <div class=\"divContainerGrid sombra\" style=\"padding: 1rem;\">\r\n          <div class=\"row cells12\">\r\n            <div class=\"cell colspan9\">\r\n              <div style=\"padding: 1rem;\">\r\n                <div><label><strong>Detalle</strong></label></div>\r\n                <div style=\"padding: 0.5rem; margin-top: 0.3rem;\"><label><strong>Factura # </strong>{{FacturaResponse}}</label></div>\r\n                <div style=\"padding: 0.5rem; margin-top: 0.3rem;\"><label><strong>Proveedor.</strong> {{PersonaNombre}}</label></div>\r\n                <div style=\"padding: 0.5rem; margin-top: 0.3rem;\"><label><strong>Dias Crédito. </strong>{{DiasCredito}}</label></div>\r\n              </div>\r\n              <div><app-grid-tracking-facturas-nacionales #myGridTrackingFacturasNacionales [data]=\"DataSkuFactura\"></app-grid-tracking-facturas-nacionales></div>\r\n            </div>\r\n            <div class=\"cell colspan3\" style=\"margin-top:0.5rem;\">\r\n              <div class=\"divsGrid\">\r\n                <div align=\"center\" style=\"margin-top: 0.5rem;\"><label style=\"color: gray; font-size:16px;\">Código Proveedor</label></div>\r\n                <div align=\"center\" style=\"margin-top: 1rem;\"><label><strong>{{CodigoProveedor}}</strong></label></div>\r\n              </div>\r\n              <div class=\"divsGrid\">\r\n                <div align=\"center\" style=\"margin-top: 0.5rem;\"><label style=\"color: gray; font-size:16px;\">Gestión</label></div>\r\n                <div align=\"center\" style=\"margin-top: 1rem;\"><label><strong>{{Gestion}}</strong></label></div>\r\n              </div>\r\n              <div class=\"divsGrid\">\r\n                <div align=\"center\" style=\"margin-top: 0.5rem;\"><label style=\"color: gray; font-size:16px;\">CR</label></div>\r\n                <div align=\"center\" style=\"margin-top: 1rem;\"><label><strong>{{CR}}</strong></label></div>\r\n              </div>\r\n              <div class=\"divsGrid\" (click)=\"VerAjustes()\">\r\n                <div align=\"center\" style=\"margin-top: 0.5rem;\"><label style=\"color: gray; font-size:16px;\">Ajustes</label></div>\r\n                <div align=\"center\" style=\"margin-top: 1rem;\"><label><strong>{{Ajustes}}</strong></label></div>\r\n              </div>\r\n              <div class=\"divsGrid\" (click)=\"VerDocumentos()\">\r\n                <div align=\"center\" style=\"margin-top: 0.5rem;\"><label style=\"color: gray; font-size:16px;\">Documentos</label></div>\r\n                <div align=\"center\" style=\"margin-top: 0.5rem; cursor:pointer;\"><img src=\"../../../../assets/icons/pdf.png\" /></div>\r\n              </div>\r\n              <div style=\"height: 4rem;\">\r\n                <div align=\"center\" style=\"margin-top: 0.5rem;\"><label style=\"color: gray; font-size:16px;\">Total Factura</label></div>\r\n                <div align=\"center\" style=\"margin-top: 1rem;\"><label><strong>{{TotalFacturada}}</strong></label></div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n    </div>\r\n\r\n    <!--Template Factura Internacional-->\r\n    <div *ngIf=\"MostrarTemplateInternacional == true\">\r\n \r\n      <div class=\"row cells12\">\r\n        <div class=\"divContainerSellos sombra\">\r\n          <div style=\"padding: 1rem;\">\r\n            <div class=\"row cells12\">\r\n              <div class=\"cell colspan8\"><span><strong style=\"font-size: 17px; margin: 2px;\">Fecha Factura: </strong><span><label>{{FechaFactura}}</label></span></span></div>\r\n            </div>\r\n            <div class=\"row cells12\">\r\n              <div class=\"cell colspan8\"><span><strong style=\"font-size: 17px; margin: 2px;\">Vencimiento: </strong><span><label>{{Vencimiento}}</label></span></span></div>\r\n            </div>\r\n          </div>\r\n          <div class=\"container\" style=\"margin-left: -0.8rem; margin-top: 4rem; height: 10rem;\">\r\n            <ul class=\"progressbarInternacional\">\r\n              <li *ngIf=\"(Entrada != '-----' && Salida == '-----') || (Entrada == '-----' && Salida == '-----'); else NgProveedor\" class=\"activeyellow\">\r\n                <img style=\"margin: -150px auto 0 auto; width: 3rem;\" src=\"../../../../assets/icons/truck.png\" />\r\n                <div><label><strong>Proveedor</strong></label></div>\r\n                <div style=\"margin-top: 0.5rem;\">\r\n                  <div><label><strong>Entrada:</strong></label></div>\r\n                  <div><label>{{Entrada}}</label></div>\r\n                  <div><label><strong>Salida:</strong></label></div>\r\n                  <div><label>{{Salida}}</label></div>\r\n                </div>\r\n\r\n                <!--<div style=\"margin-top: 1rem;\">\r\n                  <div><label>Astrid</label></div>\r\n                  <div><label>1/1</label></div>\r\n                </div>-->\r\n              </li>\r\n              <ng-template #NgProveedor>\r\n                <li class=\"active\">\r\n                  <img style=\"margin: -150px auto 0 auto; width: 3rem;\" src=\"../../../../assets/icons/truck.png\" />\r\n                  <div><label><strong>Proveedor</strong></label></div>\r\n                  <div style=\"margin-top: 0.5rem;\">\r\n                    <div><label><strong>Entrada:</strong></label></div>\r\n                    <div><label>{{Entrada}}</label></div>\r\n                    <div><label><strong>Salida:</strong></label></div>\r\n                    <div><label>{{Salida}}</label></div>\r\n                  </div>\r\n\r\n                  <!--<div style=\"margin-top: 1rem;\">\r\n                    <div><label>Astrid</label></div>\r\n                    <div><label>1/1</label></div>\r\n                  </div>-->\r\n                </li>\r\n              </ng-template>\r\n                <li *ngIf=\"Aduana == '0001-01-01 00:00:00'; else NgAduana\" class=\"activeyellow\">\r\n                  <img style=\"margin: -150px auto 0 auto; margin-left:0.5rem; width: 3.5rem;\" src=\"../../../../assets/icons/aduana.png\" />\r\n                  <div><label><strong>Aduana</strong></label></div>\r\n                  <div style=\"margin-top: 0.5rem;\">\r\n                    <div><label> ----- </label></div>\r\n                  </div>\r\n\r\n                <!--<div style=\"margin-top: 1rem;\">\r\n                  <div><label>Astrid</label></div>\r\n                  <div><label>0/1</label></div>\r\n                </div>-->\r\n              </li>\r\n              <ng-template #NgAduana>\r\n                <li class=\"active\">\r\n                  <img style=\"margin: -150px auto 0 auto; margin-left:0.5rem; width: 3.5rem;\" src=\"../../../../assets/icons/aduana.png\" />\r\n                  <div><label><strong>Aduana</strong></label></div>\r\n                  <div style=\"margin-top: 0.5rem;\">\r\n                    <div><label>{{Aduana}}</label></div>\r\n                  </div>\r\n\r\n                  <!--<div style=\"margin-top: 1rem;\">\r\n                    <div><label>Astrid</label></div>\r\n                    <div><label>1/1</label></div>\r\n                  </div>-->\r\n                </li>\r\n              </ng-template>\r\n              <li *ngIf=\"(EntradaFin != '-----' && SalidaFin == '-----') || (EntradaFin == '-----' && SalidaFin == '-----'); else NgBascula\" class=\"activeyellow\">\r\n                <img style=\"margin: -150px auto 0 auto; width: 3rem;\" src=\"../../../../assets/icons/pesaje.png\" />\r\n                <div><label><strong>Bascula</strong></label></div>\r\n                <div style=\"margin-top: 0.5rem;\">\r\n                    <div><label><strong>Entrada:</strong></label></div>\r\n                    <div><label>{{EntradaFin}}</label></div>\r\n                    <div><label><strong>Salida:</strong></label></div>\r\n                    <div><label>{{SalidaFin}}</label></div>\r\n                </div>                \r\n\r\n                <!--<div style=\"margin-top: 1rem;\">\r\n                  <div><label>Astrid</label></div>\r\n                  <div><label>1/1</label></div>\r\n                </div>-->\r\n              </li>\r\n              <ng-template #NgBascula>\r\n                <li class=\"active\">\r\n                  <img style=\"margin: -150px auto 0 auto; width: 3rem;\" src=\"../../../../assets/icons/pesaje.png\" />\r\n                  <div><label><strong>Bascula</strong></label></div>\r\n                  <div style=\"margin-top: 0.5rem;\">\r\n                    <div><label><strong>Entrada:</strong></label></div>\r\n                    <div><label>{{EntradaFin}}</label></div>\r\n                    <div><label><strong>Salida:</strong></label></div>\r\n                    <div><label>{{SalidaFin}}</label></div>\r\n                  </div>\r\n\r\n                  <!--<div style=\"margin-top: 1rem;\">\r\n                    <div><label>Astrid</label></div>\r\n                    <div><label>1/1</label></div>\r\n                  </div>-->\r\n                </li>\r\n              </ng-template>\r\n              <li *ngIf=\"Recepcion == '0001-01-01 00:00:00'; else NgRecepcion\" class=\"activeyellow\">\r\n                <img style=\"margin: -150px auto 0 auto; width: 3rem;\" src=\"../../../../assets/icons/trolley.png\" />\r\n                <div><label><strong>Recepción</strong></label></div>\r\n                <div style=\"margin-top: 0.5rem;\">\r\n                  <div><label> ----- </label></div>\r\n                </div>\r\n\r\n                <!--<div style=\"margin-top: 1rem;\">\r\n                  <div><label>Astrid</label></div>\r\n                  <div><label>0/1</label></div>\r\n                </div>-->\r\n              </li>\r\n              <ng-template #NgRecepcion>\r\n                <li class=\"active\">\r\n                  <img style=\"margin: -150px auto 0 auto; width: 3rem;\" src=\"../../../../assets/icons/trolley.png\" />\r\n                  <div><label><strong>Recepción</strong></label></div>\r\n                  <div style=\"margin-top: 0.5rem;\"> \r\n                    <div><label>{{Recepcion}}</label></div>\r\n                  </div>\r\n\r\n                  <!--<div style=\"margin-top: 1rem;\">\r\n                    <div><label>Astrid</label></div>\r\n                    <div><label>1/1</label></div>\r\n                  </div>-->\r\n                </li>\r\n              </ng-template>\r\n              <li *ngIf=\"FechaMigo == '0001-01-01 00:00:00'; else NgFechaMigo\" class=\"activeyellow\">\r\n                <img style=\"margin: -150px auto 0 auto; width: 3rem;\" src=\"../../../../assets/icons/boxes.png\" />\r\n                <div><label><strong>Ingreso en Almacén</strong></label></div>\r\n                <div style=\"margin-top: 0.5rem;\">\r\n                  <div><label> ----- </label></div>\r\n                </div>\r\n\r\n                <!--<div style=\"margin-top: 1rem;\">\r\n                  <div><label>Astrid</label></div>\r\n                  <div><label>1/1</label></div>\r\n                </div>-->\r\n              </li>\r\n              <ng-template #NgFechaMigo>\r\n                <li class=\"active\">\r\n                  <img style=\"margin: -150px auto 0 auto; width: 3rem;\" src=\"../../../../assets/icons/boxes.png\" />\r\n                  <div><label><strong>Ingreso en Almacén</strong></label></div>\r\n                  <div style=\"margin-top: 0.5rem;\"> \r\n                    <div><label>{{FechaMigo}}</label></div>\r\n                  </div>\r\n\r\n                  <!--<div style=\"margin-top: 1rem;\">\r\n                    <div><label>Astrid</label></div>\r\n                    <div><label>1/1</label></div>\r\n                  </div>-->\r\n                </li>\r\n              </ng-template>\r\n              <li *ngIf=\"FechaMiro == '0001-01-01 00:00:00'; else NgFechaMiro\" class=\"activeyellow\">\r\n                <img style=\"margin: -150px auto 0 auto; width: 3rem;\" src=\"../../../../assets/icons/calculating.png\" />\r\n                <div><label><strong>Registro de Factura</strong></label></div>\r\n                <div style=\"margin-top: 0.5rem;\">\r\n                  <div><label> ----- </label></div>\r\n                </div>\r\n\r\n                <!--<div style=\"margin-top: 1rem;\">\r\n                  <div><label>Astrid</label></div>\r\n                  <div><label>1/1</label></div>\r\n                </div>-->\r\n              </li>\r\n              <ng-template #NgFechaMiro>\r\n                <li class=\"active\">\r\n                  <img style=\"margin: -150px auto 0 auto; width: 3rem;\" src=\"../../../../assets/icons/calculating.png\" />\r\n                  <div><label><strong>Registro de Factura</strong></label></div>\r\n                  <div style=\"margin-top: 0.5rem;\">\r\n                    <div><label>{{FechaMiro}}</label></div>\r\n                  </div>\r\n\r\n                  <!--<div style=\"margin-top: 1rem;\">\r\n                    <div><label>Astrid</label></div>\r\n                    <div><label>1/1</label></div>\r\n                  </div>-->\r\n                </li>\r\n              </ng-template>\r\n            </ul>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row cells12\">\r\n        <div class=\"divContainerGrid sombra\" style=\"padding: 1rem;\">\r\n          <div class=\"row cells12\">\r\n            <div class=\"cell colspan9\">\r\n              <div style=\"padding: 1rem;\">\r\n                <div><label><strong>Detalle</strong></label></div>\r\n                <div style=\"padding: 0.5rem; margin-top: 0.3rem;\"><label><strong>Factura # </strong>{{FacturaResponse}}</label></div>\r\n                <div style=\"padding: 0.5rem; margin-top: 0.3rem;\"><label><strong>Proveedor.</strong> {{PersonaNombre}}</label></div>\r\n                <div style=\"padding: 0.5rem; margin-top: 0.3rem;\"><label><strong>Dias Crédito. </strong>{{DiasCredito}}</label></div>\r\n              </div>\r\n              <div><app-grid-tracking-facturas-nacionales #myGridTrackingFacturasNacionales [data]=\"DataSkuFactura\"></app-grid-tracking-facturas-nacionales></div>\r\n            </div>\r\n            <div class=\"cell colspan3\" style=\"margin-top:0.5rem;\">\r\n              <div class=\"divsGrid\">\r\n                <div align=\"center\" style=\"margin-top: 0.5rem;\"><label style=\"color: gray; font-size:16px;\">Código Proveedor</label></div>\r\n                <div align=\"center\" style=\"margin-top: 1rem;\"><label><strong>{{CodigoProveedor}}</strong></label></div>\r\n              </div>\r\n              <div class=\"divsGrid\">\r\n                <div align=\"center\" style=\"margin-top: 0.5rem;\"><label style=\"color: gray; font-size:16px;\">Gestión</label></div>\r\n                <div align=\"center\" style=\"margin-top: 1rem;\"><label><strong>{{Gestion}}</strong></label></div>\r\n              </div>\r\n              <div class=\"divsGrid\">\r\n                <div align=\"center\" style=\"margin-top: 0.5rem;\"><label style=\"color: gray; font-size:16px;\">CR</label></div>\r\n                <div align=\"center\" style=\"margin-top: 1rem;\"><label><strong>{{CR}}</strong></label></div>\r\n              </div>\r\n              <div class=\"divsGrid\" (click)=\"VerAjustes()\">\r\n                <div align=\"center\" style=\"margin-top: 0.5rem;\"><label style=\"color: gray; font-size:16px;\">Ajustes</label></div>\r\n                <div align=\"center\" style=\"margin-top: 1rem;\"><label><strong>{{Ajustes}}</strong></label></div>\r\n              </div>\r\n              <div class=\"divsGrid\" (click)=\"VerDocumentos()\">\r\n                <div align=\"center\" style=\"margin-top: 0.5rem;\"><label style=\"color: gray; font-size:16px;\">Documentos</label></div>\r\n                <div align=\"center\" style=\"margin-top: 0.5rem; cursor:pointer;\"><img src=\"../../../../assets/icons/pdf.png\" /></div>\r\n              </div>\r\n              <div style=\"height: 4rem;\">\r\n                <div align=\"center\" style=\"margin-top: 0.5rem;\"><label style=\"color: gray; font-size:16px;\">Total Factura</label></div>\r\n                <div align=\"center\" style=\"margin-top: 1rem;\"><label><strong>{{TotalFacturada}}</strong></label></div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<modal-template #modalAjustePrecioCarga [width-modal]=\"'90%'\" [height-modal]=\"'31rem'\">\r\n  <div class=\"grid demo-grid\" style=\"padding: 1rem;\">\r\n    <div class=\"row cells12\">\r\n      <div class=\"divContainerGridAjustes sombra\" style=\"padding: 1rem;\">\r\n        <div><h3>Ajuste por Precio</h3></div>\r\n        <div class=\"row cells12\">\r\n          <div class=\"cell colspan9\">\r\n            <app-grid-ajustes-precio #myGridAjustesPrecio></app-grid-ajustes-precio>\r\n          </div>\r\n          <div class=\"cell colspan3\">\r\n            <div style=\" border: outset; height: 5rem;\">\r\n              <div align=\"center\"><h5>TOTAL DIFERENCIA</h5></div>\r\n              <div align=\"center\"><h5>{{TotalDiferencia}}</h5></div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"row cells12\">\r\n      <div class=\"divContainerGridAjustes sombra\" style=\"padding: 1rem;\">\r\n        <div><h3>Ajuste por Carga</h3></div>\r\n        <div class=\"row cells12\">\r\n          <app-grid-ajustes-carga #myGridAjustesCarga></app-grid-ajustes-carga>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n  </div>\r\n</modal-template>\r\n\r\n<modal-template #modalOrdenCompra [width-modal]=\"'90%'\" [height-modal]=\"'28.5rem'\">\r\n  <div class=\"grid demo-grid\" style=\"padding: 0.2rem;\">\r\n    <div class=\"row cells12\">\r\n      <div class=\"cell colspan3\">\r\n        <label><strong>Orden de Compra</strong><label style=\"color: red;\">*</label></label>\r\n        <div class=\"input-control text full-size sombra\" data-role=\"input\">\r\n          <input type=\"text\" [(ngModel)]=\"OrdendeCompraInput\" />\r\n          <button class=\"button helper-button clear\" (click)=\"ClearInputOC()\"><span class=\"mif-cross\"></span></button>\r\n        </div>\r\n      </div>\r\n      <div class=\"cell\">\r\n        <div style=\"margin-top: 0.75rem;\">\r\n          <button class=\"button square-button mif-search mif-lg fg-white sombra\" style=\"background-color: #0072C6;\" (click)=\"BuscarOC()\"></button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"row cells12\">\r\n      <app-grid-orden-compra #myGridOrdenCompra (VerFacturaOrdenCompra)=\"VerFacturaOrdenCompraYCodigoProveedor($event)\"></app-grid-orden-compra>\r\n    </div>\r\n  </div>\r\n</modal-template>\r\n\r\n<modal-template #modalCodigoProveedor [width-modal]=\"'90%'\" [height-modal]=\"'28.5rem'\">\r\n  <div class=\"grid demo-grid\" style=\"padding: 0.2rem;\">\r\n    <div class=\"row cells12\">\r\n      <div class=\"cell colspan3\">\r\n        <label><strong>Código Proveedor</strong><label style=\"color: red;\">*</label></label>\r\n        <div class=\"input-control text full-size sombra\" data-role=\"input\">\r\n          <input type=\"text\" [(ngModel)]=\"CodigoProveedorInput\">\r\n          <button class=\"button helper-button clear\" (click)=\"ClearInputCP()\"><span class=\"mif-cross\"></span></button>\r\n        </div>\r\n      </div>\r\n      <div class=\"cell\">\r\n        <div style=\"margin-top: 0.75rem;\">\r\n          <button class=\"button square-button mif-search mif-lg fg-white sombra\" style=\"background-color: #0072C6;\" (click)=\"BuscarCP()\"></button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"row cells12\">\r\n      <app-grid-codigo-proveedor #myGridCodigoProveedor (VerFacturaCodigoProveedor)=\"VerFacturaOrdenCompraYCodigoProveedor($event)\"></app-grid-codigo-proveedor>\r\n    </div>\r\n  </div>\r\n</modal-template>\r\n\r\n<fileshare></fileshare>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/screen/requisas/requisas/requisas.component.html":
/*!********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/screen/requisas/requisas/requisas.component.html ***!
  \********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"grid\">\r\n  <div class=\"row cells12\">\r\n    <div class=\"grid\" style=\"margin-top:10px; background-color:#0F6BBF ; color:#FFFFFF;\">\r\n      <h3 style=\"text-align:center;\">Carrusel</h3>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"row cells12\">\r\n    <div class=\"cell colspan4\"></div>\r\n    <div class=\"cell colspan8\">\r\n      <div align=\"right\">\r\n        <button class=\"button\" style=\"margin: 1px;\"><img style=\"width: 1.5rem; height: 1.5rem; cursor:pointer;\" src=\"../../../../assets/icons/bad box.png\">   Productos Dañados</button>\r\n        <button class=\"button\" style=\"margin: 1px;\"><img style=\"width: 1.5rem; height: 1.5rem; cursor:pointer;\" src=\"../../../../assets/icons/printer.png\"></button>\r\n        <!--<button class=\"button\" style=\"margin: 1px;\" (click)=\"ReordenarProximasSalidas()\"><img style=\"width: 2rem; height: 2rem; cursor:pointer;\" src=\"../../../../assets/icons/stock-keeping-unit.png\"></button>-->\r\n        <button class=\"button\" style=\"margin: 1px;\"><img style=\"width: 2rem; height: 2rem; cursor:pointer;\" src=\"../../../../assets/icons/refresh-button.png\"></button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"row cells12\">\r\n\r\n    <!--Div Proximas Salidas-->\r\n    <div class=\"cell colspan6\">\r\n      <div class=\"row cells6\">\r\n        <div class=\"grid\" style=\"text-align:left; margin-top:10px; background-color:#0F6BBF ; color:#FFFFFF; height: 2rem;\">\r\n          <div class=\"row cells6\">\r\n            <div class=\"cell colspan4\">\r\n              <h5 style=\"margin: .5rem;\">Proximas Salidas</h5>\r\n            </div>\r\n            <div class=\"cell colspan2\">\r\n              <h5>Cantidad de Salidas: {{totalProximasSalidas}}</h5>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row cells6\">\r\n        <div class=\"cell colspan3\">\r\n          <div class=\"input-control text full-size\">\r\n            <input type=\"text\" placeholder=\"Busque una proxima salida...\" name=\"searchProximaSalida\" value=\"searchProximaSalida\" [(ngModel)]=\"searchProximaSalida\" #searchSalida=\"ngModel\" (keyup)=\"searchProximasSalidas(searchSalida.value)\" />\r\n          </div>\r\n        </div>\r\n        <div class=\"cell\" *ngIf=\"userPriorizadoYNoPriorizado == true;\">\r\n          <div *ngIf=\"enabledDisabledImg == false; else enabled\">\r\n            <img src=\"../../../../assets/icons/padlock.png\" style=\"width: 2rem; cursor:pointer;\" (click)=\"ChangeEnabledDisabled()\" />\r\n          </div>\r\n          <ng-template #enabled>\r\n            <div>\r\n              <img src=\"../../../../assets/icons/unlocked.png\" style=\"width: 2rem; cursor:pointer;\" (click)=\"ChangeEnabledDisabled()\" />\r\n            </div>\r\n          </ng-template>\r\n          <!--<div style=\"margin-top: .5rem;\">\r\n              <label class=\"switch transition-on\">\r\n                <input type=\"checkbox\" data-role=\"switch\" data-caption=\"Check\" (change)=\"ChangeEnabledDisabled()\" [(ngModel)]=\"EnabledDisabled\" />\r\n                <span class=\"check\"></span>\r\n                <span class=\"caption\" style=\"margin-left: 8px;\"> Habilitar/Deshabilitar</span>\r\n              </label>\r\n          </div>-->\r\n        </div>\r\n        <div class=\"cell colspan2\">\r\n          <div style=\"margin-top: .5rem;\">\r\n            <label style=\"font-size: 15px;\">Total KG: {{totalKilosProximasSalidas}}</label>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row cells6\">\r\n        <div style=\"background-color: #F8F9F9; border-radius: 3px; border: 1px solid slategray; padding: 1rem; overflow: auto; overflow-x: hidden; height:30rem;\">\r\n          <div *ngIf=\"userPriorizadoYNoPriorizado == true; else NoPriorizado\">\r\n            <div class=\"cardView\" *ngFor=\"let data of DataProximasSalidas | filtroProximasSalidas: searchProximaSalida; let i = index\">\r\n              <div class=\"row cells6\">\r\n                <div class=\"cell\">\r\n                  <div style=\"margin-top: 1rem;\">\r\n                    <button class=\"button dark cycle outline\" (click)=\"SubirTarjeta(data.Id)\"><img [ngClass]=\"{'EnableUpDown': enabledDisabledImg == false}\" src=\"../../../../assets//icons/arrow-up.png\" /></button>\r\n                    <button class=\"button dark cycle outline\" (click)=\"BajarTarjeta(data.Id)\"><img [ngClass]=\"{'EnableUpDown': enabledDisabledImg == false}\" src=\"../../../../assets//icons/arrow-down.png\" /></button>\r\n                  </div>\r\n                </div>\r\n                <div class=\"cell colspan5\">\r\n                  <div class=\"row cells5\">\r\n                    <div class=\"cell colspan2\">\r\n                      <div class=\"row cells2\">\r\n                        <span class=\"icon\">\r\n                          <img src=\"../../../../assets/icons/delivery-box.png\" style=\"width: 1.5rem; height: 1.5rem;\" />\r\n                        </span>\r\n                        <span>\r\n                          <label style=\"margin: .5rem; font-size: 15px;\"><Strong>{{data.NumeroPallet}}</Strong></label>\r\n                        </span>\r\n                      </div>\r\n                    </div>\r\n                    <div class=\"cell colspan3\"><label class=\"fuente\" style=\"margin: .5rem;\">{{data.Sku}}</label></div>\r\n                  </div>\r\n                  <div class=\"row cells5\">\r\n                    <div class=\"cell colspan3\">\r\n                      <span class=\"icon\">\r\n                        <img src=\"../../../../assets/icons/truck-1.png\" style=\"width: 1.5rem; height: 1.5rem;\" />\r\n                      </span>\r\n                      <label class=\"fuente\" style=\"margin: .5rem;\">\r\n                        Posicion De Salida:\r\n                        <span>\r\n                          <label class=\"fuente\" style=\"margin: .5rem;\">{{data.TurnoDeSalida}}</label>\r\n                        </span>\r\n                      </label>\r\n                    </div>\r\n                    <div class=\"cell colspan2\">\r\n                      <span class=\"icon\">\r\n                        <img src=\"../../../../assets/icons/quotation.png\" style=\"width: 1.5rem; height: 1.5rem;\" />\r\n                      </span>\r\n                      <label class=\"fuente\" style=\"margin: .5rem;\">{{data.Factura}}</label>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row cells5\">\r\n                    <div class=\"cell colspan3\">\r\n                      <span class=\"icon\">\r\n                        <img src=\"../../../../assets/icons/unit.png\" style=\"width: 1.5rem; height: 1.5rem;\" />\r\n                      </span>\r\n                      <label class=\"fuente\" style=\"margin: .5rem;\">{{data.Kilos}}</label>\r\n                    </div>\r\n                    <div class=\"cell colspan2\">\r\n                      <span class=\"icon\">\r\n                        <img src=\"../../../../assets/icons/package.png\" style=\"width: 1.5rem; height: 1.5rem;\" />\r\n                      </span>\r\n                      <label class=\"fuente\" style=\"margin: .5rem;\">{{data.Variedad}}</label>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row cells5\">\r\n                    <div class=\"cell colspan3\">\r\n                      <span class=\"icon\">\r\n                        <img src=\"../../../../assets/icons/container.png\" style=\"width: 1.5rem; height: 1.5rem;\" />\r\n                      </span>\r\n                      <label class=\"fuente\" style=\"margin: .5rem;\">{{data.Contenedor}}</label>\r\n                    </div>\r\n                    <div class=\"cell colspan2\">\r\n                      <span class=\"icon\">\r\n                        <img src=\"../../../../assets/icons/sap.png\" style=\"width: 1.8rem; height: 1.8rem;\" />\r\n                      </span>\r\n                      <label class=\"fuente\" style=\"margin: .5rem;\">{{data.Migo}}</label>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n\r\n          <ng-template #NoPriorizado>\r\n            <div class=\"cardView\" *ngFor=\"let data of DataProximasSalidas | filtroProximasSalidas: searchProximaSalida; let i = index\">\r\n                <div class=\"row cells6\">\r\n                    <div class=\"cell colspan2\">\r\n                      <div class=\"row cells2\">\r\n                        <span class=\"icon\">\r\n                          <img src=\"../../../../assets/icons/delivery-box.png\" style=\"width: 1.5rem; height: 1.5rem;\" />\r\n                        </span>\r\n                        <span>\r\n                          <label style=\"margin: .5rem; font-size: 15px;\"><Strong>{{data.NumeroPallet}}</Strong></label>\r\n                        </span>\r\n                      </div>\r\n                    </div>\r\n                    <div class=\"cell colspan4\"><label class=\"fuente\" style=\"margin: .5rem;\">{{data.Sku}}</label></div>\r\n                  </div>\r\n                <div class=\"row cells6\">\r\n                    <div class=\"cell colspan3\">\r\n                      <span class=\"icon\">\r\n                        <img src=\"../../../../assets/icons/truck-1.png\" style=\"width: 1.5rem; height: 1.5rem;\" />\r\n                      </span>\r\n                      <label class=\"fuente\" style=\"margin: .5rem;\">\r\n                        Posicion De Salida:\r\n                        <span>\r\n                          <label class=\"fuente\" style=\"margin: .5rem;\">{{data.TurnoDeSalida}}</label>\r\n                        </span>\r\n                      </label>\r\n                    </div>\r\n                    <div class=\"cell colspan3\">\r\n                      <span class=\"icon\">\r\n                        <img src=\"../../../../assets/icons/quotation.png\" style=\"width: 1.5rem; height: 1.5rem;\" />\r\n                      </span>\r\n                      <label class=\"fuente\" style=\"margin: .5rem;\">{{data.Factura}}</label>\r\n                    </div>\r\n                  </div>\r\n                <div class=\"row cells6\">\r\n                    <div class=\"cell colspan3\">\r\n                      <span class=\"icon\">\r\n                        <img src=\"../../../../assets/icons/unit.png\" style=\"width: 1.5rem; height: 1.5rem;\" />\r\n                      </span>\r\n                      <label class=\"fuente\" style=\"margin: .5rem;\">{{data.Kilos}}</label>\r\n                    </div>\r\n                    <div class=\"cell colspan3\">\r\n                      <span class=\"icon\">\r\n                        <img src=\"../../../../assets/icons/package.png\" style=\"width: 1.5rem; height: 1.5rem;\" />\r\n                      </span>\r\n                      <label class=\"fuente\" style=\"margin: .5rem;\">{{data.Variedad}}</label>\r\n                    </div>\r\n                  </div>\r\n            </div>\r\n          </ng-template>\r\n        </div>\r\n      </div>\r\n\r\n\r\n    </div>\r\n\r\n    <!--Div Pallets en Sitio-->\r\n    <div class=\"cell colspan6\">\r\n      <div class=\"row cells6\">\r\n        <div class=\"grid\" style=\"text-align:left; margin-top:10px; background-color:#0F6BBF ; color:#FFFFFF; height: 2rem;\">\r\n          <div class=\"row cells6\">\r\n            <div class=\"cell colspan4\">\r\n              <h5 style=\"margin: .5rem;\">Pallets En Sitio</h5>\r\n            </div>\r\n            <div class=\"cell colspan2\">\r\n              <h5>Cantidad de Pallets: 0</h5>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row cells6\">\r\n        <div class=\"cell colspan4\">\r\n          <div class=\"input-control text full-size\">\r\n            <input type=\"text\" placeholder=\"Busque un pallet en sitio...\" name=\"searchPalletEnSitio\" value=\"searchPalletEnSitio\" [(ngModel)]=\"searchPalletEnSitio\" #searchPallet=\"ngModel\" (keyup)=\"searchPalletsEnSitio(searchPallet.value)\" />\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div style=\"background-color: #F8F9F9; border-radius: 3px; border: 1px solid slategray; padding: 1rem; overflow: auto; overflow-x: hidden; height:30rem;\">\r\n        <!--<div class=\"cardView\" *ngFor=\"let data of ListaPalletsEnSitio | filtroPalletsEnSitio: searchPalletEnSitio; let i = index\">-->\r\n        <!--<div class=\"cardView\">\r\n          <div class=\"row cells6\">\r\n            <div class=\"cell colspan3\">\r\n              <div class=\"row cells2\">\r\n                <span class=\"icon\">\r\n                  <img src=\"../../../../assets/icons/delivery-box.png\" style=\"width: 1.5rem; height: 1.5rem;\" />\r\n                </span>\r\n                <span>\r\n                  <label style=\"margin: .5rem; font-size: 15px;\"><Strong>{{data.Gestion}}</Strong></label>\r\n                </span>\r\n              </div>\r\n            </div>\r\n            <div class=\"cell colspan3\"><label class=\"fuente\" style=\"margin: .5rem;\">{{data.Descripcion}}</label></div>\r\n          </div>\r\n          <div class=\"row cells6\">\r\n            <div class=\"cell colspan3\">\r\n              <span class=\"icon\">\r\n                <img src=\"../../../../assets/icons/truck-1.png\" style=\"width: 1.5rem; height: 1.5rem;\" />\r\n              </span>\r\n              <label class=\"fuente\" style=\"margin: .5rem;\">\r\n                Posicion De Salida:\r\n                <span>\r\n                  <label class=\"fuente\" style=\"margin: .5rem;\">{{data.PosicionSalida}}</label>\r\n                </span>\r\n              </label>\r\n            </div>\r\n            <div class=\"cell colspan2\">\r\n              <span class=\"icon\">\r\n                <img src=\"../../../../assets/icons/quotation.png\" style=\"width: 1.5rem; height: 1.5rem;\" />\r\n              </span>\r\n              <label class=\"fuente\" style=\"margin: .5rem;\">{{data.Factura}}</label>\r\n            </div>\r\n          </div>\r\n          <div class=\"row cells6\">\r\n            <div class=\"cell colspan3\">\r\n              <span class=\"icon\">\r\n                <img src=\"../../../../assets/icons/unit.png\" style=\"width: 1.5rem; height: 1.5rem;\" />\r\n              </span>\r\n              <label class=\"fuente\" style=\"margin: .5rem;\">{{data.Kilos}}</label>\r\n            </div>\r\n            <div class=\"cell colspan2\">\r\n              <span class=\"icon\">\r\n                <img src=\"../../../../assets/icons/package.png\" style=\"width: 1.5rem; height: 1.5rem;\" />\r\n              </span>\r\n              <label class=\"fuente\" style=\"margin: .5rem;\">{{data.Variedad}}</label>\r\n            </div>\r\n          </div>\r\n        </div>-->\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n</div>\r\n");

/***/ }),

/***/ "./node_modules/tslib/tslib.es6.js":
/*!*****************************************!*\
  !*** ./node_modules/tslib/tslib.es6.js ***!
  \*****************************************/
/*! exports provided: __extends, __assign, __rest, __decorate, __param, __metadata, __awaiter, __generator, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function() { return __decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function() { return __param; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function() { return __metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function() { return __exportStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return __spread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spreadArrays", function() { return __spreadArrays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__await", function() { return __await; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function() { return __asyncGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function() { return __asyncDelegator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function() { return __asyncValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function() { return __makeTemplateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importStar", function() { return __importStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importDefault", function() { return __importDefault; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),

/***/ "./src/app/app-routing.module.ts":
/*!***************************************!*\
  !*** ./src/app/app-routing.module.ts ***!
  \***************************************/
/*! exports provided: AppRoutingModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppRoutingModule", function() { return AppRoutingModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _screen_reporte_tracking_facturas_nacionales_Copy_reporte_tracking_facturas_nacionales_reporte_tracking_facturas_nacionales_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./screen/reporte-tracking-facturas-nacionales - Copy/reporte-tracking-facturas-nacionales/reporte-tracking-facturas-nacionales.component */ "./src/app/screen/reporte-tracking-facturas-nacionales - Copy/reporte-tracking-facturas-nacionales/reporte-tracking-facturas-nacionales.component.ts");
/* harmony import */ var vesta_menu__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! vesta-menu */ "./dist-library/vesta-menu/fesm2015/vesta-menu.js");
/* harmony import */ var vesta__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! vesta */ "./dist-library/vesta/fesm2015/vesta.js");
/* harmony import */ var vesta_authentication__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! vesta-authentication */ "./dist-library/vesta-authentication/fesm2015/vesta-authentication.js");







const routes = [
    { path: "", redirectTo: "menu", pathMatch: "full" },
    {
        path: "login/accessdenied", component: vesta__WEBPACK_IMPORTED_MODULE_5__["AccesoDenegadoComponent"]
    },
    {
        path: "menu",
        component: vesta_menu__WEBPACK_IMPORTED_MODULE_4__["VestaMenuComponent"], canActivate: [vesta_authentication__WEBPACK_IMPORTED_MODULE_6__["AuthorizationGuard"]]
    },
    {
        path: 'mantenimiento', children: [
            {
                path: "asignacióndesegmentos",
                loadChildren: "../app/screen/asignacion-segmentos/asignacion-segmentos.module#AsignacionSegmentosModule",
                canActivate: [vesta_authentication__WEBPACK_IMPORTED_MODULE_6__["AuthorizationGuard"]]
            }
        ]
    },
    {
        path: 'operaciones', children: [
            {
                path: 'gestiones',
                loadChildren: "../app/screen/gestiones/gestiones.module#GestionesModule",
                canActivate: [vesta_authentication__WEBPACK_IMPORTED_MODULE_6__["AuthorizationGuard"]]
            },
            {
                path: "ajustesporrecepcióndecarga",
                loadChildren: "../app/screen/revision-ajuste/revision-ajuste.module#RevisionAjusteModule",
                canActivate: [vesta_authentication__WEBPACK_IMPORTED_MODULE_6__["AuthorizationGuard"]]
            },
            {
                path: "solicitudderequisa",
                loadChildren: "../app/screen/solicitudmateria-prima/solicitudmateria-prima.module#SolicitudmateriaPrimaModule",
                canActivate: [vesta_authentication__WEBPACK_IMPORTED_MODULE_6__["AuthorizationGuard"]]
            },
            {
                path: "ingresodefacturas",
                loadChildren: "../app/screen/revision-ingreso/revision-ingreso.module#RevisionIngresoModule",
                canActivate: [vesta_authentication__WEBPACK_IMPORTED_MODULE_6__["AuthorizationGuard"]]
            },
            {
                path: "registrosmigo",
                loadChildren: "../app/screen/registro-migo/registro-migo.module#RegistroMigoModule",
                canActivate: [vesta_authentication__WEBPACK_IMPORTED_MODULE_6__["AuthorizationGuard"]]
            },
            {
                path: "carrusel",
                loadChildren: "../app/screen/requisas/requisas.module#RequisasModule",
                canActivate: [vesta_authentication__WEBPACK_IMPORTED_MODULE_6__["AuthorizationGuard"]]
            }
        ]
    },
    {
        path: 'reportes', children: [
            {
                path: "reportepicking",
                loadChildren: "../app/screen/picking/picking.module#PickingModule",
                canActivate: [vesta_authentication__WEBPACK_IMPORTED_MODULE_6__["AuthorizationGuard"]]
            },
            {
                path: "reportemigo",
                loadChildren: "../app/screen/migo-sap/migo-sap.module#MigoSapModule",
                canActivate: [vesta_authentication__WEBPACK_IMPORTED_MODULE_6__["AuthorizationGuard"]]
            },
            {
                path: "reportemiro",
                loadChildren: "../app/screen/miro-sap/miro-sap.module#MiroSapModule",
                canActivate: [vesta_authentication__WEBPACK_IMPORTED_MODULE_6__["AuthorizationGuard"]]
            },
            {
                path: "reportetraslados",
                loadChildren: "../app/screen/traslados-sap/traslados-sap.module#TrasladosSapModule",
                canActivate: [vesta_authentication__WEBPACK_IMPORTED_MODULE_6__["AuthorizationGuard"]]
            }
        ]
    },
    {
        path: 'consultas', children: [
            {
                path: "gestióndeinventario",
                //loadChildren: "../app/screen/gestion-inventario-copia/gestion-inventario-copia.module#GestionInventarioCopiaModule",
                loadChildren: "../app/screen/inventarios/inventarios.module#InventariosModule",
                canActivate: [vesta_authentication__WEBPACK_IMPORTED_MODULE_6__["AuthorizationGuard"]]
            },
            {
                path: "cortediario",
                loadChildren: "../app/screen/corte-diario/corte-diario.module#CorteDiarioModule",
                canActivate: [vesta_authentication__WEBPACK_IMPORTED_MODULE_6__["AuthorizationGuard"]]
            },
            {
                path: "reportetrackingfacturas",
                loadChildren: "../app/screen/reporte-tracking-facturas-nacionales/reporte-tracking-facturas-nacionales.module#ReporteTrackingFacturasNacionalesModule",
                canActivate: [vesta_authentication__WEBPACK_IMPORTED_MODULE_6__["AuthorizationGuard"]]
            }
        ]
    },
    { path: 'reportefacturastracking', component: _screen_reporte_tracking_facturas_nacionales_Copy_reporte_tracking_facturas_nacionales_reporte_tracking_facturas_nacionales_component__WEBPACK_IMPORTED_MODULE_3__["ReporteTrackingFacturasNacionalesComponent"] },
];
let AppRoutingModule = class AppRoutingModule {
};
AppRoutingModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        imports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"].forRoot(routes)],
        exports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"]]
    })
], AppRoutingModule);



/***/ }),

/***/ "./src/app/app.component.css":
/*!***********************************!*\
  !*** ./src/app/app.component.css ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2FwcC5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/app.component.ts":
/*!**********************************!*\
  !*** ./src/app/app.component.ts ***!
  \**********************************/
/*! exports provided: AppComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppComponent", function() { return AppComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var vesta_authentication__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vesta-authentication */ "./dist-library/vesta-authentication/fesm2015/vesta-authentication.js");
/* harmony import */ var vesta_firebase__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! vesta-firebase */ "./dist-library/vesta-firebase/fesm2015/vesta-firebase.js");
/* harmony import */ var vesta__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! vesta */ "./dist-library/vesta/fesm2015/vesta.js");





let AppComponent = class AppComponent {
    constructor(userAuth, authService, webPush, DialogService) {
        this.userAuth = userAuth;
        this.authService = authService;
        this.webPush = webPush;
        this.DialogService = DialogService;
        this.user = this.userAuth;
    }
    ngOnInit() {
        this.userAuth.UserEvent.subscribe((response) => tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            if (response.Id == null)
                return void 0;
            this.user = response;
            let resp = yield this.NotificacionFirebase();
            if (resp == false)
                return void 0;
            let mensajes = yield this.webPush.GetMensajesUsuario();
        }));
    }
    NotificacionFirebase() {
        let promise = new Promise((resolve, reject) => tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            let resp = yield this.webPush.RequestPermission(this.user);
            this.webPush.OnMessaging.subscribe(payload => {
                this.DialogService.NotificacionWarning(payload.notification.body);
            });
            resolve(resp);
        }));
        return promise;
    }
    Logout() {
        this.authService.signoutRedirect();
    }
};
AppComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [vesta_authentication__WEBPACK_IMPORTED_MODULE_2__["USER_AUTH"],] }] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [vesta_authentication__WEBPACK_IMPORTED_MODULE_2__["AUTH_SERVICE"],] }] },
    { type: vesta_firebase__WEBPACK_IMPORTED_MODULE_3__["WebPushFirebaseService"] },
    { type: vesta__WEBPACK_IMPORTED_MODULE_4__["DialogService"] }
];
AppComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-root',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./app.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./app.component.css */ "./src/app/app.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__param"](0, Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"])(vesta_authentication__WEBPACK_IMPORTED_MODULE_2__["USER_AUTH"])),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__param"](1, Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"])(vesta_authentication__WEBPACK_IMPORTED_MODULE_2__["AUTH_SERVICE"]))
], AppComponent);



/***/ }),

/***/ "./src/app/app.module.ts":
/*!*******************************!*\
  !*** ./src/app/app.module.ts ***!
  \*******************************/
/*! exports provided: AppModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppModule", function() { return AppModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _app_routing_module__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./app-routing.module */ "./src/app/app-routing.module.ts");
/* harmony import */ var vesta__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! vesta */ "./dist-library/vesta/fesm2015/vesta.js");
/* harmony import */ var _app_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./app.component */ "./src/app/app.component.ts");
/* harmony import */ var _screen_reporte_tracking_facturas_nacionales_Copy_reporte_tracking_facturas_nacionales_module__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./screen/reporte-tracking-facturas-nacionales - Copy/reporte-tracking-facturas-nacionales.module */ "./src/app/screen/reporte-tracking-facturas-nacionales - Copy/reporte-tracking-facturas-nacionales.module.ts");
/* harmony import */ var _screen_requisas_requisas_module__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./screen/requisas/requisas.module */ "./src/app/screen/requisas/requisas.module.ts");
/* harmony import */ var vesta_menu__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! vesta-menu */ "./dist-library/vesta-menu/fesm2015/vesta-menu.js");
/* harmony import */ var vesta_authentication__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! vesta-authentication */ "./dist-library/vesta-authentication/fesm2015/vesta-authentication.js");
/* harmony import */ var vesta_firebase__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! vesta-firebase */ "./dist-library/vesta-firebase/fesm2015/vesta-firebase.js");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");






//import { GestionesModule } from './screen/gestiones/gestiones.module';
//import { RevisionAjusteModule } from './screen/revision-ajuste/revision-ajuste.module';
//import { AsignacionSegmentosModule } from './screen/asignacion-segmentos/asignacion-segmentos.module';
//import { PickingModule } from './screen/picking/picking.module';
//import { SolicitudmateriaPrimaModule } from './screen/solicitudmateria-prima/solicitudmateria-prima.module';
//import { GestionInventarioModule } from './screen/gestion-inventario/gestion-inventario.module';
//import { GestionInventarioCopiaModule } from './screen/gestion-inventario-copia/gestion-inventario-copia.module';
//import { RevisionIngresoModule } from './screen/revision-ingreso/revision-ingreso.module';
//import { InventariosModule } from './screen/inventarios/inventarios.module';
//import { MigoSapModule } from './screen/migo-sap/migo-sap.module';
//import { MiroSapModule } from './screen/miro-sap/miro-sap.module';
//import { TrasladosSapModule } from './screen/traslados-sap/traslados-sap.module';
//import { CorteDiarioModule } from './screen/corte-diario/corte-diario.module';
//import { JqxGridModule } from './ng-modules/jqx-grid/jqx-grid.module';
//import { JqxTabsModule } from './ng-modules/jqx-tabs/jqx-tabs.module';






let AppModule = class AppModule {
};
AppModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["NgModule"])({
        declarations: [
            _app_component__WEBPACK_IMPORTED_MODULE_5__["AppComponent"]
        ],
        imports: [
            _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__["BrowserModule"],
            _app_routing_module__WEBPACK_IMPORTED_MODULE_3__["AppRoutingModule"],
            vesta_authentication__WEBPACK_IMPORTED_MODULE_9__["VestaAuthenticationModule"].forRoot(src_environments_environment__WEBPACK_IMPORTED_MODULE_11__["environment"].authentication),
            vesta_menu__WEBPACK_IMPORTED_MODULE_8__["VestaMenuModule"],
            vesta__WEBPACK_IMPORTED_MODULE_4__["VestaModule"].forRoot({ isAuthentication: true }),
            vesta_firebase__WEBPACK_IMPORTED_MODULE_10__["VestaFirebaseModule"].forRoot(src_environments_environment__WEBPACK_IMPORTED_MODULE_11__["environment"].firebase, { production: false }),
            //JqxGridModule,
            //JqxTabsModule,
            //GestionesModule,
            //RevisionAjusteModule,
            //AsignacionSegmentosModule,
            //PickingModule,
            //SolicitudmateriaPrimaModule,
            //RevisionIngresoModule,
            //GestionInventarioModule,
            //GestionInventarioCopiaModule,
            //InventariosModule,
            //MigoSapModule,
            //MiroSapModule,
            //TrasladosSapModule,
            _screen_reporte_tracking_facturas_nacionales_Copy_reporte_tracking_facturas_nacionales_module__WEBPACK_IMPORTED_MODULE_6__["ReporteTrackingFacturasNacionalesModule"],
            _screen_requisas_requisas_module__WEBPACK_IMPORTED_MODULE_7__["RequisasModule"]
            //CorteDiarioModule
        ],
        providers: [],
        bootstrap: [_app_component__WEBPACK_IMPORTED_MODULE_5__["AppComponent"]]
    })
], AppModule);



/***/ }),

/***/ "./src/app/extensions/moment-extends.ts":
/*!**********************************************!*\
  !*** ./src/app/extensions/moment-extends.ts ***!
  \**********************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! moment */ "./node_modules/moment/moment.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);


moment__WEBPACK_IMPORTED_MODULE_1__["prototype"].isMayor = function (input) {
    var fecha = this;
    if (input === null) {
        var value = fecha.diff(input);
        if (value > 0) {
            return true;
        }
        else {
            return false;
        }
    }
    else {
        return true;
    }
};
moment__WEBPACK_IMPORTED_MODULE_1__["prototype"].FormatoFecha = function () {
    var fecha = this;
    return fecha.format("DD/MM/YYYY HH:mm:ss");
};
moment__WEBPACK_IMPORTED_MODULE_1__["prototype"].FormatoFechaCSharp = function () {
    var fecha = this;
    return fecha.format("YYYY-MM-DD HH:mm:ss");
};
moment__WEBPACK_IMPORTED_MODULE_1__["prototype"].FormatoFechaShort = function () {
    var fecha = this;
    return fecha.format("YYYY-MM-DD");
};


/***/ }),

/***/ "./src/app/ng-modules/jqx-grid/jqx-grid.module.ts":
/*!********************************************************!*\
  !*** ./src/app/ng-modules/jqx-grid/jqx-grid.module.ts ***!
  \********************************************************/
/*! exports provided: JqxGridModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JqxGridModule", function() { return JqxGridModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _node_modules_jqwidgets_scripts_jqwidgets_ts_angular_jqxgrid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../node_modules/jqwidgets-scripts/jqwidgets-ts/angular_jqxgrid */ "./node_modules/jqwidgets-scripts/jqwidgets-ts/angular_jqxgrid.ts");




let JqxGridModule = class JqxGridModule {
};
JqxGridModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        declarations: [
            _node_modules_jqwidgets_scripts_jqwidgets_ts_angular_jqxgrid__WEBPACK_IMPORTED_MODULE_3__["jqxGridComponent"]
        ],
        imports: [
            _angular_common__WEBPACK_IMPORTED_MODULE_2__["CommonModule"]
        ],
        exports: [
            _node_modules_jqwidgets_scripts_jqwidgets_ts_angular_jqxgrid__WEBPACK_IMPORTED_MODULE_3__["jqxGridComponent"]
        ]
    })
], JqxGridModule);



/***/ }),

/***/ "./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-ajustes-carga/grid-ajustes-carga.component.css":
/*!************************************************************************************************************************!*\
  !*** ./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-ajustes-carga/grid-ajustes-carga.component.css ***!
  \************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3NjcmVlbi9yZXBvcnRlLXRyYWNraW5nLWZhY3R1cmFzLW5hY2lvbmFsZXMgLSBDb3B5L2dyaWQtYWp1c3Rlcy1jYXJnYS9ncmlkLWFqdXN0ZXMtY2FyZ2EuY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-ajustes-carga/grid-ajustes-carga.component.ts":
/*!***********************************************************************************************************************!*\
  !*** ./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-ajustes-carga/grid-ajustes-carga.component.ts ***!
  \***********************************************************************************************************************/
/*! exports provided: GridAjustesCargaComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GridAjustesCargaComponent", function() { return GridAjustesCargaComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let GridAjustesCargaComponent = class GridAjustesCargaComponent {
    constructor() {
        this.source = {
            datafields: [
                { name: 'Sku', type: 'string' },
                { name: 'SkuCodigo', type: 'string' },
                { name: 'Cantidad', type: 'number' },
                { name: 'UnidadMedida', type: 'string' },
                { name: 'PrecioFactura', type: 'number' },
                { name: 'PrecioOc', type: 'number' },
                { name: 'Diferencia', type: 'number' }
            ],
            id: "Id",
            datatype: "array"
        };
        this.dataAdapter = new jqx.dataAdapter(this.source);
        this.columns = [
            { text: 'Sku', datafield: 'Sku', cellsalign: 'left', align: 'center', width: '25%' },
            { text: 'Código', datafield: 'SkuCodigo', cellsalign: 'center', align: 'center', width: '13%' },
            { text: 'Cantidad', datafield: 'Cantidad', cellsalign: 'center', align: 'center', filterable: false, width: '10%' },
            { text: 'UM', datafield: 'UnidadDeMedida', cellsalign: 'center', align: 'center', filterable: false, width: '10%' },
            { text: 'Precio Factura', datafield: 'OrdendeCompra', cellsalign: 'center', align: 'center', filterable: false, width: '14%' },
            { text: 'Precio OC', datafield: 'Ajustes', cellsalign: 'center', align: 'center', filterable: false, width: '14%' },
            { text: 'Diferencia Precio', datafield: 'Diferencia', cellsalign: 'center', align: 'center', filterable: false, width: '14%' }
        ];
    }
    ngOnInit() {
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])('myGridAjustesCarga', { static: false })
], GridAjustesCargaComponent.prototype, "myGridAjustesCarga", void 0);
GridAjustesCargaComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-grid-ajustes-carga',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./grid-ajustes-carga.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-ajustes-carga/grid-ajustes-carga.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./grid-ajustes-carga.component.css */ "./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-ajustes-carga/grid-ajustes-carga.component.css")).default]
    })
], GridAjustesCargaComponent);



/***/ }),

/***/ "./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-ajustes-precio/grid-ajustes-precio.component.css":
/*!**************************************************************************************************************************!*\
  !*** ./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-ajustes-precio/grid-ajustes-precio.component.css ***!
  \**************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3NjcmVlbi9yZXBvcnRlLXRyYWNraW5nLWZhY3R1cmFzLW5hY2lvbmFsZXMgLSBDb3B5L2dyaWQtYWp1c3Rlcy1wcmVjaW8vZ3JpZC1hanVzdGVzLXByZWNpby5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-ajustes-precio/grid-ajustes-precio.component.ts":
/*!*************************************************************************************************************************!*\
  !*** ./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-ajustes-precio/grid-ajustes-precio.component.ts ***!
  \*************************************************************************************************************************/
/*! exports provided: GridAjustesPrecioComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GridAjustesPrecioComponent", function() { return GridAjustesPrecioComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let GridAjustesPrecioComponent = class GridAjustesPrecioComponent {
    constructor() {
        this.source = {
            datafields: [
                { name: 'Sku', type: 'string' },
                { name: 'Cantidad', type: 'number' },
                { name: 'UnidadMedida', type: 'string' },
                { name: 'PrecioFactura', type: 'number' },
                { name: 'PrecioOc', type: 'number' },
                { name: 'DiferenciaPrecio', type: 'number' }
            ],
            id: "Sku",
            datatype: "array"
        };
        this.dataAdapter = new jqx.dataAdapter(this.source);
        this.columns = [
            { text: 'Sku', datafield: 'Sku', cellsalign: 'left', align: 'center', width: '30%' },
            { text: 'Cantidad', datafield: 'Cantidad', cellsalign: 'center', align: 'center', filterable: false, width: '10%' },
            { text: 'Unidad Medida', datafield: 'UnidadMedida', cellsalign: 'center', align: 'center', filterable: false, width: '15%' },
            { text: 'Precio Factura', datafield: 'PrecioFactura', cellsalign: 'center', align: 'center', filterable: false, width: '15%' },
            { text: 'Precio OC', datafield: 'PrecioOc', cellsalign: 'center', align: 'center', filterable: false, width: '15%' },
            { text: 'Diferencia Precio', datafield: 'DiferenciaPrecio', cellsalign: 'center', align: 'center', filterable: false, width: '15%' }
        ];
    }
    ngOnInit() {
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])('myGridAjustesPrecio', { static: false })
], GridAjustesPrecioComponent.prototype, "myGridAjustesPrecio", void 0);
GridAjustesPrecioComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-grid-ajustes-precio',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./grid-ajustes-precio.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-ajustes-precio/grid-ajustes-precio.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./grid-ajustes-precio.component.css */ "./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-ajustes-precio/grid-ajustes-precio.component.css")).default]
    })
], GridAjustesPrecioComponent);



/***/ }),

/***/ "./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-codigo-proveedor/grid-codigo-proveedor.component.css":
/*!******************************************************************************************************************************!*\
  !*** ./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-codigo-proveedor/grid-codigo-proveedor.component.css ***!
  \******************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3NjcmVlbi9yZXBvcnRlLXRyYWNraW5nLWZhY3R1cmFzLW5hY2lvbmFsZXMgLSBDb3B5L2dyaWQtY29kaWdvLXByb3ZlZWRvci9ncmlkLWNvZGlnby1wcm92ZWVkb3IuY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-codigo-proveedor/grid-codigo-proveedor.component.ts":
/*!*****************************************************************************************************************************!*\
  !*** ./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-codigo-proveedor/grid-codigo-proveedor.component.ts ***!
  \*****************************************************************************************************************************/
/*! exports provided: GridCodigoProveedorComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GridCodigoProveedorComponent", function() { return GridCodigoProveedorComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let GridCodigoProveedorComponent = class GridCodigoProveedorComponent {
    constructor() {
        this.VerFacturaCodigoProveedor = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
        //Boton para SAP Migo
        this.VerFacturaCellRenderer = (row, columnfield, value, defaulthtml, columnproperties, rowdata) => {
            return '<div class="jqx-grid-cell-middle-align" style="margin-top: 0.18rem;"><img style="cursor: pointer" height="30" width="30" src="../../../../assets/icons/search.png"></div>';
        };
        this.source = {
            datafields: [
                { name: 'NoFactura', type: 'string' },
                { name: 'NotaEntrega', type: 'string' },
                { name: 'IdProveedor', type: 'number' },
                { name: 'Proveedor', type: 'string' },
                { name: 'Estado', type: 'number', map: 'Estado>DisplayName' }
            ],
            id: "IdProveedor",
            datatype: "array"
        };
        this.dataAdapter = new jqx.dataAdapter(this.source);
        this.columns = [
            { text: 'Código proveedor', datafield: 'IdProveedor', cellsalign: 'center', align: 'center', width: '13%' },
            { text: 'Proveedor', datafield: 'Proveedor', cellsalign: 'left', align: 'center', width: '30%' },
            { text: '# Factura', datafield: 'NoFactura', cellsalign: 'left', align: 'center', width: '20%' },
            { text: 'CR', datafield: 'NotaEntrega', cellsalign: 'center', align: 'center', width: '15%' },
            { text: 'Estado', datafield: 'Estado', cellsalign: 'center', align: 'center', width: '14%' },
            { text: "Ver Factura", datafield: "VerFacturaClick", cellsalign: 'center', align: "center", width: '8%', filterable: false, cellsrenderer: this.VerFacturaCellRenderer }
        ];
    }
    ngOnInit() {
    }
    //Boton de eventos
    CellClick(event) {
        let rowData = event.args.row.bounddata;
        let dataField = event.args.datafield;
        if (dataField == GridCodigoProveedorColumns.VerFacturaClick)
            this.VerFacturaClick(rowData);
    }
    VerFacturaClick(rowData) {
        this.VerFacturaCodigoProveedor.emit(rowData);
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])('myGridCodigoProveedor', { static: false })
], GridCodigoProveedorComponent.prototype, "myGridCodigoProveedor", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"])()
], GridCodigoProveedorComponent.prototype, "VerFacturaCodigoProveedor", void 0);
GridCodigoProveedorComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-grid-codigo-proveedor',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./grid-codigo-proveedor.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-codigo-proveedor/grid-codigo-proveedor.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./grid-codigo-proveedor.component.css */ "./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-codigo-proveedor/grid-codigo-proveedor.component.css")).default]
    })
], GridCodigoProveedorComponent);

var GridCodigoProveedorColumns;
(function (GridCodigoProveedorColumns) {
    GridCodigoProveedorColumns["VerFacturaClick"] = "VerFacturaClick";
})(GridCodigoProveedorColumns || (GridCodigoProveedorColumns = {}));


/***/ }),

/***/ "./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-orden-compra/grid-orden-compra.component.css":
/*!**********************************************************************************************************************!*\
  !*** ./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-orden-compra/grid-orden-compra.component.css ***!
  \**********************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3NjcmVlbi9yZXBvcnRlLXRyYWNraW5nLWZhY3R1cmFzLW5hY2lvbmFsZXMgLSBDb3B5L2dyaWQtb3JkZW4tY29tcHJhL2dyaWQtb3JkZW4tY29tcHJhLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-orden-compra/grid-orden-compra.component.ts":
/*!*********************************************************************************************************************!*\
  !*** ./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-orden-compra/grid-orden-compra.component.ts ***!
  \*********************************************************************************************************************/
/*! exports provided: GridOrdenCompraComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GridOrdenCompraComponent", function() { return GridOrdenCompraComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let GridOrdenCompraComponent = class GridOrdenCompraComponent {
    constructor() {
        this.VerFacturaOrdenCompra = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
        //Boton para SAP Migo
        this.VerFacturaCellRenderer = (row, columnfield, value, defaulthtml, columnproperties, rowdata) => {
            return '<div class="jqx-grid-cell-middle-align" style="margin-top: 0.18rem;"><img style="cursor: pointer" height="30" width="30" src="../../../../assets/icons/search.png"></div>';
        };
        this.source = {
            datafields: [
                { name: 'NoFactura', type: 'string' },
                { name: 'NotaEntrega', type: 'string' },
                { name: 'IdProveedor', type: 'number' },
                { name: 'Proveedor', type: 'string' },
                { name: 'Estado', type: 'number', map: 'Estado>DisplayName' }
            ],
            id: "IdProveedor",
            datatype: "array"
        };
        this.dataAdapter = new jqx.dataAdapter(this.source);
        this.columns = [
            { text: 'Código proveedor', datafield: 'IdProveedor', cellsalign: 'center', align: 'center', width: '13%' },
            { text: 'Proveedor', datafield: 'Proveedor', cellsalign: 'left', align: 'center', width: '30%' },
            { text: '# Factura', datafield: 'NoFactura', cellsalign: 'left', align: 'center', width: '20%' },
            { text: 'CR', datafield: 'NotaEntrega', cellsalign: 'center', align: 'center', width: '15%' },
            { text: 'Estado', datafield: 'Estado', cellsalign: 'center', align: 'center', width: '14%' },
            { text: "Ver Factura", datafield: "VerFacturaClick", cellsalign: 'center', align: "center", width: '8%', filterable: false, cellsrenderer: this.VerFacturaCellRenderer }
        ];
    }
    ngOnInit() {
    }
    //Boton de eventos
    CellClick(event) {
        let rowData = event.args.row.bounddata;
        let dataField = event.args.datafield;
        if (dataField == GridOrdenCompraColumns.VerFacturaClick)
            this.VerFacturaClick(rowData);
    }
    VerFacturaClick(rowData) {
        this.VerFacturaOrdenCompra.emit(rowData);
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])('myGridOrdenCompra', { static: false })
], GridOrdenCompraComponent.prototype, "myGridOrdenCompra", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"])()
], GridOrdenCompraComponent.prototype, "VerFacturaOrdenCompra", void 0);
GridOrdenCompraComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-grid-orden-compra',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./grid-orden-compra.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-orden-compra/grid-orden-compra.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./grid-orden-compra.component.css */ "./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-orden-compra/grid-orden-compra.component.css")).default]
    })
], GridOrdenCompraComponent);

var GridOrdenCompraColumns;
(function (GridOrdenCompraColumns) {
    GridOrdenCompraColumns["VerFacturaClick"] = "VerFacturaClick";
})(GridOrdenCompraColumns || (GridOrdenCompraColumns = {}));


/***/ }),

/***/ "./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-tracking-facturas-nacionales/grid-tracking-facturas-nacionales.component.css":
/*!******************************************************************************************************************************************************!*\
  !*** ./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-tracking-facturas-nacionales/grid-tracking-facturas-nacionales.component.css ***!
  \******************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3NjcmVlbi9yZXBvcnRlLXRyYWNraW5nLWZhY3R1cmFzLW5hY2lvbmFsZXMgLSBDb3B5L2dyaWQtdHJhY2tpbmctZmFjdHVyYXMtbmFjaW9uYWxlcy9ncmlkLXRyYWNraW5nLWZhY3R1cmFzLW5hY2lvbmFsZXMuY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-tracking-facturas-nacionales/grid-tracking-facturas-nacionales.component.ts":
/*!*****************************************************************************************************************************************************!*\
  !*** ./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-tracking-facturas-nacionales/grid-tracking-facturas-nacionales.component.ts ***!
  \*****************************************************************************************************************************************************/
/*! exports provided: GridTrackingFacturasNacionalesComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GridTrackingFacturasNacionalesComponent", function() { return GridTrackingFacturasNacionalesComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let GridTrackingFacturasNacionalesComponent = class GridTrackingFacturasNacionalesComponent {
    constructor() {
        this.data = [];
        this.source = {
            datafields: [
                { name: 'Sku', type: 'string' },
                { name: 'SkuCodigo', type: 'string' },
                { name: 'CantidadFacturada', type: 'number' },
                { name: 'CantidadRecibida', type: 'number' },
                { name: 'UnidadDeMedida', type: 'string' },
                { name: 'OrdendeCompra', type: 'string' },
                { name: 'Observacion', type: 'string' },
                { name: 'Ajustes', type: 'number' }
            ],
            id: "Id",
            datatype: "array"
        };
        this.dataAdapter = new jqx.dataAdapter(this.source);
        this.columns = [
            { text: 'Sku', datafield: 'Sku', cellsalign: 'left', align: 'center', width: '23.5%' },
            { text: 'Código', datafield: 'SkuCodigo', cellsalign: 'center', align: 'center', width: '9%' },
            { text: 'Cantidad Facturada', datafield: 'CantidadFacturada', cellsalign: 'center', align: 'center', filterable: false, width: '14%' },
            { text: 'Cantidad Recibida', datafield: 'CantidadRecibida', cellsalign: 'center', align: 'center', filterable: false, width: '13%' },
            { text: 'UM', datafield: 'UnidadDeMedida', cellsalign: 'center', align: 'center', filterable: false, width: '10%' },
            { text: 'OC', datafield: 'OrdendeCompra', cellsalign: 'center', align: 'center', filterable: false, width: '10%' },
            { text: 'Observación', datafield: 'Observacion', cellsalign: 'left', align: 'center', filterable: false, width: '13.5%' },
            { text: 'Ajustes', datafield: 'Ajustes', cellsalign: 'center', align: 'center', filterable: false, width: '7%' }
        ];
    }
    ngOnInit() {
        this.source.localdata = this.data;
        this.dataAdapter.dataBind();
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])('myGridTrackingFacturasNacionales', { static: false })
], GridTrackingFacturasNacionalesComponent.prototype, "myGridTrackingFacturasNacionales", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])('data')
], GridTrackingFacturasNacionalesComponent.prototype, "data", void 0);
GridTrackingFacturasNacionalesComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-grid-tracking-facturas-nacionales',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./grid-tracking-facturas-nacionales.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-tracking-facturas-nacionales/grid-tracking-facturas-nacionales.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./grid-tracking-facturas-nacionales.component.css */ "./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-tracking-facturas-nacionales/grid-tracking-facturas-nacionales.component.css")).default]
    })
], GridTrackingFacturasNacionalesComponent);



/***/ }),

/***/ "./src/app/screen/reporte-tracking-facturas-nacionales - Copy/reporte-tracking-facturas-nacionales.module.ts":
/*!*******************************************************************************************************************!*\
  !*** ./src/app/screen/reporte-tracking-facturas-nacionales - Copy/reporte-tracking-facturas-nacionales.module.ts ***!
  \*******************************************************************************************************************/
/*! exports provided: ReporteTrackingFacturasNacionalesModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReporteTrackingFacturasNacionalesModule", function() { return ReporteTrackingFacturasNacionalesModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _ng_modules_jqx_grid_jqx_grid_module__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../ng-modules/jqx-grid/jqx-grid.module */ "./src/app/ng-modules/jqx-grid/jqx-grid.module.ts");
/* harmony import */ var _reporte_tracking_facturas_nacionales_reporte_tracking_facturas_nacionales_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./reporte-tracking-facturas-nacionales/reporte-tracking-facturas-nacionales.component */ "./src/app/screen/reporte-tracking-facturas-nacionales - Copy/reporte-tracking-facturas-nacionales/reporte-tracking-facturas-nacionales.component.ts");
/* harmony import */ var _grid_tracking_facturas_nacionales_grid_tracking_facturas_nacionales_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./grid-tracking-facturas-nacionales/grid-tracking-facturas-nacionales.component */ "./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-tracking-facturas-nacionales/grid-tracking-facturas-nacionales.component.ts");
/* harmony import */ var _grid_ajustes_precio_grid_ajustes_precio_component__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./grid-ajustes-precio/grid-ajustes-precio.component */ "./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-ajustes-precio/grid-ajustes-precio.component.ts");
/* harmony import */ var _grid_ajustes_carga_grid_ajustes_carga_component__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./grid-ajustes-carga/grid-ajustes-carga.component */ "./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-ajustes-carga/grid-ajustes-carga.component.ts");
/* harmony import */ var _grid_orden_compra_grid_orden_compra_component__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./grid-orden-compra/grid-orden-compra.component */ "./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-orden-compra/grid-orden-compra.component.ts");
/* harmony import */ var _grid_codigo_proveedor_grid_codigo_proveedor_component__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./grid-codigo-proveedor/grid-codigo-proveedor.component */ "./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-codigo-proveedor/grid-codigo-proveedor.component.ts");
/* harmony import */ var _ng_select_ng_select__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @ng-select/ng-select */ "./node_modules/@ng-select/ng-select/fesm2015/ng-select-ng-select.js");
/* harmony import */ var modal__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! modal */ "./dist-library/modal/fesm2015/modal.js");
/* harmony import */ var fileshare__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! fileshare */ "./dist-library/fileshare/fesm2015/fileshare.js");















const routes = [
    { path: 'home/Index', component: _reporte_tracking_facturas_nacionales_reporte_tracking_facturas_nacionales_component__WEBPACK_IMPORTED_MODULE_6__["ReporteTrackingFacturasNacionalesComponent"] }
];
const routing = _angular_router__WEBPACK_IMPORTED_MODULE_4__["RouterModule"].forChild(routes);
let ReporteTrackingFacturasNacionalesModule = class ReporteTrackingFacturasNacionalesModule {
};
ReporteTrackingFacturasNacionalesModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        declarations: [_reporte_tracking_facturas_nacionales_reporte_tracking_facturas_nacionales_component__WEBPACK_IMPORTED_MODULE_6__["ReporteTrackingFacturasNacionalesComponent"], _grid_tracking_facturas_nacionales_grid_tracking_facturas_nacionales_component__WEBPACK_IMPORTED_MODULE_7__["GridTrackingFacturasNacionalesComponent"], _grid_ajustes_precio_grid_ajustes_precio_component__WEBPACK_IMPORTED_MODULE_8__["GridAjustesPrecioComponent"], _grid_ajustes_carga_grid_ajustes_carga_component__WEBPACK_IMPORTED_MODULE_9__["GridAjustesCargaComponent"], _grid_orden_compra_grid_orden_compra_component__WEBPACK_IMPORTED_MODULE_10__["GridOrdenCompraComponent"], _grid_codigo_proveedor_grid_codigo_proveedor_component__WEBPACK_IMPORTED_MODULE_11__["GridCodigoProveedorComponent"]],
        imports: [
            _angular_common__WEBPACK_IMPORTED_MODULE_2__["CommonModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormsModule"],
            _angular_router__WEBPACK_IMPORTED_MODULE_4__["RouterModule"],
            routing,
            _ng_modules_jqx_grid_jqx_grid_module__WEBPACK_IMPORTED_MODULE_5__["JqxGridModule"],
            _ng_select_ng_select__WEBPACK_IMPORTED_MODULE_12__["NgSelectModule"],
            modal__WEBPACK_IMPORTED_MODULE_13__["ModalModule"],
            fileshare__WEBPACK_IMPORTED_MODULE_14__["FileshareModule"].forRoot({ Https: true })
        ]
    })
], ReporteTrackingFacturasNacionalesModule);



/***/ }),

/***/ "./src/app/screen/reporte-tracking-facturas-nacionales - Copy/reporte-tracking-facturas-nacionales/reporte-tracking-facturas-nacionales.component.css":
/*!************************************************************************************************************************************************************!*\
  !*** ./src/app/screen/reporte-tracking-facturas-nacionales - Copy/reporte-tracking-facturas-nacionales/reporte-tracking-facturas-nacionales.component.css ***!
  \************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".divContainerSellos {\r\n  border: outset;\r\n  height: 20rem;  \r\n}\r\n\r\n.divContainerGrid {\r\n  border: outset;\r\n  height: 30rem;\r\n}\r\n\r\n.divContainerGridAjustes {\r\n  border: outset;\r\n  height: 22rem;\r\n}\r\n\r\n.divsGrid {\r\n  border-bottom: 1.5px solid #ccc !important;\r\n  height: 4rem;\r\n}\r\n\r\n.sombra {\r\n  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2), 0 6px 20px 0 rgba(0,0,0,0.19);\r\n}\r\n\r\n/*stripped class*/\r\n\r\n.container{\r\n  width: 100%\r\n}\r\n\r\n.progressbar {}\r\n\r\n.progressbar li {\r\n  list-style-type: none;\r\n  float: left;\r\n  width: 20%;\r\n  position: relative;\r\n  text-align: center;\r\n}\r\n\r\n.progressbar li:before {\r\n  content: \"\";\r\n  width: 30px;\r\n  height: 30px;\r\n  line-height: 38px;\r\n  border: 3px solid #ddd;\r\n  display: block;\r\n  text-align: center;\r\n  margin: 0 auto -10px auto;\r\n  border-radius: 50%;\r\n  background-color: white;\r\n}\r\n\r\n.progressbar li:after {\r\n  content: \"\";\r\n  position: absolute;\r\n  width: 100%;\r\n  height: 2.5px;\r\n  background-color: #ddd;\r\n  top: 17px;\r\n  left: -50%;\r\n  z-index: -1;\r\n}\r\n\r\n.progressbar li:first-child:after {\r\n  content: none;\r\n}\r\n\r\n/*green*/\r\n\r\n.progressbar li.active {\r\n  color: black;\r\n}\r\n\r\n.progressbar li.active:before {\r\n    content: url('check.00889344468a35549a5b.png');\r\n    border-color: #2ECC71;\r\n    background-color: #2ECC71;\r\n  }\r\n\r\n.progressbar li.active + li:after {\r\n    background-color: #2ECC71;\r\n  }\r\n\r\n/*Yellow*/\r\n\r\n.progressbar li.activeyellow {\r\n  color: black;\r\n}\r\n\r\n.progressbar li.activeyellow:before {\r\n    content: url('close.1818218c027640d7a76c.png');\r\n    border-color: #FFBF00;\r\n    background-color: #FFBF00;\r\n  }\r\n\r\n.progressbar li.activeyellow + li:after {\r\n    background-color: #FFBF00;\r\n  }\r\n\r\n/*template Internacional*/\r\n\r\n.progressbarInternacional {}\r\n\r\n.progressbarInternacional li {\r\n    list-style-type: none;\r\n    float: left;\r\n    width: 16.6%;\r\n    position: relative;\r\n    text-align: center;\r\n  }\r\n\r\n.progressbarInternacional li:before {\r\n      content: \"\";\r\n      width: 30px;\r\n      height: 30px;\r\n      line-height: 38px;\r\n      border: 3px solid #ddd;\r\n      display: block;\r\n      text-align: center;\r\n      margin: 0 auto -10px auto;\r\n      border-radius: 50%;\r\n      background-color: white;\r\n    }\r\n\r\n.progressbarInternacional li:after {\r\n      content: \"\";\r\n      position: absolute;\r\n      width: 100%;\r\n      height: 2.5px;\r\n      background-color: #ddd;\r\n      top: 17px;\r\n      left: -50%;\r\n      z-index: -1;\r\n    }\r\n\r\n.progressbarInternacional li:first-child:after {\r\n      content: none;\r\n    }\r\n\r\n/*green*/\r\n\r\n.progressbarInternacional li.active {\r\n      color: black;\r\n    }\r\n\r\n.progressbarInternacional li.active:before {\r\n        content: url('check.00889344468a35549a5b.png');\r\n        border-color: #2ECC71;\r\n        background-color: #2ECC71;\r\n      }\r\n\r\n.progressbarInternacional li.active + li:after {\r\n        background-color: #2ECC71;\r\n      }\r\n\r\n/*Yellow*/\r\n\r\n.progressbarInternacional li.activeyellow {\r\n      color: black;\r\n    }\r\n\r\n.progressbarInternacional li.activeyellow:before {\r\n        content: url('close.1818218c027640d7a76c.png');\r\n        border-color: #FFBF00;\r\n        background-color: #FFBF00;\r\n      }\r\n\r\n.progressbarInternacional li.activeyellow + li:after {\r\n        background-color: #FFBF00;\r\n      }\r\n\r\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/screen/reporte-tracking-facturas-nacionales - Copy/reporte-tracking-facturas-nacionales/reporte-tracking-facturas-nacionales.component.ts":
/*!***********************************************************************************************************************************************************!*\
  !*** ./src/app/screen/reporte-tracking-facturas-nacionales - Copy/reporte-tracking-facturas-nacionales/reporte-tracking-facturas-nacionales.component.ts ***!
  \***********************************************************************************************************************************************************/
/*! exports provided: ReporteTrackingFacturasNacionalesComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReporteTrackingFacturasNacionalesComponent", function() { return ReporteTrackingFacturasNacionalesComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _grid_tracking_facturas_nacionales_grid_tracking_facturas_nacionales_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../grid-tracking-facturas-nacionales/grid-tracking-facturas-nacionales.component */ "./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-tracking-facturas-nacionales/grid-tracking-facturas-nacionales.component.ts");
/* harmony import */ var _grid_ajustes_precio_grid_ajustes_precio_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../grid-ajustes-precio/grid-ajustes-precio.component */ "./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-ajustes-precio/grid-ajustes-precio.component.ts");
/* harmony import */ var _grid_ajustes_carga_grid_ajustes_carga_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../grid-ajustes-carga/grid-ajustes-carga.component */ "./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-ajustes-carga/grid-ajustes-carga.component.ts");
/* harmony import */ var _grid_orden_compra_grid_orden_compra_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../grid-orden-compra/grid-orden-compra.component */ "./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-orden-compra/grid-orden-compra.component.ts");
/* harmony import */ var _grid_codigo_proveedor_grid_codigo_proveedor_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../grid-codigo-proveedor/grid-codigo-proveedor.component */ "./src/app/screen/reporte-tracking-facturas-nacionales - Copy/grid-codigo-proveedor/grid-codigo-proveedor.component.ts");
/* harmony import */ var linq__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! linq */ "./node_modules/linq/linq.js");
/* harmony import */ var linq__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(linq__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../../environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var vesta__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! vesta */ "./dist-library/vesta/fesm2015/vesta.js");
/* harmony import */ var fileshare__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! fileshare */ "./dist-library/fileshare/fesm2015/fileshare.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! moment */ "./node_modules/moment/moment.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_11__);












__webpack_require__(/*! ../../../extensions/moment-extends */ "./src/app/extensions/moment-extends.ts");
let ReporteTrackingFacturasNacionalesComponent = class ReporteTrackingFacturasNacionalesComponent {
    constructor(DialogService, CallHttp) {
        this.DialogService = DialogService;
        this.CallHttp = CallHttp;
        //Variable ngIf
        this.MostrarTemplateNacional = false;
        this.MostrarTemplateInternacional = false;
        this.Grid = [];
        this.AjustesArray = [];
        this.AjustesPrecio = [];
        this.AjustesCarga = [];
        this.DataSkuFactura = [];
    }
    ngOnInit() {
        this.Factura = null;
    }
    BuscarFactura() {
        if (this.Factura == null || this.Factura == "") {
            this.DialogService.NotificacionWarning("Digite una factura");
        }
        else {
            this.CallHttp.httpGet(_environments_environment__WEBPACK_IMPORTED_MODULE_8__["environment"].webServices.WareHouse + "ReporteTrackingFactura/ReporteTrackingFacturaByNumeroFactura?NumeroFactura=" + this.Factura, null, { withCredentials: false })
                .subscribe(response => {
                let obj = {
                    Id: response.Id,
                    Factura: response.Factura,
                    Bultos: response.Bultos,
                    ImporteTotal: response.ImporteTotal,
                    BultosDisponible: response.BultosDisponible,
                    TipoISV: response.TipoISV,
                    CAI: response.CAI,
                    DUA: response.DUA,
                    FechaDUA: response.FechaDUA,
                    FacturaId: response.FacturaId,
                    TiempoDeCredito: response.TiempoDeCredito,
                    Kilos: response.Kilos,
                    Miro: response.Miro,
                    FechaMiro: response.FechaMiro,
                    FechaMigo: response.FechaMigo,
                    FechaFactura: response.FechaFactura,
                    Vencimiento: response.Vencimiento,
                    Migo: response.Migo,
                    NotaEntrega: response.NotaEntrega,
                    Enabled: response.Enabled,
                    IsSoftDeleted: response.IsSoftDeleted,
                    CantidadAjuste: response.CantidadAjuste,
                    TotalFactura: response.TotalFactura,
                    TotalDiferencia: response.TotalDiferencia,
                    CodigoProveedor: response.CodigoProveedor,
                    TipoFacturaNacionalInternacional: response.TipoFacturaNacionalInternacional,
                    Recepcion: {
                        Id: response.Recepcion.Id,
                        PersonaClienteId: response.Recepcion.PersonaClienteId,
                        GestionId: response.Recepcion.GestionId,
                        PersonaId: response.Recepcion.PersonaId,
                        PersonaNombre: response.Recepcion.PersonaNombre,
                        NumeroGestion: response.Recepcion.NumeroGestion,
                        NumeroPedido: response.Recepcion.NumeroPedido,
                        PaisOrigenId: response.Recepcion.PaisOrigenId,
                        SitioOrigenId: response.Recepcion.SitioOrigenId,
                        SitioOrigenNombre: response.Recepcion.SitioOrigenNombre,
                        SitioDestinoId: response.Recepcion.SitioDestinoId,
                        SitioDestinoNombre: response.Recepcion.SitioDestinoNombre,
                        FechaRecepcion: response.Recepcion.FechaRecepcion,
                        Entrada: response.Recepcion.Entrada,
                        Salida: response.Recepcion.Salida,
                        EntradaFin: response.Recepcion.EntradaFin,
                        SalidaFin: response.Recepcion.SalidaFin,
                        Eta: response.Recepcion.Eta,
                        SitioEntradaSalida: response.Recepcion.SitioEntradaSalida,
                        SitioEntradaFinSalidaFin: response.Recepcion.SitioEntradaFinSalidaFin,
                    },
                    Collectiones: response.Collectiones,
                    Settingse: response.Settingse
                };
                this.Entrada = obj.Recepcion.Entrada == null ? '-----' : moment__WEBPACK_IMPORTED_MODULE_11__(obj.Recepcion.Entrada).FormatoFechaCSharp();
                this.Salida = obj.Recepcion.Salida == null ? '-----' : moment__WEBPACK_IMPORTED_MODULE_11__(obj.Recepcion.Salida).FormatoFechaCSharp();
                this.Aduana = '2021-12-30 21:45:00' + "**";
                this.EntradaFin = obj.Recepcion.EntradaFin == null ? '-----' : moment__WEBPACK_IMPORTED_MODULE_11__(obj.Recepcion.EntradaFin).FormatoFechaCSharp();
                this.SalidaFin = obj.Recepcion.SalidaFin == null ? '-----' : moment__WEBPACK_IMPORTED_MODULE_11__(obj.Recepcion.SalidaFin).FormatoFechaCSharp();
                this.Recepcion = moment__WEBPACK_IMPORTED_MODULE_11__(obj.Recepcion.FechaRecepcion).FormatoFechaCSharp();
                this.FechaMiro = moment__WEBPACK_IMPORTED_MODULE_11__(obj.FechaMiro).FormatoFechaCSharp();
                this.FechaMigo = moment__WEBPACK_IMPORTED_MODULE_11__(obj.FechaMigo).FormatoFechaCSharp();
                /////----------/////
                //this.Grid = [];
                this.DataSkuFactura = [];
                this.AjustesArray = [];
                this.AjustesPrecio = [];
                this.AjustesCarga = [];
                this.FacturaResponse = obj.Factura;
                this.FechaFactura = moment__WEBPACK_IMPORTED_MODULE_11__(obj.FechaFactura).FormatoFechaCSharp();
                this.Vencimiento = moment__WEBPACK_IMPORTED_MODULE_11__(obj.Vencimiento).FormatoFechaCSharp();
                this.PersonaNombre = obj.Recepcion.PersonaNombre;
                this.DiasCredito = obj.TiempoDeCredito;
                this.CodigoProveedor = obj.CodigoProveedor;
                this.Gestion = obj.Recepcion.NumeroGestion;
                this.CR = obj.NotaEntrega;
                this.Ajustes = obj.CantidadAjuste;
                this.TotalFacturada = obj.TotalFactura.toFixed(2);
                this.TotalDiferencia = Number(obj.TotalDiferencia).toFixed(2);
                //this.Grid = Enumerable.from(obj.Collectiones).select(s => {
                //  return {
                //    Sku: s.Sku,
                //    SkuCodigo: s.SkuCodigo,
                //    CantidadFacturada: s.Cantidad,
                //    CantidadRecibida: s.CantidadRecibida,
                //    UnidadDeMedida: s.UnidadMedida,
                //    OrdendeCompra: s.OC,
                //    Ajustes: obj.Collectiones.length == 0 ? 0 : obj.Collectiones.length,
                //    DiasCredito: obj.TiempoDeCredito
                //  }
                //}).orderBy(o => o.SkuCodigo).toArray();
                this.AjustesArray = obj.Settingse;
                this.DataSkuFactura = linq__WEBPACK_IMPORTED_MODULE_7__["from"](obj.Collectiones).select(s => {
                    return {
                        Sku: s.Sku,
                        SkuCodigo: s.SkuCodigo,
                        CantidadFacturada: s.Cantidad,
                        CantidadRecibida: s.CantidadRecibida,
                        UnidadDeMedida: s.UnidadMedida,
                        OrdendeCompra: s.OC,
                        Observacion: s.Observacion,
                        Ajustes: s.Settingse.length == 0 ? 0 : s.Settingse.length
                    };
                }).orderBy(o => o.SkuCodigo).toArray();
                if (obj.TipoFacturaNacionalInternacional == false) {
                    this.MostrarTemplateNacional = true;
                }
                else {
                    this.MostrarTemplateInternacional = true;
                }
            }, error => {
                this.DialogService.NotificacionAlert(error);
            });
        }
    }
    VerAjustes() {
        if (this.AjustesArray.length == 0) {
            this.DialogService.NotificacionWarning("No hay ajustes disponibles para mostrar");
        }
        else {
            for (var i = 0; i < this.AjustesArray.length; i++) {
                if (this.AjustesArray[i].Reclamo.Value == 7) {
                    let objPrecio = {
                        Sku: this.AjustesArray[i].Sku,
                        Cantidad: this.AjustesArray[i].Cantidad,
                        UnidadMedida: this.AjustesArray[i].UnidadMedida == null ? '---' : this.AjustesArray[i].UnidadMedida,
                        PrecioOc: this.AjustesArray[i].PrecioOc,
                        PrecioFactura: this.AjustesArray[i].PrecioFactura,
                        DiferenciaPrecio: this.AjustesArray[i].Diferencia,
                    };
                    this.AjustesPrecio.push(objPrecio);
                }
                else {
                    let objCarga = {
                        Sku: this.AjustesArray[i].Sku,
                        Cantidad: this.AjustesArray[i].Cantidad,
                        UnidadMedida: this.AjustesArray[i].UnidadMedida,
                        PrecioOc: this.AjustesArray[i].PrecioOc,
                        PrecioFactura: this.AjustesArray[i].PrecioFactura,
                        Reclamo: this.AjustesArray[i].Reclamo.DisplayName,
                        Observacion: this.AjustesArray[i].Observacion,
                    };
                    this.AjustesCarga.push(objCarga);
                }
            }
            this.myGridAjustesPrecio.source.localdata = linq__WEBPACK_IMPORTED_MODULE_7__["from"](this.AjustesPrecio).orderBy(o => o.Sku).toArray();
            this.myGridAjustesPrecio.dataAdapter.dataBind();
            this.myGridAjustesCarga.source.localdata = linq__WEBPACK_IMPORTED_MODULE_7__["from"](this.AjustesCarga).orderBy(o => o.Sku).toArray();
            this.myGridAjustesCarga.dataAdapter.dataBind();
            this.modalAjustePrecioCarga.showModal();
        }
    }
    AbrirModalOrdenDeComprar() {
        this.OrdendeCompraInput = null;
        this.myGridOrdenCompra.myGridOrdenCompra.clear();
        this.modalOrdenCompra.showModal();
    }
    ClearInput() {
        this.Factura = null;
        this.MostrarTemplateNacional = false;
        this.MostrarTemplateInternacional = false;
    }
    ClearInputOC() {
        this.OrdendeCompraInput = null;
        this.myGridOrdenCompra.myGridOrdenCompra.clear();
    }
    AbrirModalCodigoproveedor() {
        this.CodigoProveedorInput = null;
        this.myGridCodigoProveedor.myGridCodigoProveedor.clear();
        this.modalCodigoProveedor.showModal();
    }
    ClearInputCP() {
        this.CodigoProveedorInput = null;
        this.myGridCodigoProveedor.myGridCodigoProveedor.clear();
    }
    VerDocumentos() {
        let List = [];
        List.push(this.Factura);
        this.fileShare.DownloadListDocumento(List);
    }
    BuscarOC() {
        this.CallHttp.httpGet(_environments_environment__WEBPACK_IMPORTED_MODULE_8__["environment"].webServices.WareHouse + "ReporteTrackingFactura/FacturaByOc?OC=" + this.OrdendeCompraInput, null, { withCredentials: false })
            .subscribe(response => {
            this.myGridOrdenCompra.source.localdata = linq__WEBPACK_IMPORTED_MODULE_7__["from"](response).orderBy(o => o.IdProveedor).toArray();
            this.myGridOrdenCompra.dataAdapter.dataBind();
        }, error => {
            this.DialogService.NotificacionAlert(error);
        });
    }
    BuscarCP() {
        this.CallHttp.httpGet(_environments_environment__WEBPACK_IMPORTED_MODULE_8__["environment"].webServices.WareHouse + "ReporteTrackingFactura/FacturaByIdProveedor?IdProveedor=" + this.CodigoProveedorInput, null, { withCredentials: false })
            .subscribe(response => {
            this.myGridCodigoProveedor.source.localdata = linq__WEBPACK_IMPORTED_MODULE_7__["from"](response).orderBy(o => o.IdProveedor).toArray();
            this.myGridCodigoProveedor.dataAdapter.dataBind();
        }, error => {
            this.DialogService.NotificacionAlert(error);
        });
    }
    VerFacturaOrdenCompraYCodigoProveedor(event) {
        //this.modalOrdenCompra.closeModal();
        this.CallHttp.httpGet(_environments_environment__WEBPACK_IMPORTED_MODULE_8__["environment"].webServices.WareHouse + "ReporteTrackingFactura/ReporteTrackingFacturaByNumeroFactura?NumeroFactura=" + event.NoFactura, null, { withCredentials: false })
            .subscribe(response => {
            let obj = {
                Id: response.Id,
                Factura: response.Factura,
                Bultos: response.Bultos,
                ImporteTotal: response.ImporteTotal,
                BultosDisponible: response.BultosDisponible,
                TipoISV: response.TipoISV,
                CAI: response.CAI,
                DUA: response.DUA,
                FechaDUA: response.FechaDUA,
                FacturaId: response.FacturaId,
                TiempoDeCredito: response.TiempoDeCredito,
                Kilos: response.Kilos,
                Miro: response.Miro,
                FechaMiro: response.FechaMiro,
                FechaMigo: response.FechaMigo,
                FechaFactura: response.FechaFactura,
                Vencimiento: response.Vencimiento,
                Migo: response.Migo,
                NotaEntrega: response.NotaEntrega,
                Enabled: response.Enabled,
                IsSoftDeleted: response.IsSoftDeleted,
                CantidadAjuste: response.CantidadAjuste,
                TotalFactura: response.TotalFactura,
                TotalDiferencia: response.TotalDiferencia,
                CodigoProveedor: response.CodigoProveedor,
                TipoFacturaNacionalInternacional: response.TipoFacturaNacionalInternacional,
                Recepcion: {
                    Id: response.Recepcion.Id,
                    PersonaClienteId: response.Recepcion.PersonaClienteId,
                    GestionId: response.Recepcion.GestionId,
                    PersonaId: response.Recepcion.PersonaId,
                    PersonaNombre: response.Recepcion.PersonaNombre,
                    NumeroGestion: response.Recepcion.NumeroGestion,
                    NumeroPedido: response.Recepcion.NumeroPedido,
                    PaisOrigenId: response.Recepcion.PaisOrigenId,
                    SitioOrigenId: response.Recepcion.SitioOrigenId,
                    SitioOrigenNombre: response.Recepcion.SitioOrigenNombre,
                    SitioDestinoId: response.Recepcion.SitioDestinoId,
                    SitioDestinoNombre: response.Recepcion.SitioDestinoNombre,
                    FechaRecepcion: response.Recepcion.FechaRecepcion,
                    Entrada: response.Recepcion.Entrada,
                    Salida: response.Recepcion.Salida,
                    EntradaFin: response.Recepcion.EntradaFin,
                    SalidaFin: response.Recepcion.SalidaFin,
                    Eta: response.Recepcion.Eta,
                    SitioEntradaSalida: response.Recepcion.SitioEntradaSalida,
                    SitioEntradaFinSalidaFin: response.Recepcion.SitioEntradaFinSalidaFin,
                },
                Collectiones: response.Collectiones,
                Settingse: response.Settingse
            };
            this.Entrada = obj.Recepcion.Entrada == null ? '-----' : moment__WEBPACK_IMPORTED_MODULE_11__(obj.Recepcion.Entrada).FormatoFechaCSharp();
            this.Salida = obj.Recepcion.Salida == null ? '-----' : moment__WEBPACK_IMPORTED_MODULE_11__(obj.Recepcion.Salida).FormatoFechaCSharp();
            this.Aduana = '2021-12-30 21:45:00';
            this.EntradaFin = obj.Recepcion.EntradaFin == null ? '-----' : moment__WEBPACK_IMPORTED_MODULE_11__(obj.Recepcion.EntradaFin).FormatoFechaCSharp();
            this.SalidaFin = obj.Recepcion.SalidaFin == null ? '-----' : moment__WEBPACK_IMPORTED_MODULE_11__(obj.Recepcion.SalidaFin).FormatoFechaCSharp();
            this.Recepcion = moment__WEBPACK_IMPORTED_MODULE_11__(obj.Recepcion.FechaRecepcion).format();
            this.FechaMiro = moment__WEBPACK_IMPORTED_MODULE_11__(obj.FechaMiro).FormatoFechaCSharp();
            this.FechaMigo = moment__WEBPACK_IMPORTED_MODULE_11__(obj.FechaMigo).FormatoFechaCSharp();
            /////----------/////
            //this.Grid = [];
            this.DataSkuFactura = [];
            this.AjustesArray = [];
            this.AjustesPrecio = [];
            this.AjustesCarga = [];
            this.FacturaResponse = obj.Factura;
            this.FechaFactura = moment__WEBPACK_IMPORTED_MODULE_11__(obj.FechaFactura).FormatoFechaCSharp();
            this.Vencimiento = moment__WEBPACK_IMPORTED_MODULE_11__(obj.Vencimiento).FormatoFechaCSharp();
            this.PersonaNombre = obj.Recepcion.PersonaNombre;
            this.DiasCredito = obj.TiempoDeCredito;
            this.CodigoProveedor = obj.CodigoProveedor;
            this.Gestion = obj.Recepcion.NumeroGestion;
            this.CR = obj.NotaEntrega;
            this.Ajustes = obj.CantidadAjuste;
            this.TotalFacturada = obj.TotalFactura.toFixed(2);
            this.TotalDiferencia = Number(obj.TotalDiferencia).toFixed(2);
            //this.Grid = Enumerable.from(obj.Collectiones).select(s => {
            //  return {
            //    Sku: s.Sku,
            //    SkuCodigo: s.SkuCodigo,
            //    CantidadFacturada: s.Cantidad,
            //    CantidadRecibida: s.CantidadRecibida,
            //    UnidadDeMedida: s.UnidadMedida,
            //    OrdendeCompra: s.OC,
            //    Ajustes: obj.Collectiones.length == 0 ? 0 : obj.Collectiones.length,
            //    DiasCredito: obj.TiempoDeCredito
            //  }
            //}).orderBy(o => o.SkuCodigo).toArray();
            this.AjustesArray = obj.Settingse;
            this.DataSkuFactura = linq__WEBPACK_IMPORTED_MODULE_7__["from"](obj.Collectiones).select(s => {
                return {
                    Sku: s.Sku,
                    SkuCodigo: s.SkuCodigo,
                    CantidadFacturada: s.Cantidad,
                    CantidadRecibida: s.CantidadRecibida,
                    UnidadDeMedida: s.UnidadMedida,
                    OrdendeCompra: s.OC,
                    Observacion: s.Observacion,
                    Ajustes: s.Settingse.length == 0 ? 0 : s.Settingse.length
                };
            }).orderBy(o => o.SkuCodigo).toArray();
            if (obj.TipoFacturaNacionalInternacional == false) {
                this.MostrarTemplateNacional = true;
            }
            else {
                this.MostrarTemplateInternacional = true;
            }
        }, error => {
            this.DialogService.NotificacionAlert(error);
        });
    }
};
ReporteTrackingFacturasNacionalesComponent.ctorParameters = () => [
    { type: vesta__WEBPACK_IMPORTED_MODULE_9__["DialogService"] },
    { type: vesta__WEBPACK_IMPORTED_MODULE_9__["CallHttp"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])(_grid_tracking_facturas_nacionales_grid_tracking_facturas_nacionales_component__WEBPACK_IMPORTED_MODULE_2__["GridTrackingFacturasNacionalesComponent"], { static: false })
], ReporteTrackingFacturasNacionalesComponent.prototype, "myGridTrackingFacturasNacionales", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])(_grid_ajustes_precio_grid_ajustes_precio_component__WEBPACK_IMPORTED_MODULE_3__["GridAjustesPrecioComponent"], { static: false })
], ReporteTrackingFacturasNacionalesComponent.prototype, "myGridAjustesPrecio", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])(_grid_ajustes_carga_grid_ajustes_carga_component__WEBPACK_IMPORTED_MODULE_4__["GridAjustesCargaComponent"], { static: false })
], ReporteTrackingFacturasNacionalesComponent.prototype, "myGridAjustesCarga", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])(_grid_orden_compra_grid_orden_compra_component__WEBPACK_IMPORTED_MODULE_5__["GridOrdenCompraComponent"], { static: false })
], ReporteTrackingFacturasNacionalesComponent.prototype, "myGridOrdenCompra", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])(_grid_codigo_proveedor_grid_codigo_proveedor_component__WEBPACK_IMPORTED_MODULE_6__["GridCodigoProveedorComponent"], { static: false })
], ReporteTrackingFacturasNacionalesComponent.prototype, "myGridCodigoProveedor", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])("modalAjustePrecioCarga", { static: false })
], ReporteTrackingFacturasNacionalesComponent.prototype, "modalAjustePrecioCarga", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])("modalOrdenCompra", { static: false })
], ReporteTrackingFacturasNacionalesComponent.prototype, "modalOrdenCompra", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])("modalCodigoProveedor", { static: false })
], ReporteTrackingFacturasNacionalesComponent.prototype, "modalCodigoProveedor", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])(fileshare__WEBPACK_IMPORTED_MODULE_10__["FileshareComponent"], { static: false })
], ReporteTrackingFacturasNacionalesComponent.prototype, "fileShare", void 0);
ReporteTrackingFacturasNacionalesComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-reporte-tracking-facturas-nacionales',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./reporte-tracking-facturas-nacionales.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/screen/reporte-tracking-facturas-nacionales - Copy/reporte-tracking-facturas-nacionales/reporte-tracking-facturas-nacionales.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./reporte-tracking-facturas-nacionales.component.css */ "./src/app/screen/reporte-tracking-facturas-nacionales - Copy/reporte-tracking-facturas-nacionales/reporte-tracking-facturas-nacionales.component.css")).default]
    })
], ReporteTrackingFacturasNacionalesComponent);



/***/ }),

/***/ "./src/app/screen/requisas/pipes/filtro-pallets-en-sitio/filtro-pallets-en-sitio.pipe.ts":
/*!***********************************************************************************************!*\
  !*** ./src/app/screen/requisas/pipes/filtro-pallets-en-sitio/filtro-pallets-en-sitio.pipe.ts ***!
  \***********************************************************************************************/
/*! exports provided: FiltroPalletsEnSitioPipe */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FiltroPalletsEnSitioPipe", function() { return FiltroPalletsEnSitioPipe; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let FiltroPalletsEnSitioPipe = class FiltroPalletsEnSitioPipe {
    transform(snapshotArr, searchValue) {
        if (!snapshotArr) {
            return [];
        }
        if (!searchValue) {
            return snapshotArr;
        }
        if (snapshotArr && searchValue) {
            return snapshotArr.filter(snapshot => {
                return snapshot.Gestion.toLowerCase().includes(searchValue.toLowerCase());
            });
        }
    }
};
FiltroPalletsEnSitioPipe = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Pipe"])({
        name: 'filtroPalletsEnSitio'
    })
], FiltroPalletsEnSitioPipe);



/***/ }),

/***/ "./src/app/screen/requisas/pipes/filtro-proximas-salidas/filtro-proximas-salidas.pipe.ts":
/*!***********************************************************************************************!*\
  !*** ./src/app/screen/requisas/pipes/filtro-proximas-salidas/filtro-proximas-salidas.pipe.ts ***!
  \***********************************************************************************************/
/*! exports provided: FiltroProximasSalidasPipe */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FiltroProximasSalidasPipe", function() { return FiltroProximasSalidasPipe; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let FiltroProximasSalidasPipe = class FiltroProximasSalidasPipe {
    transform(snapshotArr, searchValue) {
        if (!snapshotArr) {
            return [];
        }
        if (!searchValue) {
            return snapshotArr;
        }
        if (snapshotArr && searchValue) {
            return snapshotArr.filter(snapshot => {
                return snapshot.NumeroPallet.toLowerCase().includes(searchValue.toLowerCase());
            });
        }
    }
};
FiltroProximasSalidasPipe = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Pipe"])({
        name: 'filtroProximasSalidas'
    })
], FiltroProximasSalidasPipe);



/***/ }),

/***/ "./src/app/screen/requisas/requisas.module.ts":
/*!****************************************************!*\
  !*** ./src/app/screen/requisas/requisas.module.ts ***!
  \****************************************************/
/*! exports provided: RequisasModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RequisasModule", function() { return RequisasModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _requisas_requisas_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./requisas/requisas.component */ "./src/app/screen/requisas/requisas/requisas.component.ts");
/* harmony import */ var _pipes_filtro_proximas_salidas_filtro_proximas_salidas_pipe__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./pipes/filtro-proximas-salidas/filtro-proximas-salidas.pipe */ "./src/app/screen/requisas/pipes/filtro-proximas-salidas/filtro-proximas-salidas.pipe.ts");
/* harmony import */ var _pipes_filtro_pallets_en_sitio_filtro_pallets_en_sitio_pipe__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./pipes/filtro-pallets-en-sitio/filtro-pallets-en-sitio.pipe */ "./src/app/screen/requisas/pipes/filtro-pallets-en-sitio/filtro-pallets-en-sitio.pipe.ts");








const routes = [
    { path: 'home/Index', component: _requisas_requisas_component__WEBPACK_IMPORTED_MODULE_5__["RequisasComponent"] }
];
const routing = _angular_router__WEBPACK_IMPORTED_MODULE_4__["RouterModule"].forChild(routes);
let RequisasModule = class RequisasModule {
};
RequisasModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        declarations: [_requisas_requisas_component__WEBPACK_IMPORTED_MODULE_5__["RequisasComponent"], _pipes_filtro_proximas_salidas_filtro_proximas_salidas_pipe__WEBPACK_IMPORTED_MODULE_6__["FiltroProximasSalidasPipe"], _pipes_filtro_pallets_en_sitio_filtro_pallets_en_sitio_pipe__WEBPACK_IMPORTED_MODULE_7__["FiltroPalletsEnSitioPipe"]],
        imports: [
            _angular_common__WEBPACK_IMPORTED_MODULE_2__["CommonModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormsModule"],
            _angular_router__WEBPACK_IMPORTED_MODULE_4__["RouterModule"],
            routing
        ]
    })
], RequisasModule);



/***/ }),

/***/ "./src/app/screen/requisas/requisas/requisas.component.css":
/*!*****************************************************************!*\
  !*** ./src/app/screen/requisas/requisas/requisas.component.css ***!
  \*****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".cardView {\r\n  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);\r\n  transition: 0.4s;\r\n  width: 100%;\r\n  height: 10rem;\r\n  padding: 1rem;\r\n  border-radius: 5px;\r\n  border-left: 8px solid #0094ff\r\n}\r\n\r\n  .cardView:hover {\r\n    box-shadow: 0 4px 8px 0 rgba(0,0,0,1);\r\n    transform: perspective(1px) translateZ(0);\r\n    transition-property: box-shadow, transform\r\n  }\r\n\r\n  .fuente{\r\n    font-size: 14px;\r\n  }\r\n\r\n  .mydiv {\r\n  float: left;\r\n  width: 100px;\r\n  height: 35px;\r\n  margin: 10px;\r\n  padding: 10px;\r\n  border: 1px solid black;\r\n}\r\n\r\n  .EnableUpDown {\r\n  opacity: 0.5;\r\n}\r\n\r\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvc2NyZWVuL3JlcXVpc2FzL3JlcXVpc2FzL3JlcXVpc2FzLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSx1Q0FBdUM7RUFDdkMsZ0JBQWdCO0VBQ2hCLFdBQVc7RUFDWCxhQUFhO0VBQ2IsYUFBYTtFQUNiLGtCQUFrQjtFQUNsQjtBQUNGOztFQUVFO0lBQ0UscUNBQXFDO0lBQ3JDLHlDQUF5QztJQUN6QztFQUNGOztFQUVBO0lBQ0UsZUFBZTtFQUNqQjs7RUFFRjtFQUNFLFdBQVc7RUFDWCxZQUFZO0VBQ1osWUFBWTtFQUNaLFlBQVk7RUFDWixhQUFhO0VBQ2IsdUJBQXVCO0FBQ3pCOztFQUVBO0VBQ0UsWUFBWTtBQUNkIiwiZmlsZSI6InNyYy9hcHAvc2NyZWVuL3JlcXVpc2FzL3JlcXVpc2FzL3JlcXVpc2FzLmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuY2FyZFZpZXcge1xyXG4gIGJveC1zaGFkb3c6IDAgNHB4IDhweCAwIHJnYmEoMCwwLDAsMC4yKTtcclxuICB0cmFuc2l0aW9uOiAwLjRzO1xyXG4gIHdpZHRoOiAxMDAlO1xyXG4gIGhlaWdodDogMTByZW07XHJcbiAgcGFkZGluZzogMXJlbTtcclxuICBib3JkZXItcmFkaXVzOiA1cHg7XHJcbiAgYm9yZGVyLWxlZnQ6IDhweCBzb2xpZCAjMDA5NGZmXHJcbn1cclxuXHJcbiAgLmNhcmRWaWV3OmhvdmVyIHtcclxuICAgIGJveC1zaGFkb3c6IDAgNHB4IDhweCAwIHJnYmEoMCwwLDAsMSk7XHJcbiAgICB0cmFuc2Zvcm06IHBlcnNwZWN0aXZlKDFweCkgdHJhbnNsYXRlWigwKTtcclxuICAgIHRyYW5zaXRpb24tcHJvcGVydHk6IGJveC1zaGFkb3csIHRyYW5zZm9ybVxyXG4gIH1cclxuXHJcbiAgLmZ1ZW50ZXtcclxuICAgIGZvbnQtc2l6ZTogMTRweDtcclxuICB9XHJcblxyXG4ubXlkaXYge1xyXG4gIGZsb2F0OiBsZWZ0O1xyXG4gIHdpZHRoOiAxMDBweDtcclxuICBoZWlnaHQ6IDM1cHg7XHJcbiAgbWFyZ2luOiAxMHB4O1xyXG4gIHBhZGRpbmc6IDEwcHg7XHJcbiAgYm9yZGVyOiAxcHggc29saWQgYmxhY2s7XHJcbn1cclxuXHJcbi5FbmFibGVVcERvd24ge1xyXG4gIG9wYWNpdHk6IDAuNTtcclxufVxyXG4iXX0= */");

/***/ }),

/***/ "./src/app/screen/requisas/requisas/requisas.component.ts":
/*!****************************************************************!*\
  !*** ./src/app/screen/requisas/requisas/requisas.component.ts ***!
  \****************************************************************/
/*! exports provided: RequisasComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RequisasComponent", function() { return RequisasComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var vesta__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! vesta */ "./dist-library/vesta/fesm2015/vesta.js");
/* harmony import */ var vesta_authentication__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! vesta-authentication */ "./dist-library/vesta-authentication/fesm2015/vesta-authentication.js");
/* harmony import */ var linq__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! linq */ "./node_modules/linq/linq.js");
/* harmony import */ var linq__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(linq__WEBPACK_IMPORTED_MODULE_5__);






let RequisasComponent = class RequisasComponent {
    constructor(CallHttp, DialogService, user) {
        this.CallHttp = CallHttp;
        this.DialogService = DialogService;
        this.user = user;
        //Cargar validacion de usuario
        this.userPriorizadoYNoPriorizado = false;
        //Cargar tarjetas de proximas salidas
        this.DataProximasSalidas = [];
        this.totalProximasSalidas = null;
        this.totalKilosProximasSalidas = null;
        //Buscar proximas salidas
        this.searchProximaSalida = null;
        //Buscar pallets en sitio
        this.searchPalletEnSitio = null;
        //change habilitar/deshablitar cambio de turno de pallet
        this.enabledDisabledImg = false;
    }
    ngOnInit() {
        this.CargarValidacionUsuario();
        // this.ListaPalletsEnSitio;
    }
    //ListaPalletsEnSitio: PalletsEnSitio[] = [
    //  {
    //    Id: 5,
    //    Gestion: "PD-SPS-0001-04-11",
    //    Descripcion: "Papa Fresca Para Procesar",
    //    PosicionSalida: 5,
    //    Factura: "23-4560",
    //    Peso: "50000.00",
    //    RealizadoPor: "Lisa"
    //  },
    //  {
    //    Id: 6,
    //    Gestion: "PD-SPS-0001-04-12",
    //    Descripcion: "Papa Fresca Para Procesar",
    //    PosicionSalida: 6,
    //    Factura: "23-4561",
    //    Peso: "25300.00",
    //    RealizadoPor: "Lisa"
    //  },
    //  {
    //    Id: 7,
    //    Gestion: "PD-SPS-0001-04-13",
    //    Descripcion: "Papa Fresca Para Procesar",
    //    PosicionSalida: 7,
    //    Factura: "23-4562",
    //    Peso: "14200.00",
    //    RealizadoPor: "Lisa"
    //  }
    //]
    //Capitalizar palabras
    CapitalizarPalabras(texto) {
        const re = /(^|[^A-Za-zÁÉÍÓÚÜÑáéíóúüñ])(?:([a-záéíóúüñ])|([A-ZÁÉÍÓÚÜÑ]))|([A-ZÁÉÍÓÚÜÑ]+)/gu;
        return texto.replace(re, (m, caracterPrevio, minuscInicial, mayuscInicial, mayuscIntermedias) => {
            const locale = ['es', 'gl', 'ca', 'pt', 'en'];
            if (mayuscIntermedias)
                return mayuscIntermedias.toLocaleLowerCase(locale);
            return caracterPrevio
                + (minuscInicial ? minuscInicial.toLocaleUpperCase(locale) : mayuscInicial);
        });
    }
    CargarValidacionUsuario() {
        let IdUsuario = this.user.Id;
        this.CallHttp.httpGet(_environments_environment__WEBPACK_IMPORTED_MODULE_2__["environment"].webServices.WareHouse + 'Relations/PermisoByUsiario?UsuarioId=' + IdUsuario, null)
            .subscribe(response => {
            this.userPriorizadoYNoPriorizado = response.PriorizarTurnoSalida;
            this.CargarProximasSalidas();
        }, error => {
            this.DialogService.NotificacionAlert(error);
        });
    }
    CargarProximasSalidas() {
        let obj = {
            //SitioId: '1748a4a1-9d27-4785-9ff8-223fcf1bbeaa'
            SitioId: '2c7f282b-9bcb-4fd0-9a1d-22afe07cc0da'
        };
        this.CallHttp.httpPost(_environments_environment__WEBPACK_IMPORTED_MODULE_2__["environment"].webServices.WareHouse + 'Pallet/PalletBySitioId', obj)
            .subscribe(response => {
            if (response.length != 0) {
                this.DataProximasSalidas = linq__WEBPACK_IMPORTED_MODULE_5__["from"](response).where(w => w.IsSoftDeleted == false).select(s => {
                    return {
                        Id: s.Id,
                        NumeroPallet: s.NumeroPallet,
                        Sku: this.CapitalizarPalabras(s.Collectiones[0].Sku),
                        TurnoDeSalida: s.TurnoDeSalida,
                        NuevaPosicionSalida: s.TurnoDeSalida,
                        Factura: s.Collectiones[0].Factura,
                        Kilos: s.Kilos == null ? "N/D" : s.Kilos.toLocaleString('en'),
                        Variedad: s.Variedad == null ? "N/D" : s.Variedad,
                        Contenedor: s.Contenedor == null ? "N/D" : s.Contenedor,
                        Migo: s.Collectiones[0].Migo == null ? "N/D" : s.Collectiones[0].Migo,
                        KilosTotales: linq__WEBPACK_IMPORTED_MODULE_5__["from"](s.Kilos).sum()
                    };
                }).orderBy(o => o.TurnoDeSalida).toArray();
                this.totalProximasSalidas = this.DataProximasSalidas.length;
                this.totalKilosProximasSalidas = linq__WEBPACK_IMPORTED_MODULE_5__["from"](response).select(s => s.Kilos).sum().toLocaleString('en');
            }
        }, error => {
            this.DialogService.NotificacionAlert(error);
        });
    }
    searchProximasSalidas(name) {
        this.searchProximaSalida = name;
    }
    searchPalletsEnSitio(name) {
        this.searchPalletEnSitio = name;
    }
    //confirmarCambiosTurnos: boolean = false;
    ChangeEnabledDisabled() {
        if (this.DataProximasSalidas.length == 0) {
            this.DialogService.NotificacionWarning("No tiene salidas disponibles");
        }
        else {
            this.enabledDisabledImg = this.enabledDisabledImg == false ? true : false;
            if (this.enabledDisabledImg == false) {
                let cambioTurnoArray = [];
                cambioTurnoArray = linq__WEBPACK_IMPORTED_MODULE_5__["from"](this.DataProximasSalidas).select(s => {
                    return {
                        PalletId: s.Id,
                        Pallet: s.NumeroPallet,
                        TurnoDeSalida: s.TurnoDeSalida
                    };
                }).orderBy(o => o.TurnoDeSalida).toArray();
                console.log(cambioTurnoArray);
                let obj = {
                    CambioTurnoSalida: cambioTurnoArray
                };
                this.CallHttp.httpPost(_environments_environment__WEBPACK_IMPORTED_MODULE_2__["environment"].webServices.WareHouse + 'Pallet/AsignarNewTurnoSalida', obj)
                    .subscribe(response => {
                    if (response.Id.length != 0) {
                        this.CargarProximasSalidas();
                        this.DialogService.NotificacionSucess("Cambios de turno realizados con éxito");
                    }
                    else {
                        this.DialogService.NotificacionWarning(String(response.Id));
                    }
                }, error => {
                    this.DialogService.NotificacionAlert(error);
                });
            }
            else {
                this.DialogService.NotificacionSucess("Habilitado para modificar");
            }
        }
    }
    SubirTarjeta(id) {
        if (this.enabledDisabledImg == true) {
            let indice = this.DataProximasSalidas.findIndex(tab => tab.Id === id);
            // Si no se encuentra el elemento, devolver null
            if (indice === -1) {
                console.log("Indice no encontrado");
                return null;
            }
            else {
                let valorActual = null;
                let valorAnterior = null;
                //let valorSiguiente: TarjetaProximasSalidas = null
                [valorActual] = this.DataProximasSalidas.filter(f => f.Id == id);
                let turnoActual = valorActual.TurnoDeSalida;
                // Si hay un elemento anterior, devolver su CityId
                valorAnterior = indice > 0 ? this.DataProximasSalidas[indice - 1] : null;
                let turnoAnterior = valorAnterior.TurnoDeSalida;
                // Si no hay anterior pero hay un siguiente, devolver el siguiente
                //valorSiguiente = indice === 0 && this.DataProximasSalidas.length > 1 ? this.DataProximasSalidas[1] : null;
                if (valorAnterior != null) {
                    for (var i = 0; i < this.DataProximasSalidas.length; i++) {
                        if (this.DataProximasSalidas[i].Id == valorActual.Id) {
                            this.DataProximasSalidas[i].TurnoDeSalida = turnoAnterior;
                        }
                        if (this.DataProximasSalidas[i].Id == valorAnterior.Id) {
                            this.DataProximasSalidas[i].TurnoDeSalida = turnoActual;
                        }
                    }
                    this.DataProximasSalidas = linq__WEBPACK_IMPORTED_MODULE_5__["from"](this.DataProximasSalidas).orderBy(o => o.TurnoDeSalida).toArray();
                }
            }
        }
        else {
            console.log("habilite la opcion");
            //alert("habilite la opcion")
        }
    }
    BajarTarjeta(id) {
        if (this.enabledDisabledImg == true) {
            let indice = this.DataProximasSalidas.findIndex(tab => tab.Id === id);
            // Si no se encuentra el elemento, devolver null
            if (indice === -1) {
                console.log("Indice no encontrado");
                return null;
            }
            else {
                let valorActual = null;
                //let valorAnterior: TarjetaProximasSalidas = null;
                let valorSiguiente = null;
                [valorActual] = this.DataProximasSalidas.filter(f => f.Id == id);
                let turnoActual = valorActual.TurnoDeSalida;
                // Si hay un elemento anterior, devolver su CityId
                //valorAnterior = indice > 0 ? this.DataProximasSalidas[indice - 1] : null;
                //let turnoAnterior: number = valorAnterior.TurnoDeSalida;
                // Si no hay anterior pero hay un siguiente, devolver el siguiente
                valorSiguiente = (indice >= 0 && this.DataProximasSalidas.length > 1) ? this.DataProximasSalidas[indice + 1] : null;
                let turnoSiguiente = valorSiguiente.TurnoDeSalida;
                if (valorSiguiente != null) {
                    for (var i = 0; i < this.DataProximasSalidas.length; i++) {
                        if (this.DataProximasSalidas[i].Id == valorActual.Id) {
                            this.DataProximasSalidas[i].TurnoDeSalida = turnoSiguiente;
                        }
                        if (this.DataProximasSalidas[i].Id == valorSiguiente.Id) {
                            this.DataProximasSalidas[i].TurnoDeSalida = turnoActual;
                        }
                    }
                    this.DataProximasSalidas = linq__WEBPACK_IMPORTED_MODULE_5__["from"](this.DataProximasSalidas).orderBy(o => o.TurnoDeSalida).toArray();
                }
            }
        }
        //else {
        //  console.log("habilite la opcion");
        //}  
    }
    onSearchChange(id, searchValue) {
        let idLista = id;
        let value = searchValue;
        let [tarjetaProximaSalida] = this.DataProximasSalidas.filter(f => f.Id == idLista);
        tarjetaProximaSalida.NuevaPosicionSalida = value;
    }
    ReordenarProximasSalidas() {
        //let posiciones: Array<number> = [];
        //posiciones = Enumerable.from(this.DataProximasSalidas).select(s => s.NuevaPosicionSalida).toArray();
        //let posicion: number;
        //posicion = posiciones[0];
        //let validar: boolean = false;
        //for (var i = 0; i < posiciones.length; i++) {
        //  if (i == posicion) {
        //    this.DialogService.NotificacionWarning("Posición " + i + " duplicada");
        //    validar = true;
        //    break;
        //  } else {
        //    validar = false;
        //  }
        //}
        //if (validar == true) {
        //  alert("Incorrecto")
        //} else {
        //  alert("Correcto")
        //}
    }
};
RequisasComponent.ctorParameters = () => [
    { type: vesta__WEBPACK_IMPORTED_MODULE_3__["CallHttp"] },
    { type: vesta__WEBPACK_IMPORTED_MODULE_3__["DialogService"] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [vesta_authentication__WEBPACK_IMPORTED_MODULE_4__["USER_AUTH"],] }] }
];
RequisasComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-requisas',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./requisas.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/screen/requisas/requisas/requisas.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./requisas.component.css */ "./src/app/screen/requisas/requisas/requisas.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__param"](2, Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"])(vesta_authentication__WEBPACK_IMPORTED_MODULE_4__["USER_AUTH"]))
], RequisasComponent);



/***/ }),

/***/ "./src/environments/environment.ts":
/*!*****************************************!*\
  !*** ./src/environments/environment.ts ***!
  \*****************************************/
/*! exports provided: environment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "environment", function() { return environment; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

const environment = {
    production: false,
    authentication: { ClienteId: 'WAREHOUSEJS', SistemaId: 'd5375da8-0e2d-4dfb-8b01-199ac729ac77', Stage: true },
    fileshare: { CodigoSistema: 4 },
    firebase: {
        apiKey: "AIzaSyD0ktZx94hGtbHi7dw2N2H9mEAQPO6Txr0",
        databaseURL: "https://notificacionpushdev.firebaseio.com",
        messagingSenderId: "514261864933",
        projectId: "notificacionpushdev",
        appId: "1:514261864933:web:c1cc117677e037bf0b5f0c",
        PublicVapidKey: "BHVFl0D2ZFpy7pRHfYDN1Sa1yMzn1P8cxZiEZ94CUwBIMC2aKK3TPzD5vgNzp8W4POU1x_UcE0jxIiKYEZzC1pg",
        SistemaId: 'd5375da8-0e2d-4dfb-8b01-199ac729ac77'
    },
    webServices: {
        //URL Prod
        //WareHouse: 'https://warehouseapivesta-stg.azurewebsites.net/api/'
        //URL stage
        WareHouse: 'https://stgvestawarhouapi.azurewebsites.net/api/'
        //URL escenarios
        //WareHouse: 'https://scewarehouseapi.vestadev-accelerate.com/api/'
    },
    web: {
        Remisiones: 'https://controldedocumentos-stage.azurewebsites.net/remisiones/',
        //ModeloLogistico: 'https://modelologisticoderedope.vesta-accelerate.com/guiagestion/GestionUnica?codigoGestion='
        ModeloLogistico: 'https://modelologisticoderedwebapi-stage.azurewebsites.net/guiagestion/GestionUnica?codigoGestion='
    }
};


/***/ }),

/***/ "./src/main.ts":
/*!*********************!*\
  !*** ./src/main.ts ***!
  \*********************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/platform-browser-dynamic */ "./node_modules/@angular/platform-browser-dynamic/fesm2015/platform-browser-dynamic.js");
/* harmony import */ var _app_app_module__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./app/app.module */ "./src/app/app.module.ts");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./environments/environment */ "./src/environments/environment.ts");





if (_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].production) {
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["enableProdMode"])();
}
Object(_angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__["platformBrowserDynamic"])().bootstrapModule(_app_app_module__WEBPACK_IMPORTED_MODULE_3__["AppModule"])
    .catch(err => console.error(err));


/***/ }),

/***/ 0:
/*!***************************!*\
  !*** multi ./src/main.ts ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! C:\Users\kevin Morales\Visual Studio\WareHouse\ClientApp\src\main.ts */"./src/main.ts");


/***/ })

},[[0,"runtime","vendor"]]]);
//# sourceMappingURL=main-es2015.fc44e2724ab931814ae9.js.map